/**
 * Generated Resource Hooks
 *
 * Auto-generated from OpenAPI spec.
 * DO NOT EDIT - Run `npm run codegen:client` to regenerate.
 */

import {
  customQueryKey,
  listQueryKey,
  useListQuery,
  useResourceCustomMutation,
  useResourceCustomQuery,
  type CustomMutationOptions,
  type CustomQueryBuilder,
  type ListQueryParams,
} from "./hooks";

import type {
  CheckInFieldVisitBody,
  CheckInFieldVisitParams,
  CheckInFieldVisitResponse,
  CheckOutFieldVisitBody,
  CheckOutFieldVisitParams,
  CheckOutFieldVisitResponse,
  CreateAccountsAllBody,
  CreateAccountsAllResponse,
  CreateAccountsCreateCustomerBody,
  CreateAccountsCreateCustomerResponse,
  CreateAccountsRequestDeletionResponse,
  CreateAccountsTrackingsByAccountIdBody,
  CreateAccountsTrackingsByAccountIdParams,
  CreateAccountsTrackingsByAccountIdResponse,
  CreateAnalyticsMemberActivationActivationBody,
  CreateAnalyticsMemberActivationActivationResponse,
  CreateAuthActivateBody,
  CreateAuthActivateResponse,
  CreateAuthChangeEmailBody,
  CreateAuthChangeEmailResponse,
  CreateAuthChangeEmailVerifyBody,
  CreateAuthChangeEmailVerifyResponse,
  CreateAuthChangePasswordBody,
  CreateAuthChangePasswordResponse,
  CreateAuthCreateSessionTokenBody,
  CreateAuthCreateSessionTokenResponse,
  CreateAuthGetSignInTokenBody,
  CreateAuthGetSignInTokenResponse,
  CreateAuthImpersonateBody,
  CreateAuthImpersonateResponse,
  CreateAuthPublicVerifyPhoneNumberBody,
  CreateAuthPublicVerifyPhoneNumberResponse,
  CreateAuthResolveUserTokenBody,
  CreateAuthResolveUserTokenResponse,
  CreateAuthScopedTokenBody,
  CreateAuthScopedTokenResponse,
  CreateBillingOrderPaymentMethodsSetDefaultByPaymentMethodIdBody,
  CreateBillingOrderPaymentMethodsSetDefaultByPaymentMethodIdParams,
  CreateBillingOrderPaymentMethodsSetDefaultByPaymentMethodIdResponse,
  CreateBillingPaymentMethodsDetachByPaymentMethodIdParams,
  CreateBillingPaymentMethodsDetachByPaymentMethodIdResponse,
  CreateBillingPaymentMethodsSetDefaultByPaymentMethodIdBody,
  CreateBillingPaymentMethodsSetDefaultByPaymentMethodIdParams,
  CreateBillingPaymentMethodsSetDefaultByPaymentMethodIdResponse,
  CreateBillingPaymentMethodsSetupIntentResponse,
  CreateBillingSubscriptionPaymentMethodsSetDefaultByPaymentMethodIdBody,
  CreateBillingSubscriptionPaymentMethodsSetDefaultByPaymentMethodIdParams,
  CreateBillingSubscriptionPaymentMethodsSetDefaultByPaymentMethodIdResponse,
  CreateCampaignsAllBody,
  CreateCampaignsAllResponse,
  CreateCampaignsPushByCampaignIdBody,
  CreateCampaignsPushByCampaignIdParams,
  CreateCampaignsPushByCampaignIdResponse,
  CreateCatalogNewGroupsAllBody,
  CreateCatalogNewGroupsAllResponse,
  CreateCatalogNewItemsAllBody,
  CreateCatalogNewItemsAllResponse,
  CreateCatalogNewItemsRelationsByCatalogItemIdBody,
  CreateCatalogNewItemsRelationsByCatalogItemIdParams,
  CreateCatalogNewItemsRelationsByCatalogItemIdResponse,
  CreateCatalogNewMarketRatesAllBody,
  CreateCatalogNewMarketRatesAllResponse,
  CreateChannelsArchiveByCidParams,
  CreateChannelsArchiveByCidResponse,
  CreateChannelsMarkUnreadByCidParams,
  CreateChannelsMarkUnreadByCidResponse,
  CreateChannelsMessagesByCidBody,
  CreateChannelsMessagesByCidParams,
  CreateChannelsMessagesByCidResponse,
  CreateChannelsMessagesPinByCidByMessageIdParams,
  CreateChannelsMessagesPinByCidByMessageIdResponse,
  CreateChannelsMessagesReactionsByCidByMessageIdBody,
  CreateChannelsMessagesReactionsByCidByMessageIdParams,
  CreateChannelsMessagesReactionsByCidByMessageIdResponse,
  CreateChannelsReadByCidBody,
  CreateChannelsReadByCidParams,
  CreateChannelsReadByCidResponse,
  CreateChannelsSupportBody,
  CreateChannelsSupportResponse,
  CreateChannelsTypingByCidBody,
  CreateChannelsTypingByCidParams,
  CreateChannelsTypingByCidResponse,
  CreateCheckoutLinksAllBody,
  CreateCheckoutLinksAllResponse,
  CreateCheckoutPayBody,
  CreateCheckoutPayResponse,
  CreateExpensesAllBody,
  CreateExpensesAllResponse,
  CreateExpensesScanBody,
  CreateFieldVisitsNotifyMemberByVisitIdBody,
  CreateFieldVisitsNotifyMemberByVisitIdParams,
  CreateFieldVisitsNotifyMemberByVisitIdResponse,
  CreateGoogleConnectCalendarResponse,
  CreateGoogleDisconnectCalendarResponse,
  CreateGoogleOauth2callbackBody,
  CreateGoogleOauth2callbackResponse,
  CreateHomecarePlanOrdersProposalGenerateByOrderIdBody,
  CreateHomecarePlanOrdersProposalGenerateByOrderIdParams,
  CreateHomecarePlanOrdersProposalGenerateByOrderIdResponse,
  CreateInvoicesAllBody,
  CreateInvoicesAllResponse,
  CreateInvoicesChargeByInvoiceIdBody,
  CreateInvoicesChargeByInvoiceIdParams,
  CreateInvoicesChargeByInvoiceIdResponse,
  CreateInvoicesCreditNotesApproveByInvoiceIdByCreditNoteIdBody,
  CreateInvoicesCreditNotesApproveByInvoiceIdByCreditNoteIdParams,
  CreateInvoicesCreditNotesApproveByInvoiceIdByCreditNoteIdResponse,
  CreateInvoicesCreditNotesByInvoiceIdBody,
  CreateInvoicesCreditNotesByInvoiceIdParams,
  CreateInvoicesCreditNotesByInvoiceIdResponse,
  CreateInvoicesCreditNotesPaidOutByInvoiceIdByCreditNoteIdBody,
  CreateInvoicesCreditNotesPaidOutByInvoiceIdByCreditNoteIdParams,
  CreateInvoicesCreditNotesPaidOutByInvoiceIdByCreditNoteIdResponse,
  CreateInvoicesCreditNotesPayOutInsteadByInvoiceIdByCreditNoteIdBody,
  CreateInvoicesCreditNotesPayOutInsteadByInvoiceIdByCreditNoteIdParams,
  CreateInvoicesCreditNotesPayOutInsteadByInvoiceIdByCreditNoteIdResponse,
  CreateInvoicesCreditNotesPreviewByInvoiceIdBody,
  CreateInvoicesCreditNotesPreviewByInvoiceIdParams,
  CreateInvoicesCreditNotesPreviewByInvoiceIdResponse,
  CreateInvoicesCreditNotesRejectByInvoiceIdByCreditNoteIdBody,
  CreateInvoicesCreditNotesRejectByInvoiceIdByCreditNoteIdParams,
  CreateInvoicesCreditNotesRejectByInvoiceIdByCreditNoteIdResponse,
  CreateInvoicesCreditNotesRetryStripeByInvoiceIdByCreditNoteIdParams,
  CreateInvoicesCreditNotesRetryStripeByInvoiceIdByCreditNoteIdResponse,
  CreateInvoicesCreditNotesReviewedByInvoiceIdByCreditNoteIdParams,
  CreateInvoicesCreditNotesReviewedByInvoiceIdByCreditNoteIdResponse,
  CreateInvoicesFillLinesByInvoiceIdBody,
  CreateInvoicesFillLinesByInvoiceIdParams,
  CreateInvoicesFillLinesByInvoiceIdResponse,
  CreateInvoicesIssueByInvoiceIdBody,
  CreateInvoicesIssueByInvoiceIdParams,
  CreateInvoicesIssueByInvoiceIdResponse,
  CreateInvoicesIssuePreviewByInvoiceIdBody,
  CreateInvoicesIssuePreviewByInvoiceIdParams,
  CreateInvoicesIssuePreviewByInvoiceIdResponse,
  CreateInvoicesOutsidePaymentsByInvoiceIdBody,
  CreateInvoicesOutsidePaymentsByInvoiceIdParams,
  CreateInvoicesOutsidePaymentsByInvoiceIdResponse,
  CreateInvoicesOutsidePaymentsCancelByInvoiceIdByPaymentIdBody,
  CreateInvoicesOutsidePaymentsCancelByInvoiceIdByPaymentIdParams,
  CreateInvoicesOutsidePaymentsCancelByInvoiceIdByPaymentIdResponse,
  CreateInvoicesOutsidePaymentsClearByInvoiceIdByPaymentIdParams,
  CreateInvoicesOutsidePaymentsClearByInvoiceIdByPaymentIdResponse,
  CreateInvoicesOutsidePaymentsConfirmByInvoiceIdByPaymentIdParams,
  CreateInvoicesOutsidePaymentsConfirmByInvoiceIdByPaymentIdResponse,
  CreateInvoicesPaymentsReturnedByInvoiceIdByPaymentIdBody,
  CreateInvoicesPaymentsReturnedByInvoiceIdByPaymentIdParams,
  CreateInvoicesPaymentsReturnedByInvoiceIdByPaymentIdResponse,
  CreateInvoicesReissueByInvoiceIdBody,
  CreateInvoicesReissueByInvoiceIdParams,
  CreateInvoicesReissueByInvoiceIdResponse,
  CreateInvoicesSendByInvoiceIdParams,
  CreateInvoicesSendByInvoiceIdResponse,
  CreateInvoicesSyncReferenceByInvoiceIdParams,
  CreateInvoicesSyncReferenceByInvoiceIdResponse,
  CreateInvoicesVoidByInvoiceIdParams,
  CreateInvoicesVoidByInvoiceIdResponse,
  CreateInvoicesWalletApplicationsByInvoiceIdBody,
  CreateInvoicesWalletApplicationsByInvoiceIdParams,
  CreateInvoicesWalletApplicationsByInvoiceIdResponse,
  CreateItemGroupsAllBody,
  CreateItemGroupsCloneBody,
  CreateJoinPresaleSignUpBody,
  CreateJoinPresaleSignUpResponse,
  CreateJoinSignUpBody,
  CreateJoinSignUpResponse,
  CreateJoinWaitlistBody,
  CreateJoinWaitlistResponse,
  CreateLineItemsAllBody,
  CreateLineItemsAllResponse,
  CreateLineItemsCloneBody,
  CreateLineItemsCloneResponse,
  CreateLineItemsFromCatalogBody,
  CreateLineItemsFromCatalogResponse,
  CreateListItemsCreateBody,
  CreateListItemsCreateResponse,
  CreateListItemsLinkBody,
  CreateListItemsLinkResponse,
  CreateListItemsMarkAsDoneByListItemIdBody,
  CreateListItemsMarkAsDoneByListItemIdParams,
  CreateListItemsMarkAsDoneByListItemIdResponse,
  CreateListItemsShareBody,
  CreateListItemsShareResponse,
  CreateListItemsSortBody,
  CreateListItemsSortResponse,
  CreateListItemsUnlinkBody,
  CreateListItemsUnlinkResponse,
  CreateListItemsUpsertBody,
  CreateListItemsUpsertResponse,
  CreateLocationsAllBody,
  CreateLocationsAllResponse,
  CreateMeetGuestTokenByRoomNameBody,
  CreateMeetGuestTokenByRoomNameParams,
  CreateMeetGuestTokenByRoomNameResponse,
  CreateMeetLinkBody,
  CreateMeetLinkResponse,
  CreateMeetTokenByRoomNameParams,
  CreateMeetTokenByRoomNameResponse,
  CreateMembersBillingAlertPayBody,
  CreateMembersBillingAlertPayPreviewBody,
  CreateMembersBillingAlertPayPreviewResponse,
  CreateMembersBillingAlertPayResponse,
  CreateMembersCampaignsDismissByCampaignIdBody,
  CreateMembersCampaignsDismissByCampaignIdParams,
  CreateMembersCampaignsDismissByCampaignIdResponse,
  CreateMembersCampaignsViewByCampaignIdParams,
  CreateMembersCampaignsViewByCampaignIdResponse,
  CreateMembersInvoicesPayByInvoiceIdBody,
  CreateMembersInvoicesPayByInvoiceIdParams,
  CreateMembersInvoicesPayByInvoiceIdResponse,
  CreateMembersInvoicesPayPreviewByInvoiceIdBody,
  CreateMembersInvoicesPayPreviewByInvoiceIdParams,
  CreateMembersInvoicesPayPreviewByInvoiceIdResponse,
  CreateMembersInvoicesPaymentsCompleteByInvoiceIdByPaymentIntentIdParams,
  CreateMembersInvoicesPaymentsCompleteByInvoiceIdByPaymentIntentIdResponse,
  CreateMembersPlacesNestQueryByPlaceIdBody,
  CreateMembersPlacesNestQueryByPlaceIdParams,
  CreateMembersPlacesNestQueryByPlaceIdResponse,
  CreateMembersQuotesAcceptByQuoteIdBody,
  CreateMembersQuotesAcceptByQuoteIdParams,
  CreateMembersQuotesAcceptByQuoteIdResponse,
  CreateMembersQuotesDeclineByQuoteIdBody,
  CreateMembersQuotesDeclineByQuoteIdParams,
  CreateMembersQuotesDeclineByQuoteIdResponse,
  CreateMembersQuotesDepositPaymentsByQuoteIdBody,
  CreateMembersQuotesDepositPaymentsByQuoteIdParams,
  CreateMembersQuotesDepositPaymentsByQuoteIdResponse,
  CreateMembersQuotesDepositPaymentsCompleteByQuoteIdByPaymentIntentIdParams,
  CreateMembersQuotesDepositPaymentsCompleteByQuoteIdByPaymentIntentIdResponse,
  CreateMembersQuotesDepositPaymentsPreviewByQuoteIdBody,
  CreateMembersQuotesDepositPaymentsPreviewByQuoteIdParams,
  CreateMembersQuotesDepositPaymentsPreviewByQuoteIdResponse,
  CreateMembersQuotesViewByQuoteIdParams,
  CreateMembersQuotesViewByQuoteIdResponse,
  CreateMembershipsAllBody,
  CreateMembershipsAllResponse,
  CreateMessagesAutoBody,
  CreateMessagesAutoResponse,
  CreateNotificationsArchiveAllBody,
  CreateNotificationsArchiveAllResponse,
  CreateNotificationsReadAllBody,
  CreateNotificationsReadAllResponse,
  CreateNotificationsSeenAllBody,
  CreateNotificationsSeenAllResponse,
  CreateOnboardingsCompleteByOnboardingIdParams,
  CreateOnboardingsCompleteStepByOnboardingIdBody,
  CreateOnboardingsCompleteStepByOnboardingIdParams,
  CreateOnboardingsNextStepByOnboardingIdBody,
  CreateOnboardingsNextStepByOnboardingIdParams,
  CreateOnboardingsResetBody,
  CreateOnboardingsStartByOnboardingIdParams,
  CreateOnboardingsTriggerOnboardingBody,
  CreateOnboardingsTriggerOnboardingResponse,
  CreateOrderDepositsPaymentsClearByOrderDepositIdByPaymentIdParams,
  CreateOrderDepositsPaymentsClearByOrderDepositIdByPaymentIdResponse,
  CreateOrderDepositsPaymentsConfirmByOrderDepositIdByPaymentIdParams,
  CreateOrderDepositsPaymentsConfirmByOrderDepositIdByPaymentIdResponse,
  CreateOrderDepositsPaymentsReturnedByOrderDepositIdByPaymentIdBody,
  CreateOrderDepositsPaymentsReturnedByOrderDepositIdByPaymentIdParams,
  CreateOrderDepositsPaymentsReturnedByOrderDepositIdByPaymentIdResponse,
  CreateOrderDepositsRefundsApproveByOrderDepositIdByRefundIdParams,
  CreateOrderDepositsRefundsApproveByOrderDepositIdByRefundIdResponse,
  CreateOrderDepositsRefundsByOrderDepositIdBody,
  CreateOrderDepositsRefundsByOrderDepositIdParams,
  CreateOrderDepositsRefundsByOrderDepositIdResponse,
  CreateOrderDepositsRefundsPaidOutByOrderDepositIdByRefundIdBody,
  CreateOrderDepositsRefundsPaidOutByOrderDepositIdByRefundIdParams,
  CreateOrderDepositsRefundsPaidOutByOrderDepositIdByRefundIdResponse,
  CreateOrderDepositsRefundsRejectByOrderDepositIdByRefundIdBody,
  CreateOrderDepositsRefundsRejectByOrderDepositIdByRefundIdParams,
  CreateOrderDepositsRefundsRejectByOrderDepositIdByRefundIdResponse,
  CreateOrderDepositsSettleCancellationByOrderDepositIdBody,
  CreateOrderDepositsSettleCancellationByOrderDepositIdParams,
  CreateOrderDepositsSettleCancellationByOrderDepositIdResponse,
  CreateOrderQuotesAllBody,
  CreateOrderQuotesAllResponse,
  CreateOrderQuotesCancelByQuoteIdBody,
  CreateOrderQuotesCancelByQuoteIdParams,
  CreateOrderQuotesCancelByQuoteIdResponse,
  CreateOrderQuotesCollectDepositByQuoteIdBody,
  CreateOrderQuotesCollectDepositByQuoteIdParams,
  CreateOrderQuotesCollectDepositByQuoteIdResponse,
  CreateOrderQuotesDepositRequestsByQuoteIdBody,
  CreateOrderQuotesDepositRequestsByQuoteIdParams,
  CreateOrderQuotesDepositRequestsByQuoteIdResponse,
  CreateOrderQuotesDiscardEditsByQuoteIdParams,
  CreateOrderQuotesDiscardEditsByQuoteIdResponse,
  CreateOrderQuotesDuplicateByQuoteIdParams,
  CreateOrderQuotesDuplicateByQuoteIdResponse,
  CreateOrderQuotesIssueByQuoteIdBody,
  CreateOrderQuotesIssueByQuoteIdParams,
  CreateOrderQuotesIssueByQuoteIdResponse,
  CreateOrderQuotesLegacyScopeMigrateByOrderIdBody,
  CreateOrderQuotesLegacyScopeMigrateByOrderIdParams,
  CreateOrderQuotesLegacyScopeMigrateByOrderIdResponse,
  CreateOrderQuotesLegacyScopeTransitionByOrderIdBody,
  CreateOrderQuotesLegacyScopeTransitionByOrderIdParams,
  CreateOrderQuotesLegacyScopeTransitionByOrderIdResponse,
  CreateOrderQuotesOptionsByQuoteIdBody,
  CreateOrderQuotesOptionsByQuoteIdParams,
  CreateOrderQuotesOptionsByQuoteIdResponse,
  CreateOrderQuotesOptionsRecommendedByQuoteIdByOptionIdParams,
  CreateOrderQuotesOptionsRecommendedByQuoteIdByOptionIdResponse,
  CreateOrderQuotesReopenByQuoteIdBody,
  CreateOrderQuotesReopenByQuoteIdParams,
  CreateOrderQuotesReopenByQuoteIdResponse,
  CreateOrderQuotesResendByQuoteIdBody,
  CreateOrderQuotesResendByQuoteIdParams,
  CreateOrderQuotesResendByQuoteIdResponse,
  CreateOrderQuotesUpdateByQuoteIdBody,
  CreateOrderQuotesUpdateByQuoteIdParams,
  CreateOrderQuotesUpdateByQuoteIdResponse,
  CreateOrderRequestsAddToOrderByOrderRequestIdBody,
  CreateOrderRequestsAddToOrderByOrderRequestIdParams,
  CreateOrderRequestsAddToOrderByOrderRequestIdResponse,
  CreateOrderRequestsCancelByOrderRequestIdBody,
  CreateOrderRequestsCancelByOrderRequestIdParams,
  CreateOrderRequestsCancelByOrderRequestIdResponse,
  CreateOrderRequestsConvertByOrderRequestIdBody,
  CreateOrderRequestsConvertByOrderRequestIdParams,
  CreateOrderRequestsConvertByOrderRequestIdResponse,
  CreateOrderRequestsCreateOrderRequestBody,
  CreateOrderRequestsCreateOrderRequestResponse,
  CreateOrderRequestsItemsByOrderRequestIdBody,
  CreateOrderRequestsItemsByOrderRequestIdParams,
  CreateOrderRequestsItemsByOrderRequestIdResponse,
  CreateOrderRequestsRestoreByOrderRequestIdParams,
  CreateOrderRequestsRestoreByOrderRequestIdResponse,
  CreateOrdersAddVendorByOrderIdBody,
  CreateOrdersAddVendorByOrderIdParams,
  CreateOrdersAddVendorByOrderIdResponse,
  CreateOrdersAiSummaryRegenerateByOrderIdParams,
  CreateOrdersAiSummaryRegenerateByOrderIdResponse,
  CreateOrdersAttachmentsByOrderIdBody,
  CreateOrdersAttachmentsByOrderIdParams,
  CreateOrdersAttachmentsByOrderIdResponse,
  CreateOrdersBillingReleaseByOrderIdBody,
  CreateOrdersBillingReleaseByOrderIdParams,
  CreateOrdersBillingReleaseByOrderIdResponse,
  CreateOrdersBirdieTipsRegenerateByOrderIdParams,
  CreateOrdersBirdieTipsRegenerateByOrderIdResponse,
  CreateOrdersComposeMessageByOrderIdBody,
  CreateOrdersComposeMessageByOrderIdParams,
  CreateOrdersCreateOrderBody,
  CreateOrdersCreateOrderResponse,
  CreateOrdersFeedbackGoogleReviewCountIncrementResponse,
  CreateOrdersFeedbackRequestByOrderIdParams,
  CreateOrdersFeedbackRequestByOrderIdResponse,
  CreateOrdersFlagByOrderIdParams,
  CreateOrdersFlagByOrderIdResponse,
  CreateOrdersHomecarePlanOrdersByOrderIdParams,
  CreateOrdersHomecarePlanOrdersByOrderIdResponse,
  CreateOrdersMakeVendorPrimaryByOrderIdBody,
  CreateOrdersMakeVendorPrimaryByOrderIdParams,
  CreateOrdersMakeVendorPrimaryByOrderIdResponse,
  CreateOrdersPublishByOrderIdParams,
  CreateOrdersPublishByOrderIdResponse,
  CreateOrdersRelateByOrderIdBody,
  CreateOrdersRelateByOrderIdParams,
  CreateOrdersRelateByOrderIdResponse,
  CreateOrdersRemoveVendorByOrderIdBody,
  CreateOrdersRemoveVendorByOrderIdParams,
  CreateOrdersRemoveVendorByOrderIdResponse,
  CreateOrdersRequestOrderBody,
  CreateOrdersRequestOrderResponse,
  CreateOrdersSubscribersMeByOrderIdParams,
  CreateOrdersSubscribersMeByOrderIdResponse,
  CreateOrdersUnrelateByOrderIdBody,
  CreateOrdersUnrelateByOrderIdParams,
  CreateOrdersUnrelateByOrderIdResponse,
  CreateOrdersVisitInstructionAutofillByOrderIdBody,
  CreateOrdersVisitInstructionAutofillByOrderIdParams,
  CreateOrdersVisitInstructionAutofillByOrderIdResponse,
  CreateOrdersVisitInstructionByOrderIdBody,
  CreateOrdersVisitInstructionByOrderIdParams,
  CreateOrdersVisitInstructionByOrderIdResponse,
  CreatePayLinksPaymentsByTokenBody,
  CreatePayLinksPaymentsByTokenParams,
  CreatePayLinksPaymentsByTokenResponse,
  CreatePayLinksPaymentsCompleteByTokenByPaymentIntentIdParams,
  CreatePayLinksPaymentsCompleteByTokenByPaymentIntentIdResponse,
  CreatePayLinksPreviewByTokenBody,
  CreatePayLinksPreviewByTokenParams,
  CreatePayLinksPreviewByTokenResponse,
  CreatePlacesAddMyPlaceBody,
  CreatePlacesAddMyPlaceResponse,
  CreatePlacesAllBody,
  CreatePlacesAllResponse,
  CreatePlacesAttachmentsByPlaceIdBody,
  CreatePlacesAttachmentsByPlaceIdParams,
  CreatePlacesAttachmentsByPlaceIdResponse,
  CreatePlacesImportEvaluationsBody,
  CreatePlacesImportEvaluationsResponse,
  CreatePlacesNestEvaluationsShareByPlaceIdByEvaluationIdBody,
  CreatePlacesNestEvaluationsShareByPlaceIdByEvaluationIdParams,
  CreatePlacesNestEvaluationsShareByPlaceIdByEvaluationIdResponse,
  CreatePlacesValidateAddressBody,
  CreatePlacesValidateAddressResponse,
  CreatePolicyRolesBody,
  CreatePolicyRolesPermissionsByRoleKeyBody,
  CreatePolicyRolesPermissionsByRoleKeyParams,
  CreatePolicyRolesPermissionsByRoleKeyResponse,
  CreatePolicyRolesResponse,
  CreatePolicyUsersPermissionsByUserIdBody,
  CreatePolicyUsersPermissionsByUserIdParams,
  CreatePolicyUsersPermissionsByUserIdResponse,
  CreatePolicyUsersRolesByUserIdBody,
  CreatePolicyUsersRolesByUserIdParams,
  CreatePolicyUsersRolesByUserIdResponse,
  CreateRealtimeAuthorizeBody,
  CreateRealtimeAuthorizeResponse,
  CreateRevenueMonthsCloseByMonthParams,
  CreateRevenueMonthsCloseByMonthResponse,
  CreateRevenueMonthsReopenByMonthBody,
  CreateRevenueMonthsReopenByMonthParams,
  CreateRevenueMonthsReopenByMonthResponse,
  CreateRevenuesAllBody,
  CreateRevenuesAllResponse,
  CreateScheduleEventBody,
  CreateScheduleEventResponse,
  CreateSmartActionsAiFeedbackBySmartActionIdBody,
  CreateSmartActionsAiFeedbackBySmartActionIdParams,
  CreateSmartActionsAiFeedbackBySmartActionIdResponse,
  CreateSmartActionsAllBody,
  CreateSmartActionsAllResponse,
  CreateSmartActionsAnalyzeBody,
  CreateSmartActionsAnalyzeResponse,
  CreateSmartActionsContactBySmartActionIdBody,
  CreateSmartActionsContactBySmartActionIdParams,
  CreateSmartActionsContactBySmartActionIdResponse,
  CreateSmartActionsDismissBySmartActionIdBody,
  CreateSmartActionsDismissBySmartActionIdParams,
  CreateSmartActionsDismissBySmartActionIdResponse,
  CreateSmartActionsEventsBySmartActionIdBody,
  CreateSmartActionsEventsBySmartActionIdParams,
  CreateSmartActionsEventsBySmartActionIdResponse,
  CreateSmartActionsRefreshBody,
  CreateSmartActionsRefreshResponse,
  CreateSmartActionsReopenBySmartActionIdBody,
  CreateSmartActionsReopenBySmartActionIdParams,
  CreateSmartActionsReopenBySmartActionIdResponse,
  CreateSmartActionsReplanBySmartActionIdBody,
  CreateSmartActionsReplanBySmartActionIdParams,
  CreateSmartActionsReplanBySmartActionIdResponse,
  CreateSmartActionsResolveBySmartActionIdBody,
  CreateSmartActionsResolveBySmartActionIdParams,
  CreateSmartActionsResolveBySmartActionIdResponse,
  CreateSmartActionsRunBody,
  CreateSmartActionsRunResponse,
  CreateSmartActionsSnoozeBySmartActionIdBody,
  CreateSmartActionsSnoozeBySmartActionIdParams,
  CreateSmartActionsSnoozeBySmartActionIdResponse,
  CreateSmartActionsStepsTaskBySmartActionIdByStepIdBody,
  CreateSmartActionsStepsTaskBySmartActionIdByStepIdParams,
  CreateSmartActionsStepsTaskBySmartActionIdByStepIdResponse,
  CreateSpacesCreateBody,
  CreateSpacesCreateResponse,
  CreateSubscriptionsCreateBody,
  CreateSubscriptionsCreatePurchaseIntentBody,
  CreateSubscriptionsCreatePurchaseIntentResponse,
  CreateSubscriptionsCreateResponse,
  CreateTagsAllBody,
  CreateTagsAllResponse,
  CreateTasksAllBody,
  CreateTasksAllResponse,
  CreateTasksCompleteByTaskIdParams,
  CreateTasksCompleteByTaskIdResponse,
  CreateTimeEntriesAllBody,
  CreateTimeEntriesAllResponse,
  CreateUploadsFinalPublicBody,
  CreateUploadsFinalPublicResponse,
  CreateUploadsInitPublicBody,
  CreateUploadsInitPublicResponse,
  CreateUsersAccountByUserIdByAccountIdBody,
  CreateUsersAccountByUserIdByAccountIdParams,
  CreateUsersAccountByUserIdByAccountIdResponse,
  CreateUsersCreateUserBody,
  CreateUsersCreateUserResponse,
  CreateUsersDeviceTokensBody,
  CreateUsersDeviceTokensResponse,
  CreateUsersInvitesCancelByInviteIdParams,
  CreateUsersInvitesCancelByInviteIdResponse,
  CreateUsersInvitesPlacesByPlaceIdBody,
  CreateUsersInvitesPlacesByPlaceIdParams,
  CreateUsersInvitesPlacesByPlaceIdResponse,
  CreateUsersInvitesPlacesGrantBillingByPlaceIdBody,
  CreateUsersInvitesPlacesGrantBillingByPlaceIdParams,
  CreateUsersInvitesPlacesGrantBillingByPlaceIdResponse,
  CreateUsersInvitesPlacesJoinByPlaceIdBody,
  CreateUsersInvitesPlacesJoinByPlaceIdParams,
  CreateUsersInvitesPlacesJoinByPlaceIdResponse,
  CreateUsersInvitesPlacesRemoveByPlaceIdBody,
  CreateUsersInvitesPlacesRemoveByPlaceIdParams,
  CreateUsersInvitesPlacesRemoveByPlaceIdResponse,
  CreateUsersInvitesPlacesRevokeBillingByPlaceIdBody,
  CreateUsersInvitesPlacesRevokeBillingByPlaceIdParams,
  CreateUsersInvitesPlacesRevokeBillingByPlaceIdResponse,
  CreateUsersInvitesResendByInviteIdParams,
  CreateUsersInvitesResendByInviteIdResponse,
  CreateUsersPlacesByUserIdBody,
  CreateUsersPlacesByUserIdParams,
  CreateUsersPlacesByUserIdResponse,
  CreateUsersResendOtpBody,
  CreateUsersResendOtpResponse,
  CreateUsersTechnicianSignUpBody,
  CreateUsersTechnicianSignUpResponse,
  CreateUsersVerifyOtpBody,
  CreateUsersVerifyOtpResponse,
  CreateUsersVerifyPhoneNumberBody,
  CreateUsersVerifyPhoneNumberResponse,
  CreateVendorOnboardingsAllBody,
  CreateVendorOnboardingsAllResponse,
  CreateVendorOnboardingsSubmitBody,
  CreateVendorOnboardingsSubmitResponse,
  CreateVendorsAllBody,
  CreateVendorsAllResponse,
  CreateVendorsDocumentVerificationsByVendorIdByDocumentBody,
  CreateVendorsDocumentVerificationsByVendorIdByDocumentParams,
  CreateVendorsDocumentVerificationsByVendorIdByDocumentResponse,
  CreateViewsSetDefaultBody,
  CreateViewsSetDefaultResponse,
  CreateVisitLinksConfirmByLinkCodeBody,
  CreateVisitLinksConfirmByLinkCodeParams,
  CreateVisitLinksConfirmByLinkCodeResponse,
  CreateVisitLinksOpenByLinkCodeParams,
  CreateVisitLinksOpenByLinkCodeResponse,
  CreateVisitMonitorConfirmationByVisitIdParams,
  CreateVisitMonitorConfirmationByVisitIdResponse,
  CreateVisitMonitorSmsMessagesByVisitIdBody,
  CreateVisitMonitorSmsMessagesByVisitIdParams,
  CreateVisitMonitorSmsMessagesByVisitIdResponse,
  CreateVisitsAllBody,
  CreateVisitsAllResponse,
  CreateVisitsBookBody,
  CreateVisitsBookResponse,
  CreateVisitsCancelByVisitIdParams,
  CreateVisitsCancelByVisitIdResponse,
  CreateVisitsCompleteOnBehalfByVisitIdParams,
  CreateVisitsCompleteOnBehalfByVisitIdResponse,
  CreateVisitsInstructionRefreshByVisitIdBody,
  CreateVisitsInstructionRefreshByVisitIdParams,
  CreateVisitsInstructionRefreshByVisitIdResponse,
  CreateVisitsResetByVisitIdParams,
  CreateVisitsResetByVisitIdResponse,
  CreateVisitsStartOnBehalfByVisitIdParams,
  CreateVisitsStartOnBehalfByVisitIdResponse,
  CreateWalletsAdjustByAccountIdBody,
  CreateWalletsAdjustByAccountIdParams,
  CreateWalletsAdjustByAccountIdResponse,
  CreateWalletsCreditGrantsApproveByAccountIdByGrantIdParams,
  CreateWalletsCreditGrantsApproveByAccountIdByGrantIdResponse,
  CreateWalletsCreditGrantsByAccountIdBody,
  CreateWalletsCreditGrantsByAccountIdParams,
  CreateWalletsCreditGrantsByAccountIdResponse,
  CreateWalletsCreditGrantsRejectByAccountIdByGrantIdBody,
  CreateWalletsCreditGrantsRejectByAccountIdByGrantIdParams,
  CreateWalletsCreditGrantsRejectByAccountIdByGrantIdResponse,
  CreateWalletsCreditRefundsApproveByAccountIdByRefundIdParams,
  CreateWalletsCreditRefundsApproveByAccountIdByRefundIdResponse,
  CreateWalletsCreditRefundsByAccountIdBody,
  CreateWalletsCreditRefundsByAccountIdParams,
  CreateWalletsCreditRefundsByAccountIdResponse,
  CreateWalletsCreditRefundsPaidOutByAccountIdByRefundIdBody,
  CreateWalletsCreditRefundsPaidOutByAccountIdByRefundIdParams,
  CreateWalletsCreditRefundsPaidOutByAccountIdByRefundIdResponse,
  CreateWalletsCreditRefundsRejectByAccountIdByRefundIdBody,
  CreateWalletsCreditRefundsRejectByAccountIdByRefundIdParams,
  CreateWalletsCreditRefundsRejectByAccountIdByRefundIdResponse,
  DeleteAccountsByAccountIdBody,
  DeleteAccountsByAccountIdParams,
  DeleteAccountsByAccountIdResponse,
  DeleteAccountsTrackingsByAccountIdByTrackingIdParams,
  DeleteAccountsTrackingsByAccountIdByTrackingIdResponse,
  DeleteCampaignsByCampaignIdParams,
  DeleteCampaignsByCampaignIdResponse,
  DeleteCatalogNewGroupsByGroupIdParams,
  DeleteCatalogNewGroupsByGroupIdResponse,
  DeleteCatalogNewItemsByCatalogItemIdParams,
  DeleteCatalogNewItemsByCatalogItemIdResponse,
  DeleteCatalogNewItemsRelationsByCatalogItemIdByRelationIdParams,
  DeleteCatalogNewItemsRelationsByCatalogItemIdByRelationIdResponse,
  DeleteCatalogNewMarketRatesByMarketRateIdParams,
  DeleteCatalogNewMarketRatesByMarketRateIdResponse,
  DeleteChannelsArchiveByCidParams,
  DeleteChannelsArchiveByCidResponse,
  DeleteChannelsMessagesByCidByMessageIdParams,
  DeleteChannelsMessagesByCidByMessageIdResponse,
  DeleteChannelsMessagesPinByCidByMessageIdParams,
  DeleteChannelsMessagesPinByCidByMessageIdResponse,
  DeleteChannelsMessagesReactionsByCidByMessageIdByTypeParams,
  DeleteChannelsMessagesReactionsByCidByMessageIdByTypeResponse,
  DeleteCheckoutLinksByCheckoutLinkIdParams,
  DeleteCheckoutLinksByCheckoutLinkIdResponse,
  DeleteExpensesByExpenseIdParams,
  DeleteExpensesByExpenseIdResponse,
  DeleteGoogleCalendarAccountsByGoogleTokenIdParams,
  DeleteGoogleCalendarAccountsByGoogleTokenIdResponse,
  DeleteHomecarePlanProposalsByProposalIdParams,
  DeleteHomecarePlanProposalsByProposalIdResponse,
  DeleteInvoicesByInvoiceIdParams,
  DeleteInvoicesByInvoiceIdResponse,
  DeleteInvoicesCreditNotesByInvoiceIdByCreditNoteIdParams,
  DeleteInvoicesCreditNotesByInvoiceIdByCreditNoteIdResponse,
  DeleteItemGroupsByItemGroupIdParams,
  DeleteLineItemsByLineItemIdParams,
  DeleteLineItemsByLineItemIdResponse,
  DeleteLinksUnlinkUserPlaceBody,
  DeleteLinksUnlinkUserPlaceResponse,
  DeleteListItemsByListItemIdParams,
  DeleteListItemsByListItemIdResponse,
  DeleteLocationsByLocationIdParams,
  DeleteLocationsByLocationIdResponse,
  DeleteMeetLinkParams,
  DeleteMeetLinkResponse,
  DeleteMembershipsByMembershipIdParams,
  DeleteMembershipsByMembershipIdResponse,
  DeleteOrderQuotesByQuoteIdParams,
  DeleteOrderQuotesByQuoteIdResponse,
  DeleteOrderQuotesOptionsByQuoteIdByOptionIdParams,
  DeleteOrderQuotesOptionsByQuoteIdByOptionIdResponse,
  DeleteOrderQuotesOptionsRecommendedByQuoteIdByOptionIdParams,
  DeleteOrderQuotesOptionsRecommendedByQuoteIdByOptionIdResponse,
  DeleteOrderRequestsItemsByOrderRequestIdByItemIdParams,
  DeleteOrderRequestsItemsByOrderRequestIdByItemIdResponse,
  DeleteOrdersAttachmentsByOrderIdBody,
  DeleteOrdersAttachmentsByOrderIdParams,
  DeleteOrdersAttachmentsByOrderIdResponse,
  DeleteOrdersBillingReleaseByOrderIdParams,
  DeleteOrdersBillingReleaseByOrderIdResponse,
  DeleteOrdersByOrderIdParams,
  DeleteOrdersByOrderIdResponse,
  DeleteOrdersDraftByOrderIdParams,
  DeleteOrdersDraftByOrderIdResponse,
  DeleteOrdersFeedbackRequestByOrderIdParams,
  DeleteOrdersFeedbackRequestByOrderIdResponse,
  DeleteOrdersFlagByOrderIdParams,
  DeleteOrdersFlagByOrderIdResponse,
  DeleteOrdersSubscribersMeByOrderIdParams,
  DeleteOrdersSubscribersMeByOrderIdResponse,
  DeletePlacesAttachmentsByPlaceIdBody,
  DeletePlacesAttachmentsByPlaceIdByAttachmentIdParams,
  DeletePlacesAttachmentsByPlaceIdByAttachmentIdResponse,
  DeletePlacesAttachmentsByPlaceIdParams,
  DeletePlacesAttachmentsByPlaceIdResponse,
  DeletePlacesByPlaceIdParams,
  DeletePlacesByPlaceIdResponse,
  DeletePlacesNestFactsByPlaceIdByFactKeyParams,
  DeletePlacesNestFactsByPlaceIdByFactKeyResponse,
  DeletePolicyRolesByRoleKeyParams,
  DeletePolicyRolesByRoleKeyResponse,
  DeletePolicyRolesPermissionsByRoleKeyByPermissionKeyParams,
  DeletePolicyRolesPermissionsByRoleKeyByPermissionKeyResponse,
  DeletePolicyUsersPermissionsByUserIdByPermissionKeyParams,
  DeletePolicyUsersPermissionsByUserIdByPermissionKeyResponse,
  DeletePolicyUsersRolesByUserIdByRoleKeyParams,
  DeletePolicyUsersRolesByUserIdByRoleKeyResponse,
  DeletePurchaseIntentsByPurchaseIntentIdParams,
  DeleteRevenuesByRevenueIdParams,
  DeleteRevenuesByRevenueIdResponse,
  DeleteScheduleEventParams,
  DeleteScheduleEventResponse,
  DeleteSmartActionsBySmartActionIdParams,
  DeleteSmartActionsBySmartActionIdResponse,
  DeleteSpacesBySpaceIdParams,
  DeleteSpacesBySpaceIdResponse,
  DeleteTagsByTagIdParams,
  DeleteTagsByTagIdResponse,
  DeleteTasksByTaskIdParams,
  DeleteTasksByTaskIdResponse,
  DeleteTimeEntriesByTimeEntryIdParams,
  DeleteTimeEntriesByTimeEntryIdResponse,
  DeleteUsersAccountsByUserIdBody,
  DeleteUsersAccountsByUserIdParams,
  DeleteUsersAccountsByUserIdResponse,
  DeleteUsersByUserIdParams,
  DeleteUsersByUserIdResponse,
  DeleteUsersDeviceTokensByDeviceTokenParams,
  DeleteUsersDeviceTokensByDeviceTokenResponse,
  DeleteUsersPlacesByUserIdBody,
  DeleteUsersPlacesByUserIdParams,
  DeleteUsersPlacesByUserIdResponse,
  DeleteVendorsByVendorIdParams,
  DeleteVendorsByVendorIdResponse,
  DeleteVendorsDocumentVerificationsByVendorIdByDocumentParams,
  DeleteVendorsDocumentVerificationsByVendorIdByDocumentResponse,
  DeleteVisitMonitorConfirmationByVisitIdParams,
  DeleteVisitMonitorConfirmationByVisitIdResponse,
  DeleteVisitMonitorLinkByVisitIdParams,
  DeleteVisitMonitorLinkByVisitIdResponse,
  DeleteVisitsByVisitIdParams,
  DeleteVisitsByVisitIdResponse,
  GetAccountsByAccountIdParams,
  GetAccountsByAccountIdResponse,
  GetAccountsListExtra,
  GetAccountsListFilters,
  GetAccountsListItem,
  GetAccountsListResponse,
  GetAccountsPaymentMethodsByAccountIdExtra,
  GetAccountsPaymentMethodsByAccountIdParams,
  GetAccountsPaymentMethodsByAccountIdResponse,
  GetAccountsPlacesByAccountIdParams,
  GetAccountsPlacesByAccountIdResponse,
  GetAccountsUsersByAccountIdParams,
  GetAccountsUsersByAccountIdResponse,
  GetAiFeedbackByAiFeedbackIdParams,
  GetAiFeedbackByAiFeedbackIdResponse,
  GetAiFeedbackListExtra,
  GetAiFeedbackListFilters,
  GetAiFeedbackListItem,
  GetAiFeedbackListResponse,
  GetAiJobsByAiJobIdParams,
  GetAiJobsByAiJobIdResponse,
  GetAnalyticsConfirmedChurnResponse,
  GetAnalyticsMemberActivationRosterExtra,
  GetAnalyticsMemberActivationRosterQuery,
  GetAnalyticsMemberActivationRosterResponse,
  GetAnalyticsMemberActivationSummaryQuery,
  GetAnalyticsMemberActivationSummaryResponse,
  GetAnalyticsRenewalsFirstAnniversariesQuery,
  GetAnalyticsRenewalsFirstAnniversariesResponse,
  GetAnalyticsRenewalsQuery,
  GetAnalyticsRenewalsResponse,
  GetAnalyticsVendorScorecardResponse,
  GetAttachmentsByAttachmentIdParams,
  GetAttachmentsByAttachmentIdResponse,
  GetAuthMeQuery,
  GetAuthMeResponse,
  GetBillingInvoicesByAccountIdExtra,
  GetBillingInvoicesByAccountIdParams,
  GetBillingInvoicesByAccountIdQuery,
  GetBillingInvoicesByAccountIdResponse,
  GetBillingInvoicesByInvoiceIdParams,
  GetBillingInvoicesByInvoiceIdResponse,
  GetBillingPaymentHistoriesByAccountIdExtra,
  GetBillingPaymentHistoriesByAccountIdParams,
  GetBillingPaymentHistoriesByAccountIdQuery,
  GetBillingPaymentHistoriesByAccountIdResponse,
  GetBillingPaymentHistoriesByPaymentIdParams,
  GetBillingPaymentHistoriesByPaymentIdResponse,
  GetBillingPaymentMethodsByAccountIdExtra,
  GetBillingPaymentMethodsByAccountIdParams,
  GetBillingPaymentMethodsByAccountIdQuery,
  GetBillingPaymentMethodsByAccountIdResponse,
  GetBillingPaymentMethodsByPaymentMethodIdParams,
  GetBillingPaymentMethodsByPaymentMethodIdResponse,
  GetBillingTodoSectionsResponse,
  GetBirdieAudienceResponse,
  GetCampaignsByCampaignIdParams,
  GetCampaignsByCampaignIdResponse,
  GetCampaignsListExtra,
  GetCampaignsListFilters,
  GetCampaignsListItem,
  GetCampaignsListResponse,
  GetCatalogItemsAllQuery,
  GetCatalogItemsAllResponse,
  GetCatalogNewGroupsByGroupIdParams,
  GetCatalogNewGroupsByGroupIdResponse,
  GetCatalogNewGroupsListExtra,
  GetCatalogNewGroupsListFilters,
  GetCatalogNewGroupsListItem,
  GetCatalogNewGroupsListResponse,
  GetCatalogNewItemsByCatalogItemIdParams,
  GetCatalogNewItemsByCatalogItemIdResponse,
  GetCatalogNewItemsLineItemsByCatalogItemIdExtra,
  GetCatalogNewItemsLineItemsByCatalogItemIdParams,
  GetCatalogNewItemsLineItemsByCatalogItemIdQuery,
  GetCatalogNewItemsLineItemsByCatalogItemIdResponse,
  GetCatalogNewItemsListExtra,
  GetCatalogNewItemsListFilters,
  GetCatalogNewItemsListItem,
  GetCatalogNewItemsListResponse,
  GetCatalogNewItemsRelationsByCatalogItemIdParams,
  GetCatalogNewItemsRelationsByCatalogItemIdResponse,
  GetCatalogNewMarketRatesByMarketRateIdParams,
  GetCatalogNewMarketRatesByMarketRateIdResponse,
  GetCatalogNewMarketRatesListExtra,
  GetCatalogNewMarketRatesListFilters,
  GetCatalogNewMarketRatesListItem,
  GetCatalogNewMarketRatesListResponse,
  GetCategoriesAllExtra,
  GetCategoriesAllQuery,
  GetCategoriesAllResponse,
  GetChannelsByCidParams,
  GetChannelsByCidQuery,
  GetChannelsByCidResponse,
  GetChannelsInboxCountsQuery,
  GetChannelsInboxCountsResponse,
  GetChannelsInboxCustomersExtra,
  GetChannelsInboxCustomersFilters,
  GetChannelsInboxCustomersItem,
  GetChannelsInboxCustomersResponse,
  GetChannelsInboxExtra,
  GetChannelsInboxFilters,
  GetChannelsInboxItem,
  GetChannelsInboxPlacesExtra,
  GetChannelsInboxPlacesFilters,
  GetChannelsInboxPlacesItem,
  GetChannelsInboxPlacesResponse,
  GetChannelsInboxResponse,
  GetChannelsMembersByCidExtra,
  GetChannelsMembersByCidParams,
  GetChannelsMembersByCidResponse,
  GetChannelsMessagesByCidExtra,
  GetChannelsMessagesByCidParams,
  GetChannelsMessagesByCidQuery,
  GetChannelsMessagesByCidResponse,
  GetChannelsMessagesReadsByCidByMessageIdExtra,
  GetChannelsMessagesReadsByCidByMessageIdParams,
  GetChannelsMessagesReadsByCidByMessageIdResponse,
  GetChannelsPromptBlocksByCidExtra,
  GetChannelsPromptBlocksByCidParams,
  GetChannelsPromptBlocksByCidResponse,
  GetChannelsUnreadByCidParams,
  GetChannelsUnreadByCidResponse,
  GetCheckoutCouponsByCouponCodeParams,
  GetCheckoutCouponsByCouponCodeResponse,
  GetCheckoutLinksByCheckoutLinkIdParams,
  GetCheckoutLinksByCheckoutLinkIdResponse,
  GetCheckoutLinksListExtra,
  GetCheckoutLinksListFilters,
  GetCheckoutLinksListItem,
  GetCheckoutLinksListResponse,
  GetCheckoutLinksPlanByCheckoutLinkIdParams,
  GetCheckoutLinksPlanByCheckoutLinkIdResponse,
  GetCheckoutPurchaseIntentsByPurchaseIntentIdParams,
  GetCheckoutPurchaseIntentsByPurchaseIntentIdResponse,
  GetCheckoutPurchaseIntentsQuery,
  GetCheckoutPurchaseIntentsResponse,
  GetCheckoutPurchaseIntentsSetupIntentByPurchaseIntentIdParams,
  GetCheckoutPurchaseIntentsSetupIntentByPurchaseIntentIdResponse,
  GetCommentsByCommentIdParams,
  GetCommentsByCommentIdResponse,
  GetExpensesByExpenseIdParams,
  GetExpensesByExpenseIdResponse,
  GetExpensesListExtra,
  GetExpensesListFilters,
  GetExpensesListItem,
  GetExpensesListResponse,
  GetFieldConversationCountsQuery,
  GetFieldConversationCountsResponse,
  GetFieldConversationsExtra,
  GetFieldConversationsFilters,
  GetFieldConversationsItem,
  GetFieldConversationsResponse,
  GetFieldOrderAttachmentsParams,
  GetFieldOrderAttachmentsQuery,
  GetFieldOrderAttachmentsResponse,
  GetFieldOrderConversationParams,
  GetFieldOrderConversationResponse,
  GetFieldScheduleExtra,
  GetFieldScheduleQuery,
  GetFieldScheduleResponse,
  GetFieldVisitDetailParams,
  GetFieldVisitDetailResponse,
  GetFieldVisitReportParams,
  GetFieldVisitReportResponse,
  GetFieldVisitsNotifyMemberPreviewByVisitIdParams,
  GetFieldVisitsNotifyMemberPreviewByVisitIdQuery,
  GetFieldVisitsNotifyMemberPreviewByVisitIdResponse,
  GetGlobalOfficeResponse,
  GetGlobalSpacesResponse,
  GetHomecarePlanOrdersProposalByOrderIdParams,
  GetHomecarePlanOrdersProposalByOrderIdResponse,
  GetHomecarePlanProposalsByProposalIdParams,
  GetHomecarePlanProposalsByProposalIdResponse,
  GetHomecarePlanProposalsDetailByProposalIdParams,
  GetHomecarePlanProposalsDetailByProposalIdResponse,
  GetHomecarePlanProposalsExtra,
  GetHomecarePlanProposalsFilters,
  GetHomecarePlanProposalsItem,
  GetHomecarePlanProposalsResponse,
  GetImpersonationSearchQuery,
  GetImpersonationSearchResponse,
  GetInvoicesByInvoiceIdParams,
  GetInvoicesByInvoiceIdResponse,
  GetInvoicesCollectionByInvoiceIdParams,
  GetInvoicesCollectionByInvoiceIdResponse,
  GetInvoicesCorrectionsByInvoiceIdParams,
  GetInvoicesCorrectionsByInvoiceIdResponse,
  GetInvoicesDocumentByInvoiceIdParams,
  GetInvoicesDocumentByInvoiceIdResponse,
  GetInvoicesListExtra,
  GetInvoicesListFilters,
  GetInvoicesListItem,
  GetInvoicesListResponse,
  GetInvoicesSummaryQuery,
  GetInvoicesSummaryResponse,
  GetLineItemUnitTypesAllQuery,
  GetLineItemUnitTypesAllResponse,
  GetLineItemsByLineItemIdParams,
  GetLineItemsByLineItemIdResponse,
  GetListItemsByListItemIdParams,
  GetListItemsByListItemIdQuery,
  GetListItemsByListItemIdResponse,
  GetListItemsListExtra,
  GetListItemsListFilters,
  GetListItemsListItem,
  GetListItemsListResponse,
  GetLocationsByLocationIdParams,
  GetLocationsByLocationIdResponse,
  GetLocationsListExtra,
  GetLocationsListFilters,
  GetLocationsListItem,
  GetLocationsListResponse,
  GetMeetLinkByNameParams,
  GetMeetLinkByNameResponse,
  GetMeetParticipantsByRoomNameParams,
  GetMeetParticipantsByRoomNameResponse,
  GetMembersAccountsExtra,
  GetMembersAccountsResponse,
  GetMembersAttachmentsByAttachmentIdParams,
  GetMembersAttachmentsByAttachmentIdResponse,
  GetMembersBillingAlertResponse,
  GetMembersCampaignsExtra,
  GetMembersCampaignsResponse,
  GetMembersInsightQuery,
  GetMembersInsightResponse,
  GetMembersOrdersByOrderIdParams,
  GetMembersOrdersByOrderIdQuery,
  GetMembersOrdersByOrderIdResponse,
  GetMembersOrdersExtra,
  GetMembersOrdersFilters,
  GetMembersOrdersItem,
  GetMembersOrdersResponse,
  GetMembersPaymentsExtra,
  GetMembersPaymentsQuery,
  GetMembersPaymentsResponse,
  GetMembersPlacesByPlaceIdParams,
  GetMembersPlacesByPlaceIdQuery,
  GetMembersPlacesByPlaceIdResponse,
  GetMembersPlacesExtra,
  GetMembersPlacesNestComponentsByPlaceIdByNodeKeyParams,
  GetMembersPlacesNestComponentsByPlaceIdByNodeKeyResponse,
  GetMembersPlacesNestComponentsByPlaceIdParams,
  GetMembersPlacesNestComponentsByPlaceIdResponse,
  GetMembersPlacesNestSummaryByPlaceIdParams,
  GetMembersPlacesNestSummaryByPlaceIdResponse,
  GetMembersPlacesQuery,
  GetMembersPlacesResponse,
  GetMembersQuotesByQuoteIdParams,
  GetMembersQuotesByQuoteIdResponse,
  GetMembersSearchQuery,
  GetMembersSearchResponse,
  GetMembersVisitsExtra,
  GetMembersVisitsQuery,
  GetMembersVisitsResponse,
  GetMessagesByMessageIdParams,
  GetMessagesByMessageIdResponse,
  GetNotesDocByNotableTypeByNotableIdParams,
  GetNotesDocByNotableTypeByNotableIdResponse,
  GetNotificationsByNotificationIdParams,
  GetNotificationsByNotificationIdResponse,
  GetNotificationsCountsResponse,
  GetNotificationsDeliveriesByNotificationIdParams,
  GetNotificationsDeliveriesByNotificationIdResponse,
  GetNotificationsDeliveriesListExtra,
  GetNotificationsDeliveriesListFilters,
  GetNotificationsDeliveriesListItem,
  GetNotificationsDeliveriesListResponse,
  GetNotificationsLatestResponse,
  GetNotificationsListExtra,
  GetNotificationsListFilters,
  GetNotificationsListItem,
  GetNotificationsListResponse,
  GetOnboardingsByOnboardingIdParams,
  GetOnboardingsByOnboardingIdResponse,
  GetOnboardingsListExtra,
  GetOnboardingsListFilters,
  GetOnboardingsListItem,
  GetOnboardingsListResponse,
  GetOnboardingsStagesResponse,
  GetOnboardingsWidgetByOnboardingIdParams,
  GetOnboardingsWidgetByOnboardingIdResponse,
  GetOrderQuotesByQuoteIdParams,
  GetOrderQuotesByQuoteIdResponse,
  GetOrderQuotesCountsQuery,
  GetOrderQuotesCountsResponse,
  GetOrderQuotesDepositByQuoteIdParams,
  GetOrderQuotesDepositByQuoteIdResponse,
  GetOrderQuotesLegacyScopeMigrationPlanByOrderIdParams,
  GetOrderQuotesLegacyScopeMigrationPlanByOrderIdQuery,
  GetOrderQuotesLegacyScopeMigrationPlanByOrderIdResponse,
  GetOrderQuotesLegacyScopeMigrationResponse,
  GetOrderQuotesLegacyScopePreviewByOrderIdParams,
  GetOrderQuotesLegacyScopePreviewByOrderIdResponse,
  GetOrderQuotesListExtra,
  GetOrderQuotesListFilters,
  GetOrderQuotesListItem,
  GetOrderQuotesListResponse,
  GetOrderRequestsActivitiesByOrderRequestIdExtra,
  GetOrderRequestsActivitiesByOrderRequestIdParams,
  GetOrderRequestsActivitiesByOrderRequestIdQuery,
  GetOrderRequestsActivitiesByOrderRequestIdResponse,
  GetOrderRequestsByOrderRequestIdParams,
  GetOrderRequestsByOrderRequestIdResponse,
  GetOrderRequestsGroupCountsQuery,
  GetOrderRequestsGroupCountsResponse,
  GetOrderRequestsItemsSuggestByOrderRequestIdExtra,
  GetOrderRequestsItemsSuggestByOrderRequestIdParams,
  GetOrderRequestsItemsSuggestByOrderRequestIdQuery,
  GetOrderRequestsItemsSuggestByOrderRequestIdResponse,
  GetOrderRequestsItemsTitleSuggestionsQuery,
  GetOrderRequestsItemsTitleSuggestionsResponse,
  GetOrderRequestsListExtra,
  GetOrderRequestsListFilters,
  GetOrderRequestsListItem,
  GetOrderRequestsListResponse,
  GetOrderRequestsStatusesQuery,
  GetOrderRequestsStatusesResponse,
  GetOrderRequestsSubscribersByOrderRequestIdParams,
  GetOrderRequestsSubscribersByOrderRequestIdResponse,
  GetOrderRequestsTimeInStatusByOrderRequestIdParams,
  GetOrderRequestsTimeInStatusByOrderRequestIdResponse,
  GetOrdersActivitiesByOrderIdParams,
  GetOrdersActivitiesByOrderIdResponse,
  GetOrdersAiSummaryByOrderIdParams,
  GetOrdersAiSummaryByOrderIdResponse,
  GetOrdersAttachmentsByOrderIdParams,
  GetOrdersAttachmentsByOrderIdQuery,
  GetOrdersAttachmentsByOrderIdResponse,
  GetOrdersBirdieTipsByOrderIdParams,
  GetOrdersBirdieTipsByOrderIdResponse,
  GetOrdersBrexBillsByOrderIdParams,
  GetOrdersBrexBillsByOrderIdQuery,
  GetOrdersBrexBillsByOrderIdResponse,
  GetOrdersByOrderIdParams,
  GetOrdersByOrderIdQuery,
  GetOrdersByOrderIdResponse,
  GetOrdersConversationSummaryByOrderIdParams,
  GetOrdersConversationSummaryByOrderIdResponse,
  GetOrdersCustomerAccountsByOrderIdParams,
  GetOrdersCustomerAccountsByOrderIdResponse,
  GetOrdersDepositsByOrderIdParams,
  GetOrdersDepositsByOrderIdResponse,
  GetOrdersExpensesByOrderIdExtra,
  GetOrdersExpensesByOrderIdParams,
  GetOrdersExpensesByOrderIdResponse,
  GetOrdersFeedbackByFeedbackIdParams,
  GetOrdersFeedbackByFeedbackIdResponse,
  GetOrdersFeedbackListExtra,
  GetOrdersFeedbackListQuery,
  GetOrdersFeedbackListResponse,
  GetOrdersFeedbackTagsExtra,
  GetOrdersFeedbackTagsResponse,
  GetOrdersHomecarePlanOrdersByOrderIdParams,
  GetOrdersHomecarePlanOrdersByOrderIdResponse,
  GetOrdersInvoicesAndPaymentsByOrderIdParams,
  GetOrdersInvoicesAndPaymentsByOrderIdResponse,
  GetOrdersLastedTimePreferencesByOrderIdParams,
  GetOrdersLastedTimePreferencesByOrderIdResponse,
  GetOrdersLinkedOrdersByOrderIdParams,
  GetOrdersLinkedOrdersByOrderIdQuery,
  GetOrdersLinkedOrdersByOrderIdResponse,
  GetOrdersListExtra,
  GetOrdersListFilters,
  GetOrdersListItem,
  GetOrdersListResponse,
  GetOrdersOrderMonthListExtra,
  GetOrdersOrderMonthListFilters,
  GetOrdersOrderMonthListItem,
  GetOrdersOrderMonthListResponse,
  GetOrdersProfitByOrderIdParams,
  GetOrdersProfitByOrderIdResponse,
  GetOrdersPublicByOrderIdParams,
  GetOrdersPublicByOrderIdResponse,
  GetOrdersRevenuesByOrderIdParams,
  GetOrdersRevenuesByOrderIdResponse,
  GetOrdersScopeByOrderIdParams,
  GetOrdersScopeByOrderIdResponse,
  GetOrdersStatusesQuery,
  GetOrdersStatusesResponse,
  GetOrdersTimeInStatusByOrderIdParams,
  GetOrdersTimeInStatusByOrderIdResponse,
  GetOrdersToneByOrderIdParams,
  GetOrdersToneByOrderIdResponse,
  GetPayLinksByTokenParams,
  GetPayLinksByTokenResponse,
  GetPlacesAttachmentsByPlaceIdExtra,
  GetPlacesAttachmentsByPlaceIdParams,
  GetPlacesAttachmentsByPlaceIdQuery,
  GetPlacesAttachmentsByPlaceIdResponse,
  GetPlacesByPlaceIdParams,
  GetPlacesByPlaceIdQuery,
  GetPlacesByPlaceIdResponse,
  GetPlacesCheckByPlaceIdParams,
  GetPlacesCheckByPlaceIdResponse,
  GetPlacesListExtra,
  GetPlacesListFilters,
  GetPlacesListItem,
  GetPlacesListResponse,
  GetPlacesNestByPlaceIdParams,
  GetPlacesNestByPlaceIdResponse,
  GetPlacesNestPartsByPlaceIdParams,
  GetPlacesNestPartsByPlaceIdResponse,
  GetPlacesNestSummaryByPlaceIdParams,
  GetPlacesNestSummaryByPlaceIdResponse,
  GetPlacesOrderPlansKeysByPlaceIdByOrderPlanKeyParams,
  GetPlacesOrderPlansKeysByPlaceIdByOrderPlanKeyResponse,
  GetPolicyPermissionsResponse,
  GetPolicyRolesByRoleKeyParams,
  GetPolicyRolesByRoleKeyResponse,
  GetPolicyRolesResponse,
  GetPolicyUsersByUserIdParams,
  GetPolicyUsersByUserIdResponse,
  GetProductsAllExtra,
  GetProductsAllQuery,
  GetProductsAllResponse,
  GetProductsByProductIdParams,
  GetProductsByProductIdResponse,
  GetProductsListExtra,
  GetProductsListFilters,
  GetProductsListItem,
  GetProductsListResponse,
  GetPurchaseIntentsByPurchaseIntentIdParams,
  GetPurchaseIntentsByPurchaseIntentIdQuery,
  GetPurchaseIntentsByPurchaseIntentIdResponse,
  GetPurchaseIntentsListExtra,
  GetPurchaseIntentsListFilters,
  GetPurchaseIntentsListItem,
  GetPurchaseIntentsListResponse,
  GetReportMrrAtRiskQuery,
  GetReportMrrAtRiskResponse,
  GetReportMrrChurnReasonsQuery,
  GetReportMrrChurnReasonsResponse,
  GetReportMrrGrowthQuery,
  GetReportMrrGrowthResponse,
  GetReportMrrLedgerListExtra,
  GetReportMrrLedgerListFilters,
  GetReportMrrLedgerListItem,
  GetReportMrrLedgerListResponse,
  GetReportMrrMovementExtra,
  GetReportMrrMovementQuery,
  GetReportMrrMovementResponse,
  GetReportMrrMoversQuery,
  GetReportMrrMoversResponse,
  GetReportMrrSnapshotQuery,
  GetReportMrrSnapshotResponse,
  GetReportOrderOverviewHistoryByOrderIdParams,
  GetReportOrderOverviewHistoryByOrderIdResponse,
  GetReportOrderOverviewListExtra,
  GetReportOrderOverviewListFilters,
  GetReportOrderOverviewListItem,
  GetReportOrderOverviewListResponse,
  GetReportOrderOverviewSummaryQuery,
  GetReportOrderOverviewSummaryResponse,
  GetRevenueMonthsCloseChecksByMonthParams,
  GetRevenueMonthsCloseChecksByMonthResponse,
  GetRevenueMonthsPackageByMonthParams,
  GetRevenueMonthsPackageByMonthResponse,
  GetRevenueMonthsReportResponse,
  GetScheduleEventDetailParams,
  GetScheduleEventDetailResponse,
  GetScheduleGoogleEventDetailParams,
  GetScheduleGoogleEventDetailResponse,
  GetSchedulesListQuery,
  GetSchedulesListResponse,
  GetScopesByOrderScopeIdParams,
  GetScopesByOrderScopeIdResponse,
  GetSearchGlobalQuery,
  GetSearchGlobalResponse,
  GetSmartActionsAccuracyQuery,
  GetSmartActionsAccuracyResponse,
  GetSmartActionsBySmartActionIdParams,
  GetSmartActionsBySmartActionIdResponse,
  GetSmartActionsForecastQuery,
  GetSmartActionsForecastResponse,
  GetSmartActionsListExtra,
  GetSmartActionsListFilters,
  GetSmartActionsListItem,
  GetSmartActionsListResponse,
  GetSmartActionsLostCostsQuery,
  GetSmartActionsLostCostsResponse,
  GetSmartActionsOrderReviewByOrderIdParams,
  GetSmartActionsOrderReviewByOrderIdResponse,
  GetSmartActionsSummaryQuery,
  GetSmartActionsSummaryResponse,
  GetSpacesBySpaceIdParams,
  GetSpacesBySpaceIdResponse,
  GetStatusAllResponse,
  GetSubscriptionsBySubscriptionIdParams,
  GetSubscriptionsBySubscriptionIdResponse,
  GetSubscriptionsItemsHistoryBySubscriptionIdExtra,
  GetSubscriptionsItemsHistoryBySubscriptionIdParams,
  GetSubscriptionsItemsHistoryBySubscriptionIdQuery,
  GetSubscriptionsItemsHistoryBySubscriptionIdResponse,
  GetSubscriptionsListExtra,
  GetSubscriptionsListFilters,
  GetSubscriptionsListItem,
  GetSubscriptionsListResponse,
  GetSubscriptionsMyBySubscriptionIdParams,
  GetSubscriptionsMyBySubscriptionIdResponse,
  GetSubscriptionsPlansByPlanIdParams,
  GetSubscriptionsPlansByPlanIdQuery,
  GetSubscriptionsPlansByPlanIdResponse,
  GetSubscriptionsPlansQuery,
  GetSubscriptionsPlansResponse,
  GetSubscriptionsProductsResponse,
  GetSubscriptionsStatusesResponse,
  GetSubscriptionsTimelineBySubscriptionIdExtra,
  GetSubscriptionsTimelineBySubscriptionIdParams,
  GetSubscriptionsTimelineBySubscriptionIdQuery,
  GetSubscriptionsTimelineBySubscriptionIdResponse,
  GetTagsListExtra,
  GetTagsListFilters,
  GetTagsListItem,
  GetTagsListResponse,
  GetTasksByTaskIdParams,
  GetTasksByTaskIdResponse,
  GetTasksGroupsQuery,
  GetTasksGroupsResponse,
  GetTasksListExtra,
  GetTasksListFilters,
  GetTasksListItem,
  GetTasksListResponse,
  GetTechnicianCalendarEventsQuery,
  GetTechnicianCalendarEventsResponse,
  GetTimeEntriesListExtra,
  GetTimeEntriesListFilters,
  GetTimeEntriesListItem,
  GetTimeEntriesListResponse,
  GetTimePreferencesByTimePreferenceIdParams,
  GetTimePreferencesByTimePreferenceIdResponse,
  GetTimeProposalsByTimeProposalIdParams,
  GetTimeProposalsByTimeProposalIdResponse,
  GetUsersAccountsByUserIdParams,
  GetUsersAccountsByUserIdResponse,
  GetUsersByUserIdParams,
  GetUsersByUserIdQuery,
  GetUsersByUserIdResponse,
  GetUsersInvitesByTokenParams,
  GetUsersInvitesByTokenResponse,
  GetUsersInvitesPlacesByPlaceIdParams,
  GetUsersInvitesPlacesByPlaceIdResponse,
  GetUsersInvitesPlacesMembersByPlaceIdParams,
  GetUsersInvitesPlacesMembersByPlaceIdResponse,
  GetUsersListExtra,
  GetUsersListFilters,
  GetUsersListItem,
  GetUsersListResponse,
  GetUsersMeNotificationPreferencesResponse,
  GetUsersOnlineByUserIdParams,
  GetUsersOnlineByUserIdResponse,
  GetUsersPlacesByUserIdParams,
  GetUsersPlacesByUserIdResponse,
  GetUsersProfilesByUserIdParams,
  GetUsersProfilesByUserIdResponse,
  GetVendorsByVendorIdParams,
  GetVendorsByVendorIdQuery,
  GetVendorsByVendorIdResponse,
  GetVendorsListExtra,
  GetVendorsListFilters,
  GetVendorsListItem,
  GetVendorsListResponse,
  GetViewsDefaultsExtra,
  GetViewsDefaultsResponse,
  GetViewsListExtra,
  GetViewsListFilters,
  GetViewsListItem,
  GetViewsListResponse,
  GetVisitLinksByLinkCodeParams,
  GetVisitLinksByLinkCodeResponse,
  GetVisitMonitorLinkPreviewByVisitIdParams,
  GetVisitMonitorLinkPreviewByVisitIdResponse,
  GetVisitMonitorListExtra,
  GetVisitMonitorListFilters,
  GetVisitMonitorListItem,
  GetVisitMonitorListResponse,
  GetVisitMonitorSmsDraftByVisitIdParams,
  GetVisitMonitorSmsDraftByVisitIdResponse,
  GetVisitsAllExtra,
  GetVisitsAllQuery,
  GetVisitsAllResponse,
  GetVisitsAttachmentsByVisitIdParams,
  GetVisitsAttachmentsByVisitIdResponse,
  GetVisitsAvailableTimesExtra,
  GetVisitsAvailableTimesQuery,
  GetVisitsAvailableTimesResponse,
  GetVisitsByVisitIdParams,
  GetVisitsByVisitIdResponse,
  GetVisitsCountQuery,
  GetVisitsCountResponse,
  GetVisitsFieldReportByVisitIdParams,
  GetVisitsFieldReportByVisitIdResponse,
  GetVisitsInstructionOriginByVisitIdParams,
  GetVisitsInstructionOriginByVisitIdResponse,
  GetVisitsOfficeExpenseByVisitIdParams,
  GetVisitsOfficeExpenseByVisitIdResponse,
  GetVisitsOfficeReportByVisitIdParams,
  GetVisitsOfficeReportByVisitIdResponse,
  GetVisitsServiceTeamByVisitIdParams,
  GetVisitsServiceTeamByVisitIdResponse,
  GetVisitsTechniciansByVisitIdParams,
  GetVisitsTechniciansByVisitIdResponse,
  GetWalletsAccountCreditByAccountIdParams,
  GetWalletsAccountCreditByAccountIdResponse,
  GetWalletsByAccountIdParams,
  GetWalletsByAccountIdResponse,
  GetWalletsTransactionHistoriesByAccountIdExtra,
  GetWalletsTransactionHistoriesByAccountIdParams,
  GetWalletsTransactionHistoriesByAccountIdQuery,
  GetWalletsTransactionHistoriesByAccountIdResponse,
  GetWalletsTransactionHistoriesByLedgerIdParams,
  GetWalletsTransactionHistoriesByLedgerIdResponse,
  GetZipcodesByZipcodeParams,
  GetZipcodesByZipcodeResponse,
  GetZipcodesCitiesExtra,
  GetZipcodesCitiesQuery,
  GetZipcodesCitiesResponse,
  GetZipcodesListExtra,
  GetZipcodesListFilters,
  GetZipcodesListItem,
  GetZipcodesListResponse,
  ReadAllFieldConversationsResponse,
  UpdateAccountsByAccountIdBody,
  UpdateAccountsByAccountIdParams,
  UpdateAccountsByAccountIdResponse,
  UpdateAccountsTrackingsByAccountIdByTrackingIdBody,
  UpdateAccountsTrackingsByAccountIdByTrackingIdParams,
  UpdateAccountsTrackingsByAccountIdByTrackingIdResponse,
  UpdateAiFeedbackByAiFeedbackIdBody,
  UpdateAiFeedbackByAiFeedbackIdParams,
  UpdateAiFeedbackByAiFeedbackIdResponse,
  UpdateCampaignsByCampaignIdBody,
  UpdateCampaignsByCampaignIdParams,
  UpdateCampaignsByCampaignIdResponse,
  UpdateCatalogNewGroupsByGroupIdBody,
  UpdateCatalogNewGroupsByGroupIdParams,
  UpdateCatalogNewGroupsByGroupIdResponse,
  UpdateCatalogNewItemsByCatalogItemIdBody,
  UpdateCatalogNewItemsByCatalogItemIdParams,
  UpdateCatalogNewItemsByCatalogItemIdResponse,
  UpdateCatalogNewItemsRelationsByCatalogItemIdByRelationIdBody,
  UpdateCatalogNewItemsRelationsByCatalogItemIdByRelationIdParams,
  UpdateCatalogNewItemsRelationsByCatalogItemIdByRelationIdResponse,
  UpdateCatalogNewMarketRatesByMarketRateIdBody,
  UpdateCatalogNewMarketRatesByMarketRateIdParams,
  UpdateCatalogNewMarketRatesByMarketRateIdResponse,
  UpdateChannelsMeByCidBody,
  UpdateChannelsMeByCidParams,
  UpdateChannelsMeByCidResponse,
  UpdateChannelsMessagesByCidByMessageIdBody,
  UpdateChannelsMessagesByCidByMessageIdParams,
  UpdateChannelsMessagesByCidByMessageIdResponse,
  UpdateCheckoutLinksByCheckoutLinkIdBody,
  UpdateCheckoutLinksByCheckoutLinkIdParams,
  UpdateCheckoutLinksByCheckoutLinkIdResponse,
  UpdateCheckoutPurchaseIntentsByPurchaseIntentIdBody,
  UpdateCheckoutPurchaseIntentsByPurchaseIntentIdParams,
  UpdateCheckoutPurchaseIntentsByPurchaseIntentIdResponse,
  UpdateExpensesByExpenseIdBody,
  UpdateExpensesByExpenseIdParams,
  UpdateExpensesByExpenseIdResponse,
  UpdateHomecarePlanProposalsByProposalIdBody,
  UpdateHomecarePlanProposalsByProposalIdParams,
  UpdateHomecarePlanProposalsByProposalIdResponse,
  UpdateInvoicesByInvoiceIdBody,
  UpdateInvoicesByInvoiceIdParams,
  UpdateInvoicesByInvoiceIdResponse,
  UpdateInvoicesChargeScheduleByInvoiceIdBody,
  UpdateInvoicesChargeScheduleByInvoiceIdParams,
  UpdateInvoicesChargeScheduleByInvoiceIdResponse,
  UpdateItemGroupsByItemGroupIdBody,
  UpdateItemGroupsByItemGroupIdParams,
  UpdateLineItemsByLineItemIdBody,
  UpdateLineItemsByLineItemIdParams,
  UpdateLineItemsByLineItemIdResponse,
  UpdateLinksLinkUserPlaceBody,
  UpdateLinksLinkUserPlaceResponse,
  UpdateListItemsByListItemIdBody,
  UpdateListItemsByListItemIdParams,
  UpdateListItemsByListItemIdResponse,
  UpdateLocationsByLocationIdBody,
  UpdateLocationsByLocationIdParams,
  UpdateLocationsByLocationIdResponse,
  UpdateMembershipsByMembershipIdBody,
  UpdateMembershipsByMembershipIdParams,
  UpdateMembershipsByMembershipIdResponse,
  UpdateNotesDocByNotableTypeByNotableIdBody,
  UpdateNotesDocByNotableTypeByNotableIdParams,
  UpdateNotesDocByNotableTypeByNotableIdResponse,
  UpdateNotificationsArchiveByNotificationIdBody,
  UpdateNotificationsArchiveByNotificationIdParams,
  UpdateNotificationsArchiveByNotificationIdResponse,
  UpdateNotificationsReadByNotificationIdBody,
  UpdateNotificationsReadByNotificationIdParams,
  UpdateNotificationsReadByNotificationIdResponse,
  UpdateOrderPlansByOrderPlanIdBody,
  UpdateOrderPlansByOrderPlanIdParams,
  UpdateOrderPlansByOrderPlanIdResponse,
  UpdateOrderQuotesByQuoteIdBody,
  UpdateOrderQuotesByQuoteIdParams,
  UpdateOrderQuotesByQuoteIdResponse,
  UpdateOrderQuotesOptionsByQuoteIdByOptionIdBody,
  UpdateOrderQuotesOptionsByQuoteIdByOptionIdParams,
  UpdateOrderQuotesOptionsByQuoteIdByOptionIdResponse,
  UpdateOrderRequestsByOrderRequestIdBody,
  UpdateOrderRequestsByOrderRequestIdParams,
  UpdateOrderRequestsByOrderRequestIdResponse,
  UpdateOrderRequestsItemsByOrderRequestIdByItemIdBody,
  UpdateOrderRequestsItemsByOrderRequestIdByItemIdParams,
  UpdateOrderRequestsItemsByOrderRequestIdByItemIdResponse,
  UpdateOrderRequestsSubscribersByOrderRequestIdBody,
  UpdateOrderRequestsSubscribersByOrderRequestIdParams,
  UpdateOrderRequestsSubscribersByOrderRequestIdResponse,
  UpdateOrdersByOrderIdBody,
  UpdateOrdersByOrderIdParams,
  UpdateOrdersByOrderIdResponse,
  UpdateOrdersFeedbackByOrderIdBody,
  UpdateOrdersFeedbackByOrderIdParams,
  UpdateOrdersFeedbackByOrderIdResponse,
  UpdateOrdersSubscribersByOrderIdBody,
  UpdateOrdersSubscribersByOrderIdParams,
  UpdateOrdersSubscribersByOrderIdResponse,
  UpdatePlacesByPlaceIdBody,
  UpdatePlacesByPlaceIdParams,
  UpdatePlacesByPlaceIdResponse,
  UpdatePlacesNestFactsByPlaceIdByFactKeyBody,
  UpdatePlacesNestFactsByPlaceIdByFactKeyParams,
  UpdatePlacesNestFactsByPlaceIdByFactKeyResponse,
  UpdatePlacesNestRoomsByPlaceIdByRoomKeyBody,
  UpdatePlacesNestRoomsByPlaceIdByRoomKeyParams,
  UpdatePlacesNestRoomsByPlaceIdByRoomKeyResponse,
  UpdatePolicyRolesByRoleKeyBody,
  UpdatePolicyRolesByRoleKeyParams,
  UpdatePolicyRolesByRoleKeyResponse,
  UpdatePolicyRolesPermissionsByRoleKeyBody,
  UpdatePolicyRolesPermissionsByRoleKeyParams,
  UpdatePolicyRolesPermissionsByRoleKeyResponse,
  UpdatePurchaseIntentsByPurchaseIntentIdBody,
  UpdatePurchaseIntentsByPurchaseIntentIdParams,
  UpdatePurchaseIntentsByPurchaseIntentIdResponse,
  UpdateRevenuesByRevenueIdBody,
  UpdateRevenuesByRevenueIdParams,
  UpdateRevenuesByRevenueIdResponse,
  UpdateScheduleEventBody,
  UpdateScheduleEventParams,
  UpdateScheduleEventResponse,
  UpdateScopesAllBody,
  UpdateSmartActionsBySmartActionIdBody,
  UpdateSmartActionsBySmartActionIdParams,
  UpdateSmartActionsBySmartActionIdResponse,
  UpdateSmartActionsStepsBySmartActionIdByStepIdBody,
  UpdateSmartActionsStepsBySmartActionIdByStepIdParams,
  UpdateSmartActionsStepsBySmartActionIdByStepIdResponse,
  UpdateSpacesBySpaceIdBody,
  UpdateSpacesBySpaceIdParams,
  UpdateSpacesBySpaceIdResponse,
  UpdateSubscriptionsBySubscriptionIdBody,
  UpdateSubscriptionsBySubscriptionIdParams,
  UpdateSubscriptionsBySubscriptionIdResponse,
  UpdateTagsByTagIdBody,
  UpdateTagsByTagIdParams,
  UpdateTagsByTagIdResponse,
  UpdateTasksByTaskIdBody,
  UpdateTasksByTaskIdParams,
  UpdateTasksByTaskIdResponse,
  UpdateTimeEntriesByTimeEntryIdBody,
  UpdateTimeEntriesByTimeEntryIdParams,
  UpdateTimeEntriesByTimeEntryIdResponse,
  UpdateUsersAccountByUserIdByAccountIdBody,
  UpdateUsersAccountByUserIdByAccountIdParams,
  UpdateUsersAccountByUserIdByAccountIdResponse,
  UpdateUsersByUserIdBody,
  UpdateUsersByUserIdParams,
  UpdateUsersByUserIdResponse,
  UpdateUsersMeNotificationPreferencesBody,
  UpdateUsersMeNotificationPreferencesResponse,
  UpdateUsersPlaceByUserIdByPlaceIdBody,
  UpdateUsersPlaceByUserIdByPlaceIdParams,
  UpdateUsersPlaceByUserIdByPlaceIdResponse,
  UpdateUsersProfilesByUserIdByKeyBody,
  UpdateUsersProfilesByUserIdByKeyParams,
  UpdateUsersProfilesByUserIdByKeyResponse,
  UpdateVendorOnboardingsByVendorOnboardingIdBody,
  UpdateVendorOnboardingsByVendorOnboardingIdParams,
  UpdateVendorOnboardingsByVendorOnboardingIdResponse,
  UpdateVendorsByVendorIdBody,
  UpdateVendorsByVendorIdParams,
  UpdateVendorsByVendorIdResponse,
  UpdateVendorsDocumentExtractionsByVendorIdByAttachmentIdBody,
  UpdateVendorsDocumentExtractionsByVendorIdByAttachmentIdParams,
  UpdateVendorsDocumentExtractionsByVendorIdByAttachmentIdResponse,
  UpdateVisitMonitorLinkByVisitIdParams,
  UpdateVisitMonitorLinkByVisitIdResponse,
  UpdateVisitsByVisitIdBody,
  UpdateVisitsByVisitIdParams,
  UpdateVisitsByVisitIdResponse,
  UpdateVisitsTechniciansByVisitIdBody,
  UpdateVisitsTechniciansByVisitIdParams,
  UpdateVisitsTechniciansByVisitIdResponse,
  UpdateZipcodesByZipcodeBody,
  UpdateZipcodesByZipcodeParams,
  UpdateZipcodesByZipcodeResponse,
} from "./types.generated";

// ============================================================================
// Accounts Resource
// ============================================================================

export function useGetAccountsList() {
  return useListQuery<
    GetAccountsListItem,
    GetAccountsListResponse,
    GetAccountsListFilters
  >("accounts", "/list");
}

export function useCreateAccountsAll(
  options?: CustomMutationOptions<
    CreateAccountsAllBody,
    CreateAccountsAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAccountsAllBody,
    CreateAccountsAllResponse
  >("accounts", "", "POST", options);
}

export function useCreateAccountsCreateCustomer(
  options?: CustomMutationOptions<
    CreateAccountsCreateCustomerBody,
    CreateAccountsCreateCustomerResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAccountsCreateCustomerBody,
    CreateAccountsCreateCustomerResponse
  >("accounts", "/create-customer", "POST", options);
}

export function useCreateAccountsRequestDeletion(
  options?: CustomMutationOptions<
    unknown,
    CreateAccountsRequestDeletionResponse
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateAccountsRequestDeletionResponse
  >("accounts", "/request-deletion", "POST", options);
}

export function useGetAccountsUsersByAccountId(
  params: GetAccountsUsersByAccountIdParams,
): CustomQueryBuilder<
  GetAccountsUsersByAccountIdResponse,
  GetAccountsUsersByAccountIdParams
> {
  return useResourceCustomQuery<
    GetAccountsUsersByAccountIdResponse,
    GetAccountsUsersByAccountIdParams
  >("accounts", "/:accountId/users", params);
}

export function useGetAccountsPlacesByAccountId(
  params: GetAccountsPlacesByAccountIdParams,
): CustomQueryBuilder<
  GetAccountsPlacesByAccountIdResponse,
  GetAccountsPlacesByAccountIdParams
> {
  return useResourceCustomQuery<
    GetAccountsPlacesByAccountIdResponse,
    GetAccountsPlacesByAccountIdParams
  >("accounts", "/:accountId/places", params);
}

export function useGetAccountsPaymentMethodsByAccountId(
  params: GetAccountsPaymentMethodsByAccountIdParams,
): CustomQueryBuilder<
  GetAccountsPaymentMethodsByAccountIdResponse,
  GetAccountsPaymentMethodsByAccountIdParams,
  Record<string, unknown>,
  GetAccountsPaymentMethodsByAccountIdExtra
> {
  return useResourceCustomQuery<
    GetAccountsPaymentMethodsByAccountIdResponse,
    GetAccountsPaymentMethodsByAccountIdParams,
    Record<string, unknown>,
    GetAccountsPaymentMethodsByAccountIdExtra
  >("accounts", "/:accountId/payment-methods", params);
}

export function useCreateAccountsTrackingsByAccountId(
  options?: CustomMutationOptions<
    CreateAccountsTrackingsByAccountIdBody,
    CreateAccountsTrackingsByAccountIdResponse,
    CreateAccountsTrackingsByAccountIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateAccountsTrackingsByAccountIdBody,
    CreateAccountsTrackingsByAccountIdResponse,
    CreateAccountsTrackingsByAccountIdParams
  >("accounts", "/:accountId/trackings", "POST", options);
}

export function useUpdateAccountsTrackingsByAccountIdByTrackingId(
  options?: CustomMutationOptions<
    UpdateAccountsTrackingsByAccountIdByTrackingIdBody,
    UpdateAccountsTrackingsByAccountIdByTrackingIdResponse,
    UpdateAccountsTrackingsByAccountIdByTrackingIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateAccountsTrackingsByAccountIdByTrackingIdBody,
    UpdateAccountsTrackingsByAccountIdByTrackingIdResponse,
    UpdateAccountsTrackingsByAccountIdByTrackingIdParams
  >("accounts", "/:accountId/trackings/:trackingId", "PATCH", options);
}

export function useDeleteAccountsTrackingsByAccountIdByTrackingId(
  options?: CustomMutationOptions<
    unknown,
    DeleteAccountsTrackingsByAccountIdByTrackingIdResponse,
    DeleteAccountsTrackingsByAccountIdByTrackingIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteAccountsTrackingsByAccountIdByTrackingIdResponse,
    DeleteAccountsTrackingsByAccountIdByTrackingIdParams
  >("accounts", "/:accountId/trackings/:trackingId", "DELETE", options);
}

export function useGetAccountsByAccountId(
  params: GetAccountsByAccountIdParams,
): CustomQueryBuilder<
  GetAccountsByAccountIdResponse,
  GetAccountsByAccountIdParams
> {
  return useResourceCustomQuery<
    GetAccountsByAccountIdResponse,
    GetAccountsByAccountIdParams
  >("accounts", "/:accountId", params);
}

export function useUpdateAccountsByAccountId(
  options?: CustomMutationOptions<
    UpdateAccountsByAccountIdBody,
    UpdateAccountsByAccountIdResponse,
    UpdateAccountsByAccountIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateAccountsByAccountIdBody,
    UpdateAccountsByAccountIdResponse,
    UpdateAccountsByAccountIdParams
  >("accounts", "/:accountId", "PUT", options);
}

export function useDeleteAccountsByAccountId(
  options?: CustomMutationOptions<
    DeleteAccountsByAccountIdBody,
    DeleteAccountsByAccountIdResponse,
    DeleteAccountsByAccountIdParams
  >,
) {
  return useResourceCustomMutation<
    DeleteAccountsByAccountIdBody,
    DeleteAccountsByAccountIdResponse,
    DeleteAccountsByAccountIdParams
  >("accounts", "/:accountId", "DELETE", options);
}

// ============================================================================
// Ai Resource
// ============================================================================

export function useGetAiFeedbackList() {
  return useListQuery<
    GetAiFeedbackListItem,
    GetAiFeedbackListResponse,
    GetAiFeedbackListFilters
  >("ai", "/feedback/list");
}

export function useGetAiFeedbackByAiFeedbackId(
  params: GetAiFeedbackByAiFeedbackIdParams,
): CustomQueryBuilder<
  GetAiFeedbackByAiFeedbackIdResponse,
  GetAiFeedbackByAiFeedbackIdParams
> {
  return useResourceCustomQuery<
    GetAiFeedbackByAiFeedbackIdResponse,
    GetAiFeedbackByAiFeedbackIdParams
  >("ai", "/feedback/:aiFeedbackId", params);
}

export function useUpdateAiFeedbackByAiFeedbackId(
  options?: CustomMutationOptions<
    UpdateAiFeedbackByAiFeedbackIdBody,
    UpdateAiFeedbackByAiFeedbackIdResponse,
    UpdateAiFeedbackByAiFeedbackIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateAiFeedbackByAiFeedbackIdBody,
    UpdateAiFeedbackByAiFeedbackIdResponse,
    UpdateAiFeedbackByAiFeedbackIdParams
  >("ai", "/feedback/:aiFeedbackId", "PATCH", options);
}

export function useGetAiJobsByAiJobId(
  params: GetAiJobsByAiJobIdParams,
): CustomQueryBuilder<GetAiJobsByAiJobIdResponse, GetAiJobsByAiJobIdParams> {
  return useResourceCustomQuery<
    GetAiJobsByAiJobIdResponse,
    GetAiJobsByAiJobIdParams
  >("ai", "/jobs/:aiJobId", params);
}

// ============================================================================
// Analytics Resource
// ============================================================================

export function useGetAnalyticsMemberActivationRoster(): CustomQueryBuilder<
  GetAnalyticsMemberActivationRosterResponse,
  Record<string, string>,
  GetAnalyticsMemberActivationRosterQuery,
  GetAnalyticsMemberActivationRosterExtra
> {
  return useResourceCustomQuery<
    GetAnalyticsMemberActivationRosterResponse,
    Record<string, string>,
    GetAnalyticsMemberActivationRosterQuery,
    GetAnalyticsMemberActivationRosterExtra
  >("analytics", "/member-activation/roster");
}

export function useGetAnalyticsMemberActivationSummary(): CustomQueryBuilder<
  GetAnalyticsMemberActivationSummaryResponse,
  Record<string, string>,
  GetAnalyticsMemberActivationSummaryQuery
> {
  return useResourceCustomQuery<
    GetAnalyticsMemberActivationSummaryResponse,
    Record<string, string>,
    GetAnalyticsMemberActivationSummaryQuery
  >("analytics", "/member-activation/summary");
}

export function useCreateAnalyticsMemberActivationActivation(
  options?: CustomMutationOptions<
    CreateAnalyticsMemberActivationActivationBody,
    CreateAnalyticsMemberActivationActivationResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAnalyticsMemberActivationActivationBody,
    CreateAnalyticsMemberActivationActivationResponse
  >("analytics", "/member-activation/activation", "POST", options);
}

export function useGetAnalyticsRenewals(): CustomQueryBuilder<
  GetAnalyticsRenewalsResponse,
  Record<string, string>,
  GetAnalyticsRenewalsQuery
> {
  return useResourceCustomQuery<
    GetAnalyticsRenewalsResponse,
    Record<string, string>,
    GetAnalyticsRenewalsQuery
  >("analytics", "/renewals");
}

export function useGetAnalyticsRenewalsFirstAnniversaries(): CustomQueryBuilder<
  GetAnalyticsRenewalsFirstAnniversariesResponse,
  Record<string, string>,
  GetAnalyticsRenewalsFirstAnniversariesQuery
> {
  return useResourceCustomQuery<
    GetAnalyticsRenewalsFirstAnniversariesResponse,
    Record<string, string>,
    GetAnalyticsRenewalsFirstAnniversariesQuery
  >("analytics", "/renewals/first-anniversaries");
}

export function useGetAnalyticsVendorScorecard(): CustomQueryBuilder<GetAnalyticsVendorScorecardResponse> {
  return useResourceCustomQuery<GetAnalyticsVendorScorecardResponse>(
    "analytics",
    "/vendor-scorecard",
  );
}

export function useGetAnalyticsConfirmedChurn(): CustomQueryBuilder<GetAnalyticsConfirmedChurnResponse> {
  return useResourceCustomQuery<GetAnalyticsConfirmedChurnResponse>(
    "analytics",
    "/confirmed-churn",
  );
}

// ============================================================================
// Attachments Resource
// ============================================================================

export function useGetAttachmentsByAttachmentId(
  params: GetAttachmentsByAttachmentIdParams,
): CustomQueryBuilder<
  GetAttachmentsByAttachmentIdResponse,
  GetAttachmentsByAttachmentIdParams
> {
  return useResourceCustomQuery<
    GetAttachmentsByAttachmentIdResponse,
    GetAttachmentsByAttachmentIdParams
  >("attachments", "/:attachmentId", params);
}

// ============================================================================
// Auth Resource
// ============================================================================

export function useGetAuthMe(): CustomQueryBuilder<
  GetAuthMeResponse,
  Record<string, string>,
  GetAuthMeQuery
> {
  return useResourceCustomQuery<
    GetAuthMeResponse,
    Record<string, string>,
    GetAuthMeQuery
  >("auth", "/me");
}

export function useCreateAuthGetSignInToken(
  options?: CustomMutationOptions<
    CreateAuthGetSignInTokenBody,
    CreateAuthGetSignInTokenResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAuthGetSignInTokenBody,
    CreateAuthGetSignInTokenResponse
  >("auth", "/get-sign-in-token", "POST", options);
}

export function useCreateAuthCreateSessionToken(
  options?: CustomMutationOptions<
    CreateAuthCreateSessionTokenBody,
    CreateAuthCreateSessionTokenResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAuthCreateSessionTokenBody,
    CreateAuthCreateSessionTokenResponse
  >("auth", "/create-session-token", "POST", options);
}

export function useCreateAuthResolveUserToken(
  options?: CustomMutationOptions<
    CreateAuthResolveUserTokenBody,
    CreateAuthResolveUserTokenResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAuthResolveUserTokenBody,
    CreateAuthResolveUserTokenResponse
  >("auth", "/resolve-user-token", "POST", options);
}

export function useCreateAuthScopedToken(
  options?: CustomMutationOptions<
    CreateAuthScopedTokenBody,
    CreateAuthScopedTokenResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAuthScopedTokenBody,
    CreateAuthScopedTokenResponse
  >("auth", "/scoped-token", "POST", options);
}

export function useCreateAuthImpersonate(
  options?: CustomMutationOptions<
    CreateAuthImpersonateBody,
    CreateAuthImpersonateResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAuthImpersonateBody,
    CreateAuthImpersonateResponse
  >("auth", "/impersonate", "POST", options);
}

export function useCreateAuthChangePassword(
  options?: CustomMutationOptions<
    CreateAuthChangePasswordBody,
    CreateAuthChangePasswordResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAuthChangePasswordBody,
    CreateAuthChangePasswordResponse
  >("auth", "/change-password", "POST", options);
}

export function useCreateAuthChangeEmail(
  options?: CustomMutationOptions<
    CreateAuthChangeEmailBody,
    CreateAuthChangeEmailResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAuthChangeEmailBody,
    CreateAuthChangeEmailResponse
  >("auth", "/change-email", "POST", options);
}

export function useCreateAuthChangeEmailVerify(
  options?: CustomMutationOptions<
    CreateAuthChangeEmailVerifyBody,
    CreateAuthChangeEmailVerifyResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAuthChangeEmailVerifyBody,
    CreateAuthChangeEmailVerifyResponse
  >("auth", "/change-email/verify", "POST", options);
}

export function useCreateAuthPublicVerifyPhoneNumber(
  options?: CustomMutationOptions<
    CreateAuthPublicVerifyPhoneNumberBody,
    CreateAuthPublicVerifyPhoneNumberResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAuthPublicVerifyPhoneNumberBody,
    CreateAuthPublicVerifyPhoneNumberResponse
  >("auth", "/public-verify-phone-number", "POST", options);
}

export function useCreateAuthActivate(
  options?: CustomMutationOptions<
    CreateAuthActivateBody,
    CreateAuthActivateResponse
  >,
) {
  return useResourceCustomMutation<
    CreateAuthActivateBody,
    CreateAuthActivateResponse
  >("auth", "/activate", "POST", options);
}

// ============================================================================
// Billing Resource
// ============================================================================

export function useGetBillingPaymentMethodsByPaymentMethodId(
  params: GetBillingPaymentMethodsByPaymentMethodIdParams,
): CustomQueryBuilder<
  GetBillingPaymentMethodsByPaymentMethodIdResponse,
  GetBillingPaymentMethodsByPaymentMethodIdParams
> {
  return useResourceCustomQuery<
    GetBillingPaymentMethodsByPaymentMethodIdResponse,
    GetBillingPaymentMethodsByPaymentMethodIdParams
  >("billing", "/payment-methods/:paymentMethodId", params);
}

export function useCreateBillingPaymentMethodsSetupIntent(
  options?: CustomMutationOptions<
    unknown,
    CreateBillingPaymentMethodsSetupIntentResponse
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateBillingPaymentMethodsSetupIntentResponse
  >("billing", "/payment-methods/setup-intent", "POST", options);
}

export function useCreateBillingPaymentMethodsDetachByPaymentMethodId(
  options?: CustomMutationOptions<
    unknown,
    CreateBillingPaymentMethodsDetachByPaymentMethodIdResponse,
    CreateBillingPaymentMethodsDetachByPaymentMethodIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateBillingPaymentMethodsDetachByPaymentMethodIdResponse,
    CreateBillingPaymentMethodsDetachByPaymentMethodIdParams
  >("billing", "/payment-methods/:paymentMethodId/detach", "POST", options);
}

export function useCreateBillingPaymentMethodsSetDefaultByPaymentMethodId(
  options?: CustomMutationOptions<
    CreateBillingPaymentMethodsSetDefaultByPaymentMethodIdBody,
    CreateBillingPaymentMethodsSetDefaultByPaymentMethodIdResponse,
    CreateBillingPaymentMethodsSetDefaultByPaymentMethodIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateBillingPaymentMethodsSetDefaultByPaymentMethodIdBody,
    CreateBillingPaymentMethodsSetDefaultByPaymentMethodIdResponse,
    CreateBillingPaymentMethodsSetDefaultByPaymentMethodIdParams
  >(
    "billing",
    "/payment-methods/:paymentMethodId/set-default",
    "POST",
    options,
  );
}

export function useCreateBillingSubscriptionPaymentMethodsSetDefaultByPaymentMethodId(
  options?: CustomMutationOptions<
    CreateBillingSubscriptionPaymentMethodsSetDefaultByPaymentMethodIdBody,
    CreateBillingSubscriptionPaymentMethodsSetDefaultByPaymentMethodIdResponse,
    CreateBillingSubscriptionPaymentMethodsSetDefaultByPaymentMethodIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateBillingSubscriptionPaymentMethodsSetDefaultByPaymentMethodIdBody,
    CreateBillingSubscriptionPaymentMethodsSetDefaultByPaymentMethodIdResponse,
    CreateBillingSubscriptionPaymentMethodsSetDefaultByPaymentMethodIdParams
  >(
    "billing",
    "/subscription/payment-methods/:paymentMethodId/set-default",
    "POST",
    options,
  );
}

export function useCreateBillingOrderPaymentMethodsSetDefaultByPaymentMethodId(
  options?: CustomMutationOptions<
    CreateBillingOrderPaymentMethodsSetDefaultByPaymentMethodIdBody,
    CreateBillingOrderPaymentMethodsSetDefaultByPaymentMethodIdResponse,
    CreateBillingOrderPaymentMethodsSetDefaultByPaymentMethodIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateBillingOrderPaymentMethodsSetDefaultByPaymentMethodIdBody,
    CreateBillingOrderPaymentMethodsSetDefaultByPaymentMethodIdResponse,
    CreateBillingOrderPaymentMethodsSetDefaultByPaymentMethodIdParams
  >(
    "billing",
    "/order/payment-methods/:paymentMethodId/set-default",
    "POST",
    options,
  );
}

export function useGetBillingPaymentHistoriesByPaymentId(
  params: GetBillingPaymentHistoriesByPaymentIdParams,
): CustomQueryBuilder<
  GetBillingPaymentHistoriesByPaymentIdResponse,
  GetBillingPaymentHistoriesByPaymentIdParams
> {
  return useResourceCustomQuery<
    GetBillingPaymentHistoriesByPaymentIdResponse,
    GetBillingPaymentHistoriesByPaymentIdParams
  >("billing", "/payment-histories/:paymentId", params);
}

export function useGetBillingPaymentMethodsByAccountId(
  params: GetBillingPaymentMethodsByAccountIdParams,
): CustomQueryBuilder<
  GetBillingPaymentMethodsByAccountIdResponse,
  GetBillingPaymentMethodsByAccountIdParams,
  GetBillingPaymentMethodsByAccountIdQuery,
  GetBillingPaymentMethodsByAccountIdExtra
> {
  return useResourceCustomQuery<
    GetBillingPaymentMethodsByAccountIdResponse,
    GetBillingPaymentMethodsByAccountIdParams,
    GetBillingPaymentMethodsByAccountIdQuery,
    GetBillingPaymentMethodsByAccountIdExtra
  >("billing", "/:accountId/payment-methods", params);
}

export function useGetBillingPaymentHistoriesByAccountId(
  params: GetBillingPaymentHistoriesByAccountIdParams,
): CustomQueryBuilder<
  GetBillingPaymentHistoriesByAccountIdResponse,
  GetBillingPaymentHistoriesByAccountIdParams,
  GetBillingPaymentHistoriesByAccountIdQuery,
  GetBillingPaymentHistoriesByAccountIdExtra
> {
  return useResourceCustomQuery<
    GetBillingPaymentHistoriesByAccountIdResponse,
    GetBillingPaymentHistoriesByAccountIdParams,
    GetBillingPaymentHistoriesByAccountIdQuery,
    GetBillingPaymentHistoriesByAccountIdExtra
  >("billing", "/:accountId/payment-histories", params);
}

export function useGetBillingInvoicesByInvoiceId(
  params: GetBillingInvoicesByInvoiceIdParams,
): CustomQueryBuilder<
  GetBillingInvoicesByInvoiceIdResponse,
  GetBillingInvoicesByInvoiceIdParams
> {
  return useResourceCustomQuery<
    GetBillingInvoicesByInvoiceIdResponse,
    GetBillingInvoicesByInvoiceIdParams
  >("billing", "/invoices/:invoiceId", params);
}

export function useGetBillingInvoicesByAccountId(
  params: GetBillingInvoicesByAccountIdParams,
): CustomQueryBuilder<
  GetBillingInvoicesByAccountIdResponse,
  GetBillingInvoicesByAccountIdParams,
  GetBillingInvoicesByAccountIdQuery,
  GetBillingInvoicesByAccountIdExtra
> {
  return useResourceCustomQuery<
    GetBillingInvoicesByAccountIdResponse,
    GetBillingInvoicesByAccountIdParams,
    GetBillingInvoicesByAccountIdQuery,
    GetBillingInvoicesByAccountIdExtra
  >("billing", "/:accountId/invoices", params);
}

// ============================================================================
// BillingTodo Resource
// ============================================================================

export function useGetBillingTodoSections(): CustomQueryBuilder<GetBillingTodoSectionsResponse> {
  return useResourceCustomQuery<GetBillingTodoSectionsResponse>(
    "billing-todo",
    "/sections",
  );
}

// ============================================================================
// Birdie Resource
// ============================================================================

export function useGetBirdieAudience(): CustomQueryBuilder<GetBirdieAudienceResponse> {
  return useResourceCustomQuery<GetBirdieAudienceResponse>(
    "birdie",
    "/audience",
  );
}

// ============================================================================
// Campaigns Resource
// ============================================================================

export function useGetCampaignsList() {
  return useListQuery<
    GetCampaignsListItem,
    GetCampaignsListResponse,
    GetCampaignsListFilters
  >("campaigns", "/list");
}

export function useGetCampaignsByCampaignId(
  params: GetCampaignsByCampaignIdParams,
): CustomQueryBuilder<
  GetCampaignsByCampaignIdResponse,
  GetCampaignsByCampaignIdParams
> {
  return useResourceCustomQuery<
    GetCampaignsByCampaignIdResponse,
    GetCampaignsByCampaignIdParams
  >("campaigns", "/:campaignId", params);
}

export function useUpdateCampaignsByCampaignId(
  options?: CustomMutationOptions<
    UpdateCampaignsByCampaignIdBody,
    UpdateCampaignsByCampaignIdResponse,
    UpdateCampaignsByCampaignIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateCampaignsByCampaignIdBody,
    UpdateCampaignsByCampaignIdResponse,
    UpdateCampaignsByCampaignIdParams
  >("campaigns", "/:campaignId", "PATCH", options);
}

export function useDeleteCampaignsByCampaignId(
  options?: CustomMutationOptions<
    unknown,
    DeleteCampaignsByCampaignIdResponse,
    DeleteCampaignsByCampaignIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteCampaignsByCampaignIdResponse,
    DeleteCampaignsByCampaignIdParams
  >("campaigns", "/:campaignId", "DELETE", options);
}

export function useCreateCampaignsAll(
  options?: CustomMutationOptions<
    CreateCampaignsAllBody,
    CreateCampaignsAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateCampaignsAllBody,
    CreateCampaignsAllResponse
  >("campaigns", "", "POST", options);
}

export function useCreateCampaignsPushByCampaignId(
  options?: CustomMutationOptions<
    CreateCampaignsPushByCampaignIdBody,
    CreateCampaignsPushByCampaignIdResponse,
    CreateCampaignsPushByCampaignIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateCampaignsPushByCampaignIdBody,
    CreateCampaignsPushByCampaignIdResponse,
    CreateCampaignsPushByCampaignIdParams
  >("campaigns", "/:campaignId/push", "POST", options);
}

// ============================================================================
// CatalogItems Resource
// ============================================================================

export function useGetCatalogItemsAll(): CustomQueryBuilder<
  GetCatalogItemsAllResponse,
  Record<string, string>,
  GetCatalogItemsAllQuery
> {
  return useResourceCustomQuery<
    GetCatalogItemsAllResponse,
    Record<string, string>,
    GetCatalogItemsAllQuery
  >("catalog-items", "");
}

// ============================================================================
// CatalogNew Resource
// ============================================================================

export function useGetCatalogNewGroupsList() {
  return useListQuery<
    GetCatalogNewGroupsListItem,
    GetCatalogNewGroupsListResponse,
    GetCatalogNewGroupsListFilters
  >("catalog-new", "/groups/list");
}

export function useGetCatalogNewGroupsByGroupId(
  params: GetCatalogNewGroupsByGroupIdParams,
): CustomQueryBuilder<
  GetCatalogNewGroupsByGroupIdResponse,
  GetCatalogNewGroupsByGroupIdParams
> {
  return useResourceCustomQuery<
    GetCatalogNewGroupsByGroupIdResponse,
    GetCatalogNewGroupsByGroupIdParams
  >("catalog-new", "/groups/:groupId", params);
}

export function useUpdateCatalogNewGroupsByGroupId(
  options?: CustomMutationOptions<
    UpdateCatalogNewGroupsByGroupIdBody,
    UpdateCatalogNewGroupsByGroupIdResponse,
    UpdateCatalogNewGroupsByGroupIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateCatalogNewGroupsByGroupIdBody,
    UpdateCatalogNewGroupsByGroupIdResponse,
    UpdateCatalogNewGroupsByGroupIdParams
  >("catalog-new", "/groups/:groupId", "PATCH", options);
}

export function useDeleteCatalogNewGroupsByGroupId(
  options?: CustomMutationOptions<
    unknown,
    DeleteCatalogNewGroupsByGroupIdResponse,
    DeleteCatalogNewGroupsByGroupIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteCatalogNewGroupsByGroupIdResponse,
    DeleteCatalogNewGroupsByGroupIdParams
  >("catalog-new", "/groups/:groupId", "DELETE", options);
}

export function useCreateCatalogNewGroupsAll(
  options?: CustomMutationOptions<
    CreateCatalogNewGroupsAllBody,
    CreateCatalogNewGroupsAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateCatalogNewGroupsAllBody,
    CreateCatalogNewGroupsAllResponse
  >("catalog-new", "/groups", "POST", options);
}

export function useGetCatalogNewItemsList() {
  return useListQuery<
    GetCatalogNewItemsListItem,
    GetCatalogNewItemsListResponse,
    GetCatalogNewItemsListFilters
  >("catalog-new", "/items/list");
}

export function useGetCatalogNewItemsByCatalogItemId(
  params: GetCatalogNewItemsByCatalogItemIdParams,
): CustomQueryBuilder<
  GetCatalogNewItemsByCatalogItemIdResponse,
  GetCatalogNewItemsByCatalogItemIdParams
> {
  return useResourceCustomQuery<
    GetCatalogNewItemsByCatalogItemIdResponse,
    GetCatalogNewItemsByCatalogItemIdParams
  >("catalog-new", "/items/:catalogItemId", params);
}

export function useUpdateCatalogNewItemsByCatalogItemId(
  options?: CustomMutationOptions<
    UpdateCatalogNewItemsByCatalogItemIdBody,
    UpdateCatalogNewItemsByCatalogItemIdResponse,
    UpdateCatalogNewItemsByCatalogItemIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateCatalogNewItemsByCatalogItemIdBody,
    UpdateCatalogNewItemsByCatalogItemIdResponse,
    UpdateCatalogNewItemsByCatalogItemIdParams
  >("catalog-new", "/items/:catalogItemId", "PATCH", options);
}

export function useDeleteCatalogNewItemsByCatalogItemId(
  options?: CustomMutationOptions<
    unknown,
    DeleteCatalogNewItemsByCatalogItemIdResponse,
    DeleteCatalogNewItemsByCatalogItemIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteCatalogNewItemsByCatalogItemIdResponse,
    DeleteCatalogNewItemsByCatalogItemIdParams
  >("catalog-new", "/items/:catalogItemId", "DELETE", options);
}

export function useGetCatalogNewItemsLineItemsByCatalogItemId(
  params: GetCatalogNewItemsLineItemsByCatalogItemIdParams,
): CustomQueryBuilder<
  GetCatalogNewItemsLineItemsByCatalogItemIdResponse,
  GetCatalogNewItemsLineItemsByCatalogItemIdParams,
  GetCatalogNewItemsLineItemsByCatalogItemIdQuery,
  GetCatalogNewItemsLineItemsByCatalogItemIdExtra
> {
  return useResourceCustomQuery<
    GetCatalogNewItemsLineItemsByCatalogItemIdResponse,
    GetCatalogNewItemsLineItemsByCatalogItemIdParams,
    GetCatalogNewItemsLineItemsByCatalogItemIdQuery,
    GetCatalogNewItemsLineItemsByCatalogItemIdExtra
  >("catalog-new", "/items/:catalogItemId/line-items", params);
}

export function useGetCatalogNewItemsRelationsByCatalogItemId(
  params: GetCatalogNewItemsRelationsByCatalogItemIdParams,
): CustomQueryBuilder<
  GetCatalogNewItemsRelationsByCatalogItemIdResponse,
  GetCatalogNewItemsRelationsByCatalogItemIdParams
> {
  return useResourceCustomQuery<
    GetCatalogNewItemsRelationsByCatalogItemIdResponse,
    GetCatalogNewItemsRelationsByCatalogItemIdParams
  >("catalog-new", "/items/:catalogItemId/relations", params);
}

export function useCreateCatalogNewItemsRelationsByCatalogItemId(
  options?: CustomMutationOptions<
    CreateCatalogNewItemsRelationsByCatalogItemIdBody,
    CreateCatalogNewItemsRelationsByCatalogItemIdResponse,
    CreateCatalogNewItemsRelationsByCatalogItemIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateCatalogNewItemsRelationsByCatalogItemIdBody,
    CreateCatalogNewItemsRelationsByCatalogItemIdResponse,
    CreateCatalogNewItemsRelationsByCatalogItemIdParams
  >("catalog-new", "/items/:catalogItemId/relations", "POST", options);
}

export function useUpdateCatalogNewItemsRelationsByCatalogItemIdByRelationId(
  options?: CustomMutationOptions<
    UpdateCatalogNewItemsRelationsByCatalogItemIdByRelationIdBody,
    UpdateCatalogNewItemsRelationsByCatalogItemIdByRelationIdResponse,
    UpdateCatalogNewItemsRelationsByCatalogItemIdByRelationIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateCatalogNewItemsRelationsByCatalogItemIdByRelationIdBody,
    UpdateCatalogNewItemsRelationsByCatalogItemIdByRelationIdResponse,
    UpdateCatalogNewItemsRelationsByCatalogItemIdByRelationIdParams
  >(
    "catalog-new",
    "/items/:catalogItemId/relations/:relationId",
    "PATCH",
    options,
  );
}

export function useDeleteCatalogNewItemsRelationsByCatalogItemIdByRelationId(
  options?: CustomMutationOptions<
    unknown,
    DeleteCatalogNewItemsRelationsByCatalogItemIdByRelationIdResponse,
    DeleteCatalogNewItemsRelationsByCatalogItemIdByRelationIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteCatalogNewItemsRelationsByCatalogItemIdByRelationIdResponse,
    DeleteCatalogNewItemsRelationsByCatalogItemIdByRelationIdParams
  >(
    "catalog-new",
    "/items/:catalogItemId/relations/:relationId",
    "DELETE",
    options,
  );
}

export function useCreateCatalogNewItemsAll(
  options?: CustomMutationOptions<
    CreateCatalogNewItemsAllBody,
    CreateCatalogNewItemsAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateCatalogNewItemsAllBody,
    CreateCatalogNewItemsAllResponse
  >("catalog-new", "/items", "POST", options);
}

export function useGetCatalogNewMarketRatesList() {
  return useListQuery<
    GetCatalogNewMarketRatesListItem,
    GetCatalogNewMarketRatesListResponse,
    GetCatalogNewMarketRatesListFilters
  >("catalog-new", "/market-rates/list");
}

export function useGetCatalogNewMarketRatesByMarketRateId(
  params: GetCatalogNewMarketRatesByMarketRateIdParams,
): CustomQueryBuilder<
  GetCatalogNewMarketRatesByMarketRateIdResponse,
  GetCatalogNewMarketRatesByMarketRateIdParams
> {
  return useResourceCustomQuery<
    GetCatalogNewMarketRatesByMarketRateIdResponse,
    GetCatalogNewMarketRatesByMarketRateIdParams
  >("catalog-new", "/market-rates/:marketRateId", params);
}

export function useUpdateCatalogNewMarketRatesByMarketRateId(
  options?: CustomMutationOptions<
    UpdateCatalogNewMarketRatesByMarketRateIdBody,
    UpdateCatalogNewMarketRatesByMarketRateIdResponse,
    UpdateCatalogNewMarketRatesByMarketRateIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateCatalogNewMarketRatesByMarketRateIdBody,
    UpdateCatalogNewMarketRatesByMarketRateIdResponse,
    UpdateCatalogNewMarketRatesByMarketRateIdParams
  >("catalog-new", "/market-rates/:marketRateId", "PATCH", options);
}

export function useDeleteCatalogNewMarketRatesByMarketRateId(
  options?: CustomMutationOptions<
    unknown,
    DeleteCatalogNewMarketRatesByMarketRateIdResponse,
    DeleteCatalogNewMarketRatesByMarketRateIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteCatalogNewMarketRatesByMarketRateIdResponse,
    DeleteCatalogNewMarketRatesByMarketRateIdParams
  >("catalog-new", "/market-rates/:marketRateId", "DELETE", options);
}

export function useCreateCatalogNewMarketRatesAll(
  options?: CustomMutationOptions<
    CreateCatalogNewMarketRatesAllBody,
    CreateCatalogNewMarketRatesAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateCatalogNewMarketRatesAllBody,
    CreateCatalogNewMarketRatesAllResponse
  >("catalog-new", "/market-rates", "POST", options);
}

// ============================================================================
// Categories Resource
// ============================================================================

export function useGetCategoriesAll(): CustomQueryBuilder<
  GetCategoriesAllResponse,
  Record<string, string>,
  GetCategoriesAllQuery,
  GetCategoriesAllExtra
> {
  return useResourceCustomQuery<
    GetCategoriesAllResponse,
    Record<string, string>,
    GetCategoriesAllQuery,
    GetCategoriesAllExtra
  >("categories", "");
}

// ============================================================================
// Channels Resource
// ============================================================================

export function useGetChannelsInbox() {
  return useListQuery<
    GetChannelsInboxItem,
    GetChannelsInboxResponse,
    GetChannelsInboxFilters
  >("channels", "/inbox");
}

export function useGetChannelsInboxPlaces() {
  return useListQuery<
    GetChannelsInboxPlacesItem,
    GetChannelsInboxPlacesResponse,
    GetChannelsInboxPlacesFilters
  >("channels", "/inbox/places");
}

export function useGetChannelsInboxCustomers() {
  return useListQuery<
    GetChannelsInboxCustomersItem,
    GetChannelsInboxCustomersResponse,
    GetChannelsInboxCustomersFilters
  >("channels", "/inbox/customers");
}

export function useGetChannelsInboxCounts(): CustomQueryBuilder<
  GetChannelsInboxCountsResponse,
  Record<string, string>,
  GetChannelsInboxCountsQuery
> {
  return useResourceCustomQuery<
    GetChannelsInboxCountsResponse,
    Record<string, string>,
    GetChannelsInboxCountsQuery
  >("channels", "/inbox/counts");
}

export function useCreateChannelsSupport(
  options?: CustomMutationOptions<
    CreateChannelsSupportBody,
    CreateChannelsSupportResponse
  >,
) {
  return useResourceCustomMutation<
    CreateChannelsSupportBody,
    CreateChannelsSupportResponse
  >("channels", "/support", "POST", options);
}

export function useGetChannelsByCid(
  params: GetChannelsByCidParams,
): CustomQueryBuilder<
  GetChannelsByCidResponse,
  GetChannelsByCidParams,
  GetChannelsByCidQuery
> {
  return useResourceCustomQuery<
    GetChannelsByCidResponse,
    GetChannelsByCidParams,
    GetChannelsByCidQuery
  >("channels", "/:cid", params);
}

export function useGetChannelsMembersByCid(
  params: GetChannelsMembersByCidParams,
): CustomQueryBuilder<
  GetChannelsMembersByCidResponse,
  GetChannelsMembersByCidParams,
  Record<string, unknown>,
  GetChannelsMembersByCidExtra
> {
  return useResourceCustomQuery<
    GetChannelsMembersByCidResponse,
    GetChannelsMembersByCidParams,
    Record<string, unknown>,
    GetChannelsMembersByCidExtra
  >("channels", "/:cid/members", params);
}

export function useGetChannelsMessagesByCid(
  params: GetChannelsMessagesByCidParams,
): CustomQueryBuilder<
  GetChannelsMessagesByCidResponse,
  GetChannelsMessagesByCidParams,
  GetChannelsMessagesByCidQuery,
  GetChannelsMessagesByCidExtra
> {
  return useResourceCustomQuery<
    GetChannelsMessagesByCidResponse,
    GetChannelsMessagesByCidParams,
    GetChannelsMessagesByCidQuery,
    GetChannelsMessagesByCidExtra
  >("channels", "/:cid/messages", params);
}

export function useCreateChannelsMessagesByCid(
  options?: CustomMutationOptions<
    CreateChannelsMessagesByCidBody,
    CreateChannelsMessagesByCidResponse,
    CreateChannelsMessagesByCidParams
  >,
) {
  return useResourceCustomMutation<
    CreateChannelsMessagesByCidBody,
    CreateChannelsMessagesByCidResponse,
    CreateChannelsMessagesByCidParams
  >("channels", "/:cid/messages", "POST", options);
}

export function useUpdateChannelsMessagesByCidByMessageId(
  options?: CustomMutationOptions<
    UpdateChannelsMessagesByCidByMessageIdBody,
    UpdateChannelsMessagesByCidByMessageIdResponse,
    UpdateChannelsMessagesByCidByMessageIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateChannelsMessagesByCidByMessageIdBody,
    UpdateChannelsMessagesByCidByMessageIdResponse,
    UpdateChannelsMessagesByCidByMessageIdParams
  >("channels", "/:cid/messages/:messageId", "PATCH", options);
}

export function useDeleteChannelsMessagesByCidByMessageId(
  options?: CustomMutationOptions<
    unknown,
    DeleteChannelsMessagesByCidByMessageIdResponse,
    DeleteChannelsMessagesByCidByMessageIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteChannelsMessagesByCidByMessageIdResponse,
    DeleteChannelsMessagesByCidByMessageIdParams
  >("channels", "/:cid/messages/:messageId", "DELETE", options);
}

export function useGetChannelsMessagesReadsByCidByMessageId(
  params: GetChannelsMessagesReadsByCidByMessageIdParams,
): CustomQueryBuilder<
  GetChannelsMessagesReadsByCidByMessageIdResponse,
  GetChannelsMessagesReadsByCidByMessageIdParams,
  Record<string, unknown>,
  GetChannelsMessagesReadsByCidByMessageIdExtra
> {
  return useResourceCustomQuery<
    GetChannelsMessagesReadsByCidByMessageIdResponse,
    GetChannelsMessagesReadsByCidByMessageIdParams,
    Record<string, unknown>,
    GetChannelsMessagesReadsByCidByMessageIdExtra
  >("channels", "/:cid/messages/:messageId/reads", params);
}

export function useCreateChannelsMessagesPinByCidByMessageId(
  options?: CustomMutationOptions<
    unknown,
    CreateChannelsMessagesPinByCidByMessageIdResponse,
    CreateChannelsMessagesPinByCidByMessageIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateChannelsMessagesPinByCidByMessageIdResponse,
    CreateChannelsMessagesPinByCidByMessageIdParams
  >("channels", "/:cid/messages/:messageId/pin", "POST", options);
}

export function useDeleteChannelsMessagesPinByCidByMessageId(
  options?: CustomMutationOptions<
    unknown,
    DeleteChannelsMessagesPinByCidByMessageIdResponse,
    DeleteChannelsMessagesPinByCidByMessageIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteChannelsMessagesPinByCidByMessageIdResponse,
    DeleteChannelsMessagesPinByCidByMessageIdParams
  >("channels", "/:cid/messages/:messageId/pin", "DELETE", options);
}

export function useCreateChannelsMessagesReactionsByCidByMessageId(
  options?: CustomMutationOptions<
    CreateChannelsMessagesReactionsByCidByMessageIdBody,
    CreateChannelsMessagesReactionsByCidByMessageIdResponse,
    CreateChannelsMessagesReactionsByCidByMessageIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateChannelsMessagesReactionsByCidByMessageIdBody,
    CreateChannelsMessagesReactionsByCidByMessageIdResponse,
    CreateChannelsMessagesReactionsByCidByMessageIdParams
  >("channels", "/:cid/messages/:messageId/reactions", "POST", options);
}

export function useDeleteChannelsMessagesReactionsByCidByMessageIdByType(
  options?: CustomMutationOptions<
    unknown,
    DeleteChannelsMessagesReactionsByCidByMessageIdByTypeResponse,
    DeleteChannelsMessagesReactionsByCidByMessageIdByTypeParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteChannelsMessagesReactionsByCidByMessageIdByTypeResponse,
    DeleteChannelsMessagesReactionsByCidByMessageIdByTypeParams
  >("channels", "/:cid/messages/:messageId/reactions/:type", "DELETE", options);
}

export function useCreateChannelsReadByCid(
  options?: CustomMutationOptions<
    CreateChannelsReadByCidBody,
    CreateChannelsReadByCidResponse,
    CreateChannelsReadByCidParams
  >,
) {
  return useResourceCustomMutation<
    CreateChannelsReadByCidBody,
    CreateChannelsReadByCidResponse,
    CreateChannelsReadByCidParams
  >("channels", "/:cid/read", "POST", options);
}

export function useCreateChannelsMarkUnreadByCid(
  options?: CustomMutationOptions<
    unknown,
    CreateChannelsMarkUnreadByCidResponse,
    CreateChannelsMarkUnreadByCidParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateChannelsMarkUnreadByCidResponse,
    CreateChannelsMarkUnreadByCidParams
  >("channels", "/:cid/mark-unread", "POST", options);
}

/** @deprecated */
export function useUpdateChannelsMeByCid(
  options?: CustomMutationOptions<
    UpdateChannelsMeByCidBody,
    UpdateChannelsMeByCidResponse,
    UpdateChannelsMeByCidParams
  >,
) {
  return useResourceCustomMutation<
    UpdateChannelsMeByCidBody,
    UpdateChannelsMeByCidResponse,
    UpdateChannelsMeByCidParams
  >("channels", "/:cid/me", "PATCH", options);
}

export function useCreateChannelsArchiveByCid(
  options?: CustomMutationOptions<
    unknown,
    CreateChannelsArchiveByCidResponse,
    CreateChannelsArchiveByCidParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateChannelsArchiveByCidResponse,
    CreateChannelsArchiveByCidParams
  >("channels", "/:cid/archive", "POST", options);
}

export function useDeleteChannelsArchiveByCid(
  options?: CustomMutationOptions<
    unknown,
    DeleteChannelsArchiveByCidResponse,
    DeleteChannelsArchiveByCidParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteChannelsArchiveByCidResponse,
    DeleteChannelsArchiveByCidParams
  >("channels", "/:cid/archive", "DELETE", options);
}

export function useCreateChannelsTypingByCid(
  options?: CustomMutationOptions<
    CreateChannelsTypingByCidBody,
    CreateChannelsTypingByCidResponse,
    CreateChannelsTypingByCidParams
  >,
) {
  return useResourceCustomMutation<
    CreateChannelsTypingByCidBody,
    CreateChannelsTypingByCidResponse,
    CreateChannelsTypingByCidParams
  >("channels", "/:cid/typing", "POST", options);
}

export function useGetChannelsUnreadByCid(
  params: GetChannelsUnreadByCidParams,
): CustomQueryBuilder<
  GetChannelsUnreadByCidResponse,
  GetChannelsUnreadByCidParams
> {
  return useResourceCustomQuery<
    GetChannelsUnreadByCidResponse,
    GetChannelsUnreadByCidParams
  >("channels", "/:cid/unread", params);
}

export function useGetChannelsPromptBlocksByCid(
  params: GetChannelsPromptBlocksByCidParams,
): CustomQueryBuilder<
  GetChannelsPromptBlocksByCidResponse,
  GetChannelsPromptBlocksByCidParams,
  Record<string, unknown>,
  GetChannelsPromptBlocksByCidExtra
> {
  return useResourceCustomQuery<
    GetChannelsPromptBlocksByCidResponse,
    GetChannelsPromptBlocksByCidParams,
    Record<string, unknown>,
    GetChannelsPromptBlocksByCidExtra
  >("channels", "/:cid/prompt-blocks", params);
}

// ============================================================================
// Checkout Resource
// ============================================================================

export function useGetCheckoutCouponsByCouponCode(
  params: GetCheckoutCouponsByCouponCodeParams,
): CustomQueryBuilder<
  GetCheckoutCouponsByCouponCodeResponse,
  GetCheckoutCouponsByCouponCodeParams
> {
  return useResourceCustomQuery<
    GetCheckoutCouponsByCouponCodeResponse,
    GetCheckoutCouponsByCouponCodeParams
  >("checkout", "/coupons/:couponCode", params);
}

export function useGetCheckoutPurchaseIntents(): CustomQueryBuilder<
  GetCheckoutPurchaseIntentsResponse,
  Record<string, string>,
  GetCheckoutPurchaseIntentsQuery
> {
  return useResourceCustomQuery<
    GetCheckoutPurchaseIntentsResponse,
    Record<string, string>,
    GetCheckoutPurchaseIntentsQuery
  >("checkout", "/purchase-intents");
}

export function useCreateCheckoutPay(
  options?: CustomMutationOptions<
    CreateCheckoutPayBody,
    CreateCheckoutPayResponse
  >,
) {
  return useResourceCustomMutation<
    CreateCheckoutPayBody,
    CreateCheckoutPayResponse
  >("checkout", "/pay", "POST", options);
}

export function useGetCheckoutPurchaseIntentsByPurchaseIntentId(
  params: GetCheckoutPurchaseIntentsByPurchaseIntentIdParams,
): CustomQueryBuilder<
  GetCheckoutPurchaseIntentsByPurchaseIntentIdResponse,
  GetCheckoutPurchaseIntentsByPurchaseIntentIdParams
> {
  return useResourceCustomQuery<
    GetCheckoutPurchaseIntentsByPurchaseIntentIdResponse,
    GetCheckoutPurchaseIntentsByPurchaseIntentIdParams
  >("checkout", "/purchase-intents/:purchaseIntentId", params);
}

export function useUpdateCheckoutPurchaseIntentsByPurchaseIntentId(
  options?: CustomMutationOptions<
    UpdateCheckoutPurchaseIntentsByPurchaseIntentIdBody,
    UpdateCheckoutPurchaseIntentsByPurchaseIntentIdResponse,
    UpdateCheckoutPurchaseIntentsByPurchaseIntentIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateCheckoutPurchaseIntentsByPurchaseIntentIdBody,
    UpdateCheckoutPurchaseIntentsByPurchaseIntentIdResponse,
    UpdateCheckoutPurchaseIntentsByPurchaseIntentIdParams
  >("checkout", "/purchase-intents/:purchaseIntentId", "PUT", options);
}

export function useGetCheckoutPurchaseIntentsSetupIntentByPurchaseIntentId(
  params: GetCheckoutPurchaseIntentsSetupIntentByPurchaseIntentIdParams,
): CustomQueryBuilder<
  GetCheckoutPurchaseIntentsSetupIntentByPurchaseIntentIdResponse,
  GetCheckoutPurchaseIntentsSetupIntentByPurchaseIntentIdParams
> {
  return useResourceCustomQuery<
    GetCheckoutPurchaseIntentsSetupIntentByPurchaseIntentIdResponse,
    GetCheckoutPurchaseIntentsSetupIntentByPurchaseIntentIdParams
  >("checkout", "/purchase-intents/:purchaseIntentId/setup-intent", params);
}

// ============================================================================
// CheckoutLinks Resource
// ============================================================================

export function useGetCheckoutLinksList() {
  return useListQuery<
    GetCheckoutLinksListItem,
    GetCheckoutLinksListResponse,
    GetCheckoutLinksListFilters
  >("checkout-links", "/list");
}

export function useCreateCheckoutLinksAll(
  options?: CustomMutationOptions<
    CreateCheckoutLinksAllBody,
    CreateCheckoutLinksAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateCheckoutLinksAllBody,
    CreateCheckoutLinksAllResponse
  >("checkout-links", "", "POST", options);
}

export function useGetCheckoutLinksByCheckoutLinkId(
  params: GetCheckoutLinksByCheckoutLinkIdParams,
): CustomQueryBuilder<
  GetCheckoutLinksByCheckoutLinkIdResponse,
  GetCheckoutLinksByCheckoutLinkIdParams
> {
  return useResourceCustomQuery<
    GetCheckoutLinksByCheckoutLinkIdResponse,
    GetCheckoutLinksByCheckoutLinkIdParams
  >("checkout-links", "/:checkoutLinkId", params);
}

export function useUpdateCheckoutLinksByCheckoutLinkId(
  options?: CustomMutationOptions<
    UpdateCheckoutLinksByCheckoutLinkIdBody,
    UpdateCheckoutLinksByCheckoutLinkIdResponse,
    UpdateCheckoutLinksByCheckoutLinkIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateCheckoutLinksByCheckoutLinkIdBody,
    UpdateCheckoutLinksByCheckoutLinkIdResponse,
    UpdateCheckoutLinksByCheckoutLinkIdParams
  >("checkout-links", "/:checkoutLinkId", "PUT", options);
}

export function useDeleteCheckoutLinksByCheckoutLinkId(
  options?: CustomMutationOptions<
    unknown,
    DeleteCheckoutLinksByCheckoutLinkIdResponse,
    DeleteCheckoutLinksByCheckoutLinkIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteCheckoutLinksByCheckoutLinkIdResponse,
    DeleteCheckoutLinksByCheckoutLinkIdParams
  >("checkout-links", "/:checkoutLinkId", "DELETE", options);
}

export function useGetCheckoutLinksPlanByCheckoutLinkId(
  params: GetCheckoutLinksPlanByCheckoutLinkIdParams,
): CustomQueryBuilder<
  GetCheckoutLinksPlanByCheckoutLinkIdResponse,
  GetCheckoutLinksPlanByCheckoutLinkIdParams
> {
  return useResourceCustomQuery<
    GetCheckoutLinksPlanByCheckoutLinkIdResponse,
    GetCheckoutLinksPlanByCheckoutLinkIdParams
  >("checkout-links", "/:checkoutLinkId/plan", params);
}

// ============================================================================
// Comments Resource
// ============================================================================

export function useGetCommentsByCommentId(
  params: GetCommentsByCommentIdParams,
): CustomQueryBuilder<
  GetCommentsByCommentIdResponse,
  GetCommentsByCommentIdParams
> {
  return useResourceCustomQuery<
    GetCommentsByCommentIdResponse,
    GetCommentsByCommentIdParams
  >("comments", "/:commentId", params);
}

// ============================================================================
// Expenses Resource
// ============================================================================

export function useGetExpensesList() {
  return useListQuery<
    GetExpensesListItem,
    GetExpensesListResponse,
    GetExpensesListFilters
  >("expenses", "/list");
}

export function useCreateExpensesAll(
  options?: CustomMutationOptions<
    CreateExpensesAllBody,
    CreateExpensesAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateExpensesAllBody,
    CreateExpensesAllResponse
  >("expenses", "", "POST", options);
}

export function useCreateExpensesScan(
  options?: CustomMutationOptions<CreateExpensesScanBody, unknown>,
) {
  return useResourceCustomMutation<CreateExpensesScanBody, unknown>(
    "expenses",
    "/scan",
    "POST",
    options,
  );
}

export function useGetExpensesByExpenseId(
  params: GetExpensesByExpenseIdParams,
): CustomQueryBuilder<
  GetExpensesByExpenseIdResponse,
  GetExpensesByExpenseIdParams
> {
  return useResourceCustomQuery<
    GetExpensesByExpenseIdResponse,
    GetExpensesByExpenseIdParams
  >("expenses", "/:expenseId", params);
}

export function useUpdateExpensesByExpenseId(
  options?: CustomMutationOptions<
    UpdateExpensesByExpenseIdBody,
    UpdateExpensesByExpenseIdResponse,
    UpdateExpensesByExpenseIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateExpensesByExpenseIdBody,
    UpdateExpensesByExpenseIdResponse,
    UpdateExpensesByExpenseIdParams
  >("expenses", "/:expenseId", "PATCH", options);
}

export function useDeleteExpensesByExpenseId(
  options?: CustomMutationOptions<
    unknown,
    DeleteExpensesByExpenseIdResponse,
    DeleteExpensesByExpenseIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteExpensesByExpenseIdResponse,
    DeleteExpensesByExpenseIdParams
  >("expenses", "/:expenseId", "DELETE", options);
}

// ============================================================================
// Field Resource
// ============================================================================

export function useGetFieldSchedule(): CustomQueryBuilder<
  GetFieldScheduleResponse,
  Record<string, string>,
  GetFieldScheduleQuery,
  GetFieldScheduleExtra
> {
  return useResourceCustomQuery<
    GetFieldScheduleResponse,
    Record<string, string>,
    GetFieldScheduleQuery,
    GetFieldScheduleExtra
  >("field", "/schedule");
}

export function useGetTechnicianCalendarEvents(): CustomQueryBuilder<
  GetTechnicianCalendarEventsResponse,
  Record<string, string>,
  GetTechnicianCalendarEventsQuery
> {
  return useResourceCustomQuery<
    GetTechnicianCalendarEventsResponse,
    Record<string, string>,
    GetTechnicianCalendarEventsQuery
  >("field", "/events/list");
}

export function useGetFieldConversations() {
  return useListQuery<
    GetFieldConversationsItem,
    GetFieldConversationsResponse,
    GetFieldConversationsFilters
  >("field", "/conversations/list");
}

export function useGetFieldConversationCounts(): CustomQueryBuilder<
  GetFieldConversationCountsResponse,
  Record<string, string>,
  GetFieldConversationCountsQuery
> {
  return useResourceCustomQuery<
    GetFieldConversationCountsResponse,
    Record<string, string>,
    GetFieldConversationCountsQuery
  >("field", "/conversations/counts");
}

export function useReadAllFieldConversations(
  options?: CustomMutationOptions<unknown, ReadAllFieldConversationsResponse>,
) {
  return useResourceCustomMutation<unknown, ReadAllFieldConversationsResponse>(
    "field",
    "/conversations/read-all",
    "POST",
    options,
  );
}

export function useGetFieldOrderAttachments(
  params: GetFieldOrderAttachmentsParams,
): CustomQueryBuilder<
  GetFieldOrderAttachmentsResponse,
  GetFieldOrderAttachmentsParams,
  GetFieldOrderAttachmentsQuery
> {
  return useResourceCustomQuery<
    GetFieldOrderAttachmentsResponse,
    GetFieldOrderAttachmentsParams,
    GetFieldOrderAttachmentsQuery
  >("field", "/orders/:orderId/attachments", params);
}

export function useGetFieldOrderConversation(
  params: GetFieldOrderConversationParams,
): CustomQueryBuilder<
  GetFieldOrderConversationResponse,
  GetFieldOrderConversationParams
> {
  return useResourceCustomQuery<
    GetFieldOrderConversationResponse,
    GetFieldOrderConversationParams
  >("field", "/orders/:orderId/conversation", params);
}

export function useGetFieldVisitsNotifyMemberPreviewByVisitId(
  params: GetFieldVisitsNotifyMemberPreviewByVisitIdParams,
): CustomQueryBuilder<
  GetFieldVisitsNotifyMemberPreviewByVisitIdResponse,
  GetFieldVisitsNotifyMemberPreviewByVisitIdParams,
  GetFieldVisitsNotifyMemberPreviewByVisitIdQuery
> {
  return useResourceCustomQuery<
    GetFieldVisitsNotifyMemberPreviewByVisitIdResponse,
    GetFieldVisitsNotifyMemberPreviewByVisitIdParams,
    GetFieldVisitsNotifyMemberPreviewByVisitIdQuery
  >("field", "/visits/:visitId/notify-member/preview", params);
}

export function useCreateFieldVisitsNotifyMemberByVisitId(
  options?: CustomMutationOptions<
    CreateFieldVisitsNotifyMemberByVisitIdBody,
    CreateFieldVisitsNotifyMemberByVisitIdResponse,
    CreateFieldVisitsNotifyMemberByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateFieldVisitsNotifyMemberByVisitIdBody,
    CreateFieldVisitsNotifyMemberByVisitIdResponse,
    CreateFieldVisitsNotifyMemberByVisitIdParams
  >("field", "/visits/:visitId/notify-member", "POST", options);
}

export function useGetFieldVisitReport(
  params: GetFieldVisitReportParams,
): CustomQueryBuilder<GetFieldVisitReportResponse, GetFieldVisitReportParams> {
  return useResourceCustomQuery<
    GetFieldVisitReportResponse,
    GetFieldVisitReportParams
  >("field", "/visits/:visitId/report/:reportId", params);
}

export function useGetFieldVisitDetail(
  params: GetFieldVisitDetailParams,
): CustomQueryBuilder<GetFieldVisitDetailResponse, GetFieldVisitDetailParams> {
  return useResourceCustomQuery<
    GetFieldVisitDetailResponse,
    GetFieldVisitDetailParams
  >("field", "/visits/:visitId", params);
}

export function useCheckInFieldVisit(
  options?: CustomMutationOptions<
    CheckInFieldVisitBody,
    CheckInFieldVisitResponse,
    CheckInFieldVisitParams
  >,
) {
  return useResourceCustomMutation<
    CheckInFieldVisitBody,
    CheckInFieldVisitResponse,
    CheckInFieldVisitParams
  >("field", "/visits/:visitId/check-in", "POST", options);
}

export function useCheckOutFieldVisit(
  options?: CustomMutationOptions<
    CheckOutFieldVisitBody,
    CheckOutFieldVisitResponse,
    CheckOutFieldVisitParams
  >,
) {
  return useResourceCustomMutation<
    CheckOutFieldVisitBody,
    CheckOutFieldVisitResponse,
    CheckOutFieldVisitParams
  >("field", "/visits/:visitId/check-out", "POST", options);
}

// ============================================================================
// Global Resource
// ============================================================================

export function useGetGlobalOffice(): CustomQueryBuilder<GetGlobalOfficeResponse> {
  return useResourceCustomQuery<GetGlobalOfficeResponse>("global", "/office");
}

export function useGetGlobalSpaces(): CustomQueryBuilder<GetGlobalSpacesResponse> {
  return useResourceCustomQuery<GetGlobalSpacesResponse>("global", "/spaces");
}

// ============================================================================
// Google Resource
// ============================================================================

export function useCreateGoogleConnectCalendar(
  options?: CustomMutationOptions<unknown, CreateGoogleConnectCalendarResponse>,
) {
  return useResourceCustomMutation<
    unknown,
    CreateGoogleConnectCalendarResponse
  >("google", "/connect-calendar", "POST", options);
}

export function useCreateGoogleDisconnectCalendar(
  options?: CustomMutationOptions<
    unknown,
    CreateGoogleDisconnectCalendarResponse
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateGoogleDisconnectCalendarResponse
  >("google", "/disconnect-calendar", "POST", options);
}

export function useDeleteGoogleCalendarAccountsByGoogleTokenId(
  options?: CustomMutationOptions<
    unknown,
    DeleteGoogleCalendarAccountsByGoogleTokenIdResponse,
    DeleteGoogleCalendarAccountsByGoogleTokenIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteGoogleCalendarAccountsByGoogleTokenIdResponse,
    DeleteGoogleCalendarAccountsByGoogleTokenIdParams
  >("google", "/calendar-accounts/:googleTokenId", "DELETE", options);
}

export function useCreateGoogleOauth2callback(
  options?: CustomMutationOptions<
    CreateGoogleOauth2callbackBody,
    CreateGoogleOauth2callbackResponse
  >,
) {
  return useResourceCustomMutation<
    CreateGoogleOauth2callbackBody,
    CreateGoogleOauth2callbackResponse
  >("google", "/oauth2callback", "POST", options);
}

// ============================================================================
// HomecarePlan Resource
// ============================================================================

export function useGetHomecarePlanOrdersProposalByOrderId(
  params: GetHomecarePlanOrdersProposalByOrderIdParams,
): CustomQueryBuilder<
  GetHomecarePlanOrdersProposalByOrderIdResponse,
  GetHomecarePlanOrdersProposalByOrderIdParams
> {
  return useResourceCustomQuery<
    GetHomecarePlanOrdersProposalByOrderIdResponse,
    GetHomecarePlanOrdersProposalByOrderIdParams
  >("homecare-plan", "/orders/:orderId/proposal", params);
}

export function useCreateHomecarePlanOrdersProposalGenerateByOrderId(
  options?: CustomMutationOptions<
    CreateHomecarePlanOrdersProposalGenerateByOrderIdBody,
    CreateHomecarePlanOrdersProposalGenerateByOrderIdResponse,
    CreateHomecarePlanOrdersProposalGenerateByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateHomecarePlanOrdersProposalGenerateByOrderIdBody,
    CreateHomecarePlanOrdersProposalGenerateByOrderIdResponse,
    CreateHomecarePlanOrdersProposalGenerateByOrderIdParams
  >("homecare-plan", "/orders/:orderId/proposal/generate", "POST", options);
}

export function useGetHomecarePlanProposals() {
  return useListQuery<
    GetHomecarePlanProposalsItem,
    GetHomecarePlanProposalsResponse,
    GetHomecarePlanProposalsFilters
  >("homecare-plan", "/proposals");
}

export function useGetHomecarePlanProposalsDetailByProposalId(
  params: GetHomecarePlanProposalsDetailByProposalIdParams,
): CustomQueryBuilder<
  GetHomecarePlanProposalsDetailByProposalIdResponse,
  GetHomecarePlanProposalsDetailByProposalIdParams
> {
  return useResourceCustomQuery<
    GetHomecarePlanProposalsDetailByProposalIdResponse,
    GetHomecarePlanProposalsDetailByProposalIdParams
  >("homecare-plan", "/proposals/:proposalId/detail", params);
}

export function useGetHomecarePlanProposalsByProposalId(
  params: GetHomecarePlanProposalsByProposalIdParams,
): CustomQueryBuilder<
  GetHomecarePlanProposalsByProposalIdResponse,
  GetHomecarePlanProposalsByProposalIdParams
> {
  return useResourceCustomQuery<
    GetHomecarePlanProposalsByProposalIdResponse,
    GetHomecarePlanProposalsByProposalIdParams
  >("homecare-plan", "/proposals/:proposalId", params);
}

export function useUpdateHomecarePlanProposalsByProposalId(
  options?: CustomMutationOptions<
    UpdateHomecarePlanProposalsByProposalIdBody,
    UpdateHomecarePlanProposalsByProposalIdResponse,
    UpdateHomecarePlanProposalsByProposalIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateHomecarePlanProposalsByProposalIdBody,
    UpdateHomecarePlanProposalsByProposalIdResponse,
    UpdateHomecarePlanProposalsByProposalIdParams
  >("homecare-plan", "/proposals/:proposalId", "PATCH", options);
}

export function useDeleteHomecarePlanProposalsByProposalId(
  options?: CustomMutationOptions<
    unknown,
    DeleteHomecarePlanProposalsByProposalIdResponse,
    DeleteHomecarePlanProposalsByProposalIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteHomecarePlanProposalsByProposalIdResponse,
    DeleteHomecarePlanProposalsByProposalIdParams
  >("homecare-plan", "/proposals/:proposalId", "DELETE", options);
}

// ============================================================================
// Impersonation Resource
// ============================================================================

export function useGetImpersonationSearch(): CustomQueryBuilder<
  GetImpersonationSearchResponse,
  Record<string, string>,
  GetImpersonationSearchQuery
> {
  return useResourceCustomQuery<
    GetImpersonationSearchResponse,
    Record<string, string>,
    GetImpersonationSearchQuery
  >("impersonation", "/search");
}

// ============================================================================
// Invoices Resource
// ============================================================================

export function useGetInvoicesList() {
  return useListQuery<
    GetInvoicesListItem,
    GetInvoicesListResponse,
    GetInvoicesListFilters
  >("invoices", "/list");
}

export function useGetInvoicesSummary(): CustomQueryBuilder<
  GetInvoicesSummaryResponse,
  Record<string, string>,
  GetInvoicesSummaryQuery
> {
  return useResourceCustomQuery<
    GetInvoicesSummaryResponse,
    Record<string, string>,
    GetInvoicesSummaryQuery
  >("invoices", "/summary");
}

export function useCreateInvoicesAll(
  options?: CustomMutationOptions<
    CreateInvoicesAllBody,
    CreateInvoicesAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesAllBody,
    CreateInvoicesAllResponse
  >("invoices", "", "POST", options);
}

export function useGetInvoicesCollectionByInvoiceId(
  params: GetInvoicesCollectionByInvoiceIdParams,
): CustomQueryBuilder<
  GetInvoicesCollectionByInvoiceIdResponse,
  GetInvoicesCollectionByInvoiceIdParams
> {
  return useResourceCustomQuery<
    GetInvoicesCollectionByInvoiceIdResponse,
    GetInvoicesCollectionByInvoiceIdParams
  >("invoices", "/:invoiceId/collection", params);
}

export function useGetInvoicesDocumentByInvoiceId(
  params: GetInvoicesDocumentByInvoiceIdParams,
): CustomQueryBuilder<
  GetInvoicesDocumentByInvoiceIdResponse,
  GetInvoicesDocumentByInvoiceIdParams
> {
  return useResourceCustomQuery<
    GetInvoicesDocumentByInvoiceIdResponse,
    GetInvoicesDocumentByInvoiceIdParams
  >("invoices", "/:invoiceId/document", params);
}

export function useCreateInvoicesChargeByInvoiceId(
  options?: CustomMutationOptions<
    CreateInvoicesChargeByInvoiceIdBody,
    CreateInvoicesChargeByInvoiceIdResponse,
    CreateInvoicesChargeByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesChargeByInvoiceIdBody,
    CreateInvoicesChargeByInvoiceIdResponse,
    CreateInvoicesChargeByInvoiceIdParams
  >("invoices", "/:invoiceId/charge", "POST", options);
}

export function useUpdateInvoicesChargeScheduleByInvoiceId(
  options?: CustomMutationOptions<
    UpdateInvoicesChargeScheduleByInvoiceIdBody,
    UpdateInvoicesChargeScheduleByInvoiceIdResponse,
    UpdateInvoicesChargeScheduleByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateInvoicesChargeScheduleByInvoiceIdBody,
    UpdateInvoicesChargeScheduleByInvoiceIdResponse,
    UpdateInvoicesChargeScheduleByInvoiceIdParams
  >("invoices", "/:invoiceId/charge-schedule", "PUT", options);
}

export function useCreateInvoicesSendByInvoiceId(
  options?: CustomMutationOptions<
    unknown,
    CreateInvoicesSendByInvoiceIdResponse,
    CreateInvoicesSendByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateInvoicesSendByInvoiceIdResponse,
    CreateInvoicesSendByInvoiceIdParams
  >("invoices", "/:invoiceId/send", "POST", options);
}

export function useCreateInvoicesOutsidePaymentsByInvoiceId(
  options?: CustomMutationOptions<
    CreateInvoicesOutsidePaymentsByInvoiceIdBody,
    CreateInvoicesOutsidePaymentsByInvoiceIdResponse,
    CreateInvoicesOutsidePaymentsByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesOutsidePaymentsByInvoiceIdBody,
    CreateInvoicesOutsidePaymentsByInvoiceIdResponse,
    CreateInvoicesOutsidePaymentsByInvoiceIdParams
  >("invoices", "/:invoiceId/outside-payments", "POST", options);
}

export function useCreateInvoicesOutsidePaymentsConfirmByInvoiceIdByPaymentId(
  options?: CustomMutationOptions<
    unknown,
    CreateInvoicesOutsidePaymentsConfirmByInvoiceIdByPaymentIdResponse,
    CreateInvoicesOutsidePaymentsConfirmByInvoiceIdByPaymentIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateInvoicesOutsidePaymentsConfirmByInvoiceIdByPaymentIdResponse,
    CreateInvoicesOutsidePaymentsConfirmByInvoiceIdByPaymentIdParams
  >(
    "invoices",
    "/:invoiceId/outside-payments/:paymentId/confirm",
    "POST",
    options,
  );
}

export function useCreateInvoicesOutsidePaymentsClearByInvoiceIdByPaymentId(
  options?: CustomMutationOptions<
    unknown,
    CreateInvoicesOutsidePaymentsClearByInvoiceIdByPaymentIdResponse,
    CreateInvoicesOutsidePaymentsClearByInvoiceIdByPaymentIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateInvoicesOutsidePaymentsClearByInvoiceIdByPaymentIdResponse,
    CreateInvoicesOutsidePaymentsClearByInvoiceIdByPaymentIdParams
  >(
    "invoices",
    "/:invoiceId/outside-payments/:paymentId/clear",
    "POST",
    options,
  );
}

export function useCreateInvoicesOutsidePaymentsCancelByInvoiceIdByPaymentId(
  options?: CustomMutationOptions<
    CreateInvoicesOutsidePaymentsCancelByInvoiceIdByPaymentIdBody,
    CreateInvoicesOutsidePaymentsCancelByInvoiceIdByPaymentIdResponse,
    CreateInvoicesOutsidePaymentsCancelByInvoiceIdByPaymentIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesOutsidePaymentsCancelByInvoiceIdByPaymentIdBody,
    CreateInvoicesOutsidePaymentsCancelByInvoiceIdByPaymentIdResponse,
    CreateInvoicesOutsidePaymentsCancelByInvoiceIdByPaymentIdParams
  >(
    "invoices",
    "/:invoiceId/outside-payments/:paymentId/cancel",
    "POST",
    options,
  );
}

export function useGetInvoicesCorrectionsByInvoiceId(
  params: GetInvoicesCorrectionsByInvoiceIdParams,
): CustomQueryBuilder<
  GetInvoicesCorrectionsByInvoiceIdResponse,
  GetInvoicesCorrectionsByInvoiceIdParams
> {
  return useResourceCustomQuery<
    GetInvoicesCorrectionsByInvoiceIdResponse,
    GetInvoicesCorrectionsByInvoiceIdParams
  >("invoices", "/:invoiceId/corrections", params);
}

export function useCreateInvoicesCreditNotesPreviewByInvoiceId(
  options?: CustomMutationOptions<
    CreateInvoicesCreditNotesPreviewByInvoiceIdBody,
    CreateInvoicesCreditNotesPreviewByInvoiceIdResponse,
    CreateInvoicesCreditNotesPreviewByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesCreditNotesPreviewByInvoiceIdBody,
    CreateInvoicesCreditNotesPreviewByInvoiceIdResponse,
    CreateInvoicesCreditNotesPreviewByInvoiceIdParams
  >("invoices", "/:invoiceId/credit-notes/preview", "POST", options);
}

export function useCreateInvoicesCreditNotesByInvoiceId(
  options?: CustomMutationOptions<
    CreateInvoicesCreditNotesByInvoiceIdBody,
    CreateInvoicesCreditNotesByInvoiceIdResponse,
    CreateInvoicesCreditNotesByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesCreditNotesByInvoiceIdBody,
    CreateInvoicesCreditNotesByInvoiceIdResponse,
    CreateInvoicesCreditNotesByInvoiceIdParams
  >("invoices", "/:invoiceId/credit-notes", "POST", options);
}

export function useCreateInvoicesCreditNotesApproveByInvoiceIdByCreditNoteId(
  options?: CustomMutationOptions<
    CreateInvoicesCreditNotesApproveByInvoiceIdByCreditNoteIdBody,
    CreateInvoicesCreditNotesApproveByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesApproveByInvoiceIdByCreditNoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesCreditNotesApproveByInvoiceIdByCreditNoteIdBody,
    CreateInvoicesCreditNotesApproveByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesApproveByInvoiceIdByCreditNoteIdParams
  >(
    "invoices",
    "/:invoiceId/credit-notes/:creditNoteId/approve",
    "POST",
    options,
  );
}

export function useCreateInvoicesCreditNotesRejectByInvoiceIdByCreditNoteId(
  options?: CustomMutationOptions<
    CreateInvoicesCreditNotesRejectByInvoiceIdByCreditNoteIdBody,
    CreateInvoicesCreditNotesRejectByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesRejectByInvoiceIdByCreditNoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesCreditNotesRejectByInvoiceIdByCreditNoteIdBody,
    CreateInvoicesCreditNotesRejectByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesRejectByInvoiceIdByCreditNoteIdParams
  >(
    "invoices",
    "/:invoiceId/credit-notes/:creditNoteId/reject",
    "POST",
    options,
  );
}

export function useDeleteInvoicesCreditNotesByInvoiceIdByCreditNoteId(
  options?: CustomMutationOptions<
    unknown,
    DeleteInvoicesCreditNotesByInvoiceIdByCreditNoteIdResponse,
    DeleteInvoicesCreditNotesByInvoiceIdByCreditNoteIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteInvoicesCreditNotesByInvoiceIdByCreditNoteIdResponse,
    DeleteInvoicesCreditNotesByInvoiceIdByCreditNoteIdParams
  >("invoices", "/:invoiceId/credit-notes/:creditNoteId", "DELETE", options);
}

export function useCreateInvoicesCreditNotesPaidOutByInvoiceIdByCreditNoteId(
  options?: CustomMutationOptions<
    CreateInvoicesCreditNotesPaidOutByInvoiceIdByCreditNoteIdBody,
    CreateInvoicesCreditNotesPaidOutByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesPaidOutByInvoiceIdByCreditNoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesCreditNotesPaidOutByInvoiceIdByCreditNoteIdBody,
    CreateInvoicesCreditNotesPaidOutByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesPaidOutByInvoiceIdByCreditNoteIdParams
  >(
    "invoices",
    "/:invoiceId/credit-notes/:creditNoteId/paid-out",
    "POST",
    options,
  );
}

export function useCreateInvoicesCreditNotesPayOutInsteadByInvoiceIdByCreditNoteId(
  options?: CustomMutationOptions<
    CreateInvoicesCreditNotesPayOutInsteadByInvoiceIdByCreditNoteIdBody,
    CreateInvoicesCreditNotesPayOutInsteadByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesPayOutInsteadByInvoiceIdByCreditNoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesCreditNotesPayOutInsteadByInvoiceIdByCreditNoteIdBody,
    CreateInvoicesCreditNotesPayOutInsteadByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesPayOutInsteadByInvoiceIdByCreditNoteIdParams
  >(
    "invoices",
    "/:invoiceId/credit-notes/:creditNoteId/pay-out-instead",
    "POST",
    options,
  );
}

export function useCreateInvoicesCreditNotesReviewedByInvoiceIdByCreditNoteId(
  options?: CustomMutationOptions<
    unknown,
    CreateInvoicesCreditNotesReviewedByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesReviewedByInvoiceIdByCreditNoteIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateInvoicesCreditNotesReviewedByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesReviewedByInvoiceIdByCreditNoteIdParams
  >(
    "invoices",
    "/:invoiceId/credit-notes/:creditNoteId/reviewed",
    "POST",
    options,
  );
}

export function useCreateInvoicesCreditNotesRetryStripeByInvoiceIdByCreditNoteId(
  options?: CustomMutationOptions<
    unknown,
    CreateInvoicesCreditNotesRetryStripeByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesRetryStripeByInvoiceIdByCreditNoteIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateInvoicesCreditNotesRetryStripeByInvoiceIdByCreditNoteIdResponse,
    CreateInvoicesCreditNotesRetryStripeByInvoiceIdByCreditNoteIdParams
  >(
    "invoices",
    "/:invoiceId/credit-notes/:creditNoteId/retry-stripe",
    "POST",
    options,
  );
}

export function useCreateInvoicesWalletApplicationsByInvoiceId(
  options?: CustomMutationOptions<
    CreateInvoicesWalletApplicationsByInvoiceIdBody,
    CreateInvoicesWalletApplicationsByInvoiceIdResponse,
    CreateInvoicesWalletApplicationsByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesWalletApplicationsByInvoiceIdBody,
    CreateInvoicesWalletApplicationsByInvoiceIdResponse,
    CreateInvoicesWalletApplicationsByInvoiceIdParams
  >("invoices", "/:invoiceId/wallet-applications", "POST", options);
}

export function useCreateInvoicesReissueByInvoiceId(
  options?: CustomMutationOptions<
    CreateInvoicesReissueByInvoiceIdBody,
    CreateInvoicesReissueByInvoiceIdResponse,
    CreateInvoicesReissueByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesReissueByInvoiceIdBody,
    CreateInvoicesReissueByInvoiceIdResponse,
    CreateInvoicesReissueByInvoiceIdParams
  >("invoices", "/:invoiceId/reissue", "POST", options);
}

export function useCreateInvoicesPaymentsReturnedByInvoiceIdByPaymentId(
  options?: CustomMutationOptions<
    CreateInvoicesPaymentsReturnedByInvoiceIdByPaymentIdBody,
    CreateInvoicesPaymentsReturnedByInvoiceIdByPaymentIdResponse,
    CreateInvoicesPaymentsReturnedByInvoiceIdByPaymentIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesPaymentsReturnedByInvoiceIdByPaymentIdBody,
    CreateInvoicesPaymentsReturnedByInvoiceIdByPaymentIdResponse,
    CreateInvoicesPaymentsReturnedByInvoiceIdByPaymentIdParams
  >("invoices", "/:invoiceId/payments/:paymentId/returned", "POST", options);
}

export function useGetInvoicesByInvoiceId(
  params: GetInvoicesByInvoiceIdParams,
): CustomQueryBuilder<
  GetInvoicesByInvoiceIdResponse,
  GetInvoicesByInvoiceIdParams
> {
  return useResourceCustomQuery<
    GetInvoicesByInvoiceIdResponse,
    GetInvoicesByInvoiceIdParams
  >("invoices", "/:invoiceId", params);
}

export function useUpdateInvoicesByInvoiceId(
  options?: CustomMutationOptions<
    UpdateInvoicesByInvoiceIdBody,
    UpdateInvoicesByInvoiceIdResponse,
    UpdateInvoicesByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateInvoicesByInvoiceIdBody,
    UpdateInvoicesByInvoiceIdResponse,
    UpdateInvoicesByInvoiceIdParams
  >("invoices", "/:invoiceId", "PATCH", options);
}

export function useDeleteInvoicesByInvoiceId(
  options?: CustomMutationOptions<
    unknown,
    DeleteInvoicesByInvoiceIdResponse,
    DeleteInvoicesByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteInvoicesByInvoiceIdResponse,
    DeleteInvoicesByInvoiceIdParams
  >("invoices", "/:invoiceId", "DELETE", options);
}

export function useCreateInvoicesFillLinesByInvoiceId(
  options?: CustomMutationOptions<
    CreateInvoicesFillLinesByInvoiceIdBody,
    CreateInvoicesFillLinesByInvoiceIdResponse,
    CreateInvoicesFillLinesByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesFillLinesByInvoiceIdBody,
    CreateInvoicesFillLinesByInvoiceIdResponse,
    CreateInvoicesFillLinesByInvoiceIdParams
  >("invoices", "/:invoiceId/fill-lines", "POST", options);
}

export function useCreateInvoicesIssuePreviewByInvoiceId(
  options?: CustomMutationOptions<
    CreateInvoicesIssuePreviewByInvoiceIdBody,
    CreateInvoicesIssuePreviewByInvoiceIdResponse,
    CreateInvoicesIssuePreviewByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesIssuePreviewByInvoiceIdBody,
    CreateInvoicesIssuePreviewByInvoiceIdResponse,
    CreateInvoicesIssuePreviewByInvoiceIdParams
  >("invoices", "/:invoiceId/issue-preview", "POST", options);
}

export function useCreateInvoicesIssueByInvoiceId(
  options?: CustomMutationOptions<
    CreateInvoicesIssueByInvoiceIdBody,
    CreateInvoicesIssueByInvoiceIdResponse,
    CreateInvoicesIssueByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateInvoicesIssueByInvoiceIdBody,
    CreateInvoicesIssueByInvoiceIdResponse,
    CreateInvoicesIssueByInvoiceIdParams
  >("invoices", "/:invoiceId/issue", "POST", options);
}

export function useCreateInvoicesVoidByInvoiceId(
  options?: CustomMutationOptions<
    unknown,
    CreateInvoicesVoidByInvoiceIdResponse,
    CreateInvoicesVoidByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateInvoicesVoidByInvoiceIdResponse,
    CreateInvoicesVoidByInvoiceIdParams
  >("invoices", "/:invoiceId/void", "POST", options);
}

export function useCreateInvoicesSyncReferenceByInvoiceId(
  options?: CustomMutationOptions<
    unknown,
    CreateInvoicesSyncReferenceByInvoiceIdResponse,
    CreateInvoicesSyncReferenceByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateInvoicesSyncReferenceByInvoiceIdResponse,
    CreateInvoicesSyncReferenceByInvoiceIdParams
  >("invoices", "/:invoiceId/sync-reference", "POST", options);
}

// ============================================================================
// ItemGroups Resource
// ============================================================================

export function useCreateItemGroupsAll(
  options?: CustomMutationOptions<CreateItemGroupsAllBody, unknown>,
) {
  return useResourceCustomMutation<CreateItemGroupsAllBody, unknown>(
    "item-groups",
    "",
    "POST",
    options,
  );
}

export function useCreateItemGroupsClone(
  options?: CustomMutationOptions<CreateItemGroupsCloneBody, unknown>,
) {
  return useResourceCustomMutation<CreateItemGroupsCloneBody, unknown>(
    "item-groups",
    "/clone",
    "POST",
    options,
  );
}

export function useUpdateItemGroupsByItemGroupId(
  options?: CustomMutationOptions<
    UpdateItemGroupsByItemGroupIdBody,
    unknown,
    UpdateItemGroupsByItemGroupIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateItemGroupsByItemGroupIdBody,
    unknown,
    UpdateItemGroupsByItemGroupIdParams
  >("item-groups", "/:itemGroupId", "PUT", options);
}

export function useDeleteItemGroupsByItemGroupId(
  options?: CustomMutationOptions<
    unknown,
    unknown,
    DeleteItemGroupsByItemGroupIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    unknown,
    DeleteItemGroupsByItemGroupIdParams
  >("item-groups", "/:itemGroupId", "DELETE", options);
}

// ============================================================================
// Join Resource
// ============================================================================

export function useCreateJoinSignUp(
  options?: CustomMutationOptions<
    CreateJoinSignUpBody,
    CreateJoinSignUpResponse
  >,
) {
  return useResourceCustomMutation<
    CreateJoinSignUpBody,
    CreateJoinSignUpResponse
  >("join", "/sign-up", "POST", options);
}

export function useCreateJoinPresaleSignUp(
  options?: CustomMutationOptions<
    CreateJoinPresaleSignUpBody,
    CreateJoinPresaleSignUpResponse
  >,
) {
  return useResourceCustomMutation<
    CreateJoinPresaleSignUpBody,
    CreateJoinPresaleSignUpResponse
  >("join", "/presale-sign-up", "POST", options);
}

export function useCreateJoinWaitlist(
  options?: CustomMutationOptions<
    CreateJoinWaitlistBody,
    CreateJoinWaitlistResponse
  >,
) {
  return useResourceCustomMutation<
    CreateJoinWaitlistBody,
    CreateJoinWaitlistResponse
  >("join", "/waitlist", "POST", options);
}

// ============================================================================
// LineItemUnitTypes Resource
// ============================================================================

export function useGetLineItemUnitTypesAll(): CustomQueryBuilder<
  GetLineItemUnitTypesAllResponse,
  Record<string, string>,
  GetLineItemUnitTypesAllQuery
> {
  return useResourceCustomQuery<
    GetLineItemUnitTypesAllResponse,
    Record<string, string>,
    GetLineItemUnitTypesAllQuery
  >("line-item-unit-types", "");
}

// ============================================================================
// LineItems Resource
// ============================================================================

export function useCreateLineItemsFromCatalog(
  options?: CustomMutationOptions<
    CreateLineItemsFromCatalogBody,
    CreateLineItemsFromCatalogResponse
  >,
) {
  return useResourceCustomMutation<
    CreateLineItemsFromCatalogBody,
    CreateLineItemsFromCatalogResponse
  >("line-items", "/from-catalog", "POST", options);
}

export function useCreateLineItemsClone(
  options?: CustomMutationOptions<
    CreateLineItemsCloneBody,
    CreateLineItemsCloneResponse
  >,
) {
  return useResourceCustomMutation<
    CreateLineItemsCloneBody,
    CreateLineItemsCloneResponse
  >("line-items", "/clone", "POST", options);
}

export function useCreateLineItemsAll(
  options?: CustomMutationOptions<
    CreateLineItemsAllBody,
    CreateLineItemsAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateLineItemsAllBody,
    CreateLineItemsAllResponse
  >("line-items", "", "POST", options);
}

export function useGetLineItemsByLineItemId(
  params: GetLineItemsByLineItemIdParams,
): CustomQueryBuilder<
  GetLineItemsByLineItemIdResponse,
  GetLineItemsByLineItemIdParams
> {
  return useResourceCustomQuery<
    GetLineItemsByLineItemIdResponse,
    GetLineItemsByLineItemIdParams
  >("line-items", "/:lineItemId", params);
}

export function useUpdateLineItemsByLineItemId(
  options?: CustomMutationOptions<
    UpdateLineItemsByLineItemIdBody,
    UpdateLineItemsByLineItemIdResponse,
    UpdateLineItemsByLineItemIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateLineItemsByLineItemIdBody,
    UpdateLineItemsByLineItemIdResponse,
    UpdateLineItemsByLineItemIdParams
  >("line-items", "/:lineItemId", "PUT", options);
}

export function useDeleteLineItemsByLineItemId(
  options?: CustomMutationOptions<
    unknown,
    DeleteLineItemsByLineItemIdResponse,
    DeleteLineItemsByLineItemIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteLineItemsByLineItemIdResponse,
    DeleteLineItemsByLineItemIdParams
  >("line-items", "/:lineItemId", "DELETE", options);
}

// ============================================================================
// Links Resource
// ============================================================================

export function useUpdateLinksLinkUserPlace(
  options?: CustomMutationOptions<
    UpdateLinksLinkUserPlaceBody,
    UpdateLinksLinkUserPlaceResponse
  >,
) {
  return useResourceCustomMutation<
    UpdateLinksLinkUserPlaceBody,
    UpdateLinksLinkUserPlaceResponse
  >("links", "/link-user-place", "PUT", options);
}

export function useDeleteLinksUnlinkUserPlace(
  options?: CustomMutationOptions<
    DeleteLinksUnlinkUserPlaceBody,
    DeleteLinksUnlinkUserPlaceResponse
  >,
) {
  return useResourceCustomMutation<
    DeleteLinksUnlinkUserPlaceBody,
    DeleteLinksUnlinkUserPlaceResponse
  >("links", "/unlink-user-place", "DELETE", options);
}

// ============================================================================
// ListItems Resource
// ============================================================================

export function useGetListItemsList() {
  return useListQuery<
    GetListItemsListItem,
    GetListItemsListResponse,
    GetListItemsListFilters
  >("list-items", "/list");
}

export function useCreateListItemsCreate(
  options?: CustomMutationOptions<
    CreateListItemsCreateBody,
    CreateListItemsCreateResponse
  >,
) {
  return useResourceCustomMutation<
    CreateListItemsCreateBody,
    CreateListItemsCreateResponse
  >("list-items", "/create", "POST", options);
}

export function useCreateListItemsUpsert(
  options?: CustomMutationOptions<
    CreateListItemsUpsertBody,
    CreateListItemsUpsertResponse
  >,
) {
  return useResourceCustomMutation<
    CreateListItemsUpsertBody,
    CreateListItemsUpsertResponse
  >("list-items", "/upsert", "POST", options);
}

export function useCreateListItemsSort(
  options?: CustomMutationOptions<
    CreateListItemsSortBody,
    CreateListItemsSortResponse
  >,
) {
  return useResourceCustomMutation<
    CreateListItemsSortBody,
    CreateListItemsSortResponse
  >("list-items", "/sort", "POST", options);
}

export function useCreateListItemsLink(
  options?: CustomMutationOptions<
    CreateListItemsLinkBody,
    CreateListItemsLinkResponse
  >,
) {
  return useResourceCustomMutation<
    CreateListItemsLinkBody,
    CreateListItemsLinkResponse
  >("list-items", "/link", "POST", options);
}

export function useCreateListItemsUnlink(
  options?: CustomMutationOptions<
    CreateListItemsUnlinkBody,
    CreateListItemsUnlinkResponse
  >,
) {
  return useResourceCustomMutation<
    CreateListItemsUnlinkBody,
    CreateListItemsUnlinkResponse
  >("list-items", "/unlink", "POST", options);
}

export function useCreateListItemsShare(
  options?: CustomMutationOptions<
    CreateListItemsShareBody,
    CreateListItemsShareResponse
  >,
) {
  return useResourceCustomMutation<
    CreateListItemsShareBody,
    CreateListItemsShareResponse
  >("list-items", "/share", "POST", options);
}

export function useCreateListItemsMarkAsDoneByListItemId(
  options?: CustomMutationOptions<
    CreateListItemsMarkAsDoneByListItemIdBody,
    CreateListItemsMarkAsDoneByListItemIdResponse,
    CreateListItemsMarkAsDoneByListItemIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateListItemsMarkAsDoneByListItemIdBody,
    CreateListItemsMarkAsDoneByListItemIdResponse,
    CreateListItemsMarkAsDoneByListItemIdParams
  >("list-items", "/:listItemId/mark-as-done", "POST", options);
}

export function useGetListItemsByListItemId(
  params: GetListItemsByListItemIdParams,
): CustomQueryBuilder<
  GetListItemsByListItemIdResponse,
  GetListItemsByListItemIdParams,
  GetListItemsByListItemIdQuery
> {
  return useResourceCustomQuery<
    GetListItemsByListItemIdResponse,
    GetListItemsByListItemIdParams,
    GetListItemsByListItemIdQuery
  >("list-items", "/:listItemId", params);
}

export function useUpdateListItemsByListItemId(
  options?: CustomMutationOptions<
    UpdateListItemsByListItemIdBody,
    UpdateListItemsByListItemIdResponse,
    UpdateListItemsByListItemIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateListItemsByListItemIdBody,
    UpdateListItemsByListItemIdResponse,
    UpdateListItemsByListItemIdParams
  >("list-items", "/:listItemId", "PUT", options);
}

export function useDeleteListItemsByListItemId(
  options?: CustomMutationOptions<
    unknown,
    DeleteListItemsByListItemIdResponse,
    DeleteListItemsByListItemIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteListItemsByListItemIdResponse,
    DeleteListItemsByListItemIdParams
  >("list-items", "/:listItemId", "DELETE", options);
}

// ============================================================================
// Locations Resource
// ============================================================================

export function useGetLocationsList() {
  return useListQuery<
    GetLocationsListItem,
    GetLocationsListResponse,
    GetLocationsListFilters
  >("locations", "/list");
}

export function useCreateLocationsAll(
  options?: CustomMutationOptions<
    CreateLocationsAllBody,
    CreateLocationsAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateLocationsAllBody,
    CreateLocationsAllResponse
  >("locations", "", "POST", options);
}

export function useGetLocationsByLocationId(
  params: GetLocationsByLocationIdParams,
): CustomQueryBuilder<
  GetLocationsByLocationIdResponse,
  GetLocationsByLocationIdParams
> {
  return useResourceCustomQuery<
    GetLocationsByLocationIdResponse,
    GetLocationsByLocationIdParams
  >("locations", "/:locationId", params);
}

export function useUpdateLocationsByLocationId(
  options?: CustomMutationOptions<
    UpdateLocationsByLocationIdBody,
    UpdateLocationsByLocationIdResponse,
    UpdateLocationsByLocationIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateLocationsByLocationIdBody,
    UpdateLocationsByLocationIdResponse,
    UpdateLocationsByLocationIdParams
  >("locations", "/:locationId", "PUT", options);
}

export function useDeleteLocationsByLocationId(
  options?: CustomMutationOptions<
    unknown,
    DeleteLocationsByLocationIdResponse,
    DeleteLocationsByLocationIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteLocationsByLocationIdResponse,
    DeleteLocationsByLocationIdParams
  >("locations", "/:locationId", "DELETE", options);
}

// ============================================================================
// Meet Resource
// ============================================================================

export function useCreateMeetLink(
  options?: CustomMutationOptions<CreateMeetLinkBody, CreateMeetLinkResponse>,
) {
  return useResourceCustomMutation<CreateMeetLinkBody, CreateMeetLinkResponse>(
    "meet",
    "/links",
    "POST",
    options,
  );
}

export function useGetMeetLinkByName(
  params: GetMeetLinkByNameParams,
): CustomQueryBuilder<GetMeetLinkByNameResponse, GetMeetLinkByNameParams> {
  return useResourceCustomQuery<
    GetMeetLinkByNameResponse,
    GetMeetLinkByNameParams
  >("meet", "/links/by-name/:roomName", params);
}

export function useGetMeetParticipantsByRoomName(
  params: GetMeetParticipantsByRoomNameParams,
): CustomQueryBuilder<
  GetMeetParticipantsByRoomNameResponse,
  GetMeetParticipantsByRoomNameParams
> {
  return useResourceCustomQuery<
    GetMeetParticipantsByRoomNameResponse,
    GetMeetParticipantsByRoomNameParams
  >("meet", "/:roomName/participants", params);
}

export function useDeleteMeetLink(
  options?: CustomMutationOptions<
    unknown,
    DeleteMeetLinkResponse,
    DeleteMeetLinkParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteMeetLinkResponse,
    DeleteMeetLinkParams
  >("meet", "/links/:meetLinkId", "DELETE", options);
}

export function useCreateMeetTokenByRoomName(
  options?: CustomMutationOptions<
    unknown,
    CreateMeetTokenByRoomNameResponse,
    CreateMeetTokenByRoomNameParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateMeetTokenByRoomNameResponse,
    CreateMeetTokenByRoomNameParams
  >("meet", "/:roomName/token", "POST", options);
}

export function useCreateMeetGuestTokenByRoomName(
  options?: CustomMutationOptions<
    CreateMeetGuestTokenByRoomNameBody,
    CreateMeetGuestTokenByRoomNameResponse,
    CreateMeetGuestTokenByRoomNameParams
  >,
) {
  return useResourceCustomMutation<
    CreateMeetGuestTokenByRoomNameBody,
    CreateMeetGuestTokenByRoomNameResponse,
    CreateMeetGuestTokenByRoomNameParams
  >("meet", "/:roomName/guest-token", "POST", options);
}

// ============================================================================
// Members Resource
// ============================================================================

export function useGetMembersPlaces(): CustomQueryBuilder<
  GetMembersPlacesResponse,
  Record<string, string>,
  GetMembersPlacesQuery,
  GetMembersPlacesExtra
> {
  return useResourceCustomQuery<
    GetMembersPlacesResponse,
    Record<string, string>,
    GetMembersPlacesQuery,
    GetMembersPlacesExtra
  >("members", "/places");
}

export function useGetMembersVisits(): CustomQueryBuilder<
  GetMembersVisitsResponse,
  Record<string, string>,
  GetMembersVisitsQuery,
  GetMembersVisitsExtra
> {
  return useResourceCustomQuery<
    GetMembersVisitsResponse,
    Record<string, string>,
    GetMembersVisitsQuery,
    GetMembersVisitsExtra
  >("members", "/visits");
}

export function useGetMembersPayments(): CustomQueryBuilder<
  GetMembersPaymentsResponse,
  Record<string, string>,
  GetMembersPaymentsQuery,
  GetMembersPaymentsExtra
> {
  return useResourceCustomQuery<
    GetMembersPaymentsResponse,
    Record<string, string>,
    GetMembersPaymentsQuery,
    GetMembersPaymentsExtra
  >("members", "/payments");
}

export function useGetMembersAccounts(): CustomQueryBuilder<
  GetMembersAccountsResponse,
  Record<string, string>,
  Record<string, unknown>,
  GetMembersAccountsExtra
> {
  return useResourceCustomQuery<
    GetMembersAccountsResponse,
    Record<string, string>,
    Record<string, unknown>,
    GetMembersAccountsExtra
  >("members", "/accounts");
}

export function useGetMembersSearch(): CustomQueryBuilder<
  GetMembersSearchResponse,
  Record<string, string>,
  GetMembersSearchQuery
> {
  return useResourceCustomQuery<
    GetMembersSearchResponse,
    Record<string, string>,
    GetMembersSearchQuery
  >("members", "/search");
}

export function useGetMembersCampaigns(): CustomQueryBuilder<
  GetMembersCampaignsResponse,
  Record<string, string>,
  Record<string, unknown>,
  GetMembersCampaignsExtra
> {
  return useResourceCustomQuery<
    GetMembersCampaignsResponse,
    Record<string, string>,
    Record<string, unknown>,
    GetMembersCampaignsExtra
  >("members", "/campaigns");
}

export function useCreateMembersCampaignsViewByCampaignId(
  options?: CustomMutationOptions<
    unknown,
    CreateMembersCampaignsViewByCampaignIdResponse,
    CreateMembersCampaignsViewByCampaignIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateMembersCampaignsViewByCampaignIdResponse,
    CreateMembersCampaignsViewByCampaignIdParams
  >("members", "/campaigns/:campaignId/view", "POST", options);
}

export function useCreateMembersCampaignsDismissByCampaignId(
  options?: CustomMutationOptions<
    CreateMembersCampaignsDismissByCampaignIdBody,
    CreateMembersCampaignsDismissByCampaignIdResponse,
    CreateMembersCampaignsDismissByCampaignIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateMembersCampaignsDismissByCampaignIdBody,
    CreateMembersCampaignsDismissByCampaignIdResponse,
    CreateMembersCampaignsDismissByCampaignIdParams
  >("members", "/campaigns/:campaignId/dismiss", "POST", options);
}

export function useGetMembersAttachmentsByAttachmentId(
  params: GetMembersAttachmentsByAttachmentIdParams,
): CustomQueryBuilder<
  GetMembersAttachmentsByAttachmentIdResponse,
  GetMembersAttachmentsByAttachmentIdParams
> {
  return useResourceCustomQuery<
    GetMembersAttachmentsByAttachmentIdResponse,
    GetMembersAttachmentsByAttachmentIdParams
  >("members", "/attachments/:attachmentId", params);
}

export function useGetMembersBillingAlert(): CustomQueryBuilder<GetMembersBillingAlertResponse> {
  return useResourceCustomQuery<GetMembersBillingAlertResponse>(
    "members",
    "/billing-alert",
  );
}

export function useCreateMembersBillingAlertPayPreview(
  options?: CustomMutationOptions<
    CreateMembersBillingAlertPayPreviewBody,
    CreateMembersBillingAlertPayPreviewResponse
  >,
) {
  return useResourceCustomMutation<
    CreateMembersBillingAlertPayPreviewBody,
    CreateMembersBillingAlertPayPreviewResponse
  >("members", "/billing-alert/pay/preview", "POST", options);
}

export function useCreateMembersBillingAlertPay(
  options?: CustomMutationOptions<
    CreateMembersBillingAlertPayBody,
    CreateMembersBillingAlertPayResponse
  >,
) {
  return useResourceCustomMutation<
    CreateMembersBillingAlertPayBody,
    CreateMembersBillingAlertPayResponse
  >("members", "/billing-alert/pay", "POST", options);
}

export function useCreateMembersInvoicesPayPreviewByInvoiceId(
  options?: CustomMutationOptions<
    CreateMembersInvoicesPayPreviewByInvoiceIdBody,
    CreateMembersInvoicesPayPreviewByInvoiceIdResponse,
    CreateMembersInvoicesPayPreviewByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateMembersInvoicesPayPreviewByInvoiceIdBody,
    CreateMembersInvoicesPayPreviewByInvoiceIdResponse,
    CreateMembersInvoicesPayPreviewByInvoiceIdParams
  >("members", "/invoices/:invoiceId/pay/preview", "POST", options);
}

export function useCreateMembersInvoicesPayByInvoiceId(
  options?: CustomMutationOptions<
    CreateMembersInvoicesPayByInvoiceIdBody,
    CreateMembersInvoicesPayByInvoiceIdResponse,
    CreateMembersInvoicesPayByInvoiceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateMembersInvoicesPayByInvoiceIdBody,
    CreateMembersInvoicesPayByInvoiceIdResponse,
    CreateMembersInvoicesPayByInvoiceIdParams
  >("members", "/invoices/:invoiceId/pay", "POST", options);
}

export function useCreateMembersInvoicesPaymentsCompleteByInvoiceIdByPaymentIntentId(
  options?: CustomMutationOptions<
    unknown,
    CreateMembersInvoicesPaymentsCompleteByInvoiceIdByPaymentIntentIdResponse,
    CreateMembersInvoicesPaymentsCompleteByInvoiceIdByPaymentIntentIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateMembersInvoicesPaymentsCompleteByInvoiceIdByPaymentIntentIdResponse,
    CreateMembersInvoicesPaymentsCompleteByInvoiceIdByPaymentIntentIdParams
  >(
    "members",
    "/invoices/:invoiceId/payments/:paymentIntentId/complete",
    "POST",
    options,
  );
}

export function useGetMembersInsight(): CustomQueryBuilder<
  GetMembersInsightResponse,
  Record<string, string>,
  GetMembersInsightQuery
> {
  return useResourceCustomQuery<
    GetMembersInsightResponse,
    Record<string, string>,
    GetMembersInsightQuery
  >("members", "/insight");
}

export function useGetMembersPlacesNestSummaryByPlaceId(
  params: GetMembersPlacesNestSummaryByPlaceIdParams,
): CustomQueryBuilder<
  GetMembersPlacesNestSummaryByPlaceIdResponse,
  GetMembersPlacesNestSummaryByPlaceIdParams
> {
  return useResourceCustomQuery<
    GetMembersPlacesNestSummaryByPlaceIdResponse,
    GetMembersPlacesNestSummaryByPlaceIdParams
  >("members", "/places/:placeId/nest/summary", params);
}

export function useCreateMembersPlacesNestQueryByPlaceId(
  options?: CustomMutationOptions<
    CreateMembersPlacesNestQueryByPlaceIdBody,
    CreateMembersPlacesNestQueryByPlaceIdResponse,
    CreateMembersPlacesNestQueryByPlaceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateMembersPlacesNestQueryByPlaceIdBody,
    CreateMembersPlacesNestQueryByPlaceIdResponse,
    CreateMembersPlacesNestQueryByPlaceIdParams
  >("members", "/places/:placeId/nest/query", "POST", options);
}

export function useGetMembersPlacesNestComponentsByPlaceId(
  params: GetMembersPlacesNestComponentsByPlaceIdParams,
): CustomQueryBuilder<
  GetMembersPlacesNestComponentsByPlaceIdResponse,
  GetMembersPlacesNestComponentsByPlaceIdParams
> {
  return useResourceCustomQuery<
    GetMembersPlacesNestComponentsByPlaceIdResponse,
    GetMembersPlacesNestComponentsByPlaceIdParams
  >("members", "/places/:placeId/nest/components", params);
}

export function useGetMembersPlacesNestComponentsByPlaceIdByNodeKey(
  params: GetMembersPlacesNestComponentsByPlaceIdByNodeKeyParams,
): CustomQueryBuilder<
  GetMembersPlacesNestComponentsByPlaceIdByNodeKeyResponse,
  GetMembersPlacesNestComponentsByPlaceIdByNodeKeyParams
> {
  return useResourceCustomQuery<
    GetMembersPlacesNestComponentsByPlaceIdByNodeKeyResponse,
    GetMembersPlacesNestComponentsByPlaceIdByNodeKeyParams
  >("members", "/places/:placeId/nest/components/:nodeKey", params);
}

export function useGetMembersPlacesByPlaceId(
  params: GetMembersPlacesByPlaceIdParams,
): CustomQueryBuilder<
  GetMembersPlacesByPlaceIdResponse,
  GetMembersPlacesByPlaceIdParams,
  GetMembersPlacesByPlaceIdQuery
> {
  return useResourceCustomQuery<
    GetMembersPlacesByPlaceIdResponse,
    GetMembersPlacesByPlaceIdParams,
    GetMembersPlacesByPlaceIdQuery
  >("members", "/places/:placeId", params);
}

export function useGetMembersOrders() {
  return useListQuery<
    GetMembersOrdersItem,
    GetMembersOrdersResponse,
    GetMembersOrdersFilters
  >("members", "/orders");
}

export function useGetMembersOrdersByOrderId(
  params: GetMembersOrdersByOrderIdParams,
): CustomQueryBuilder<
  GetMembersOrdersByOrderIdResponse,
  GetMembersOrdersByOrderIdParams,
  GetMembersOrdersByOrderIdQuery
> {
  return useResourceCustomQuery<
    GetMembersOrdersByOrderIdResponse,
    GetMembersOrdersByOrderIdParams,
    GetMembersOrdersByOrderIdQuery
  >("members", "/orders/:orderId", params);
}

export function useCreateMembersQuotesViewByQuoteId(
  options?: CustomMutationOptions<
    unknown,
    CreateMembersQuotesViewByQuoteIdResponse,
    CreateMembersQuotesViewByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateMembersQuotesViewByQuoteIdResponse,
    CreateMembersQuotesViewByQuoteIdParams
  >("members", "/quotes/:quoteId/view", "POST", options);
}

export function useCreateMembersQuotesAcceptByQuoteId(
  options?: CustomMutationOptions<
    CreateMembersQuotesAcceptByQuoteIdBody,
    CreateMembersQuotesAcceptByQuoteIdResponse,
    CreateMembersQuotesAcceptByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateMembersQuotesAcceptByQuoteIdBody,
    CreateMembersQuotesAcceptByQuoteIdResponse,
    CreateMembersQuotesAcceptByQuoteIdParams
  >("members", "/quotes/:quoteId/accept", "POST", options);
}

export function useCreateMembersQuotesDeclineByQuoteId(
  options?: CustomMutationOptions<
    CreateMembersQuotesDeclineByQuoteIdBody,
    CreateMembersQuotesDeclineByQuoteIdResponse,
    CreateMembersQuotesDeclineByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateMembersQuotesDeclineByQuoteIdBody,
    CreateMembersQuotesDeclineByQuoteIdResponse,
    CreateMembersQuotesDeclineByQuoteIdParams
  >("members", "/quotes/:quoteId/decline", "POST", options);
}

export function useCreateMembersQuotesDepositPaymentsPreviewByQuoteId(
  options?: CustomMutationOptions<
    CreateMembersQuotesDepositPaymentsPreviewByQuoteIdBody,
    CreateMembersQuotesDepositPaymentsPreviewByQuoteIdResponse,
    CreateMembersQuotesDepositPaymentsPreviewByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateMembersQuotesDepositPaymentsPreviewByQuoteIdBody,
    CreateMembersQuotesDepositPaymentsPreviewByQuoteIdResponse,
    CreateMembersQuotesDepositPaymentsPreviewByQuoteIdParams
  >("members", "/quotes/:quoteId/deposit-payments/preview", "POST", options);
}

export function useCreateMembersQuotesDepositPaymentsByQuoteId(
  options?: CustomMutationOptions<
    CreateMembersQuotesDepositPaymentsByQuoteIdBody,
    CreateMembersQuotesDepositPaymentsByQuoteIdResponse,
    CreateMembersQuotesDepositPaymentsByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateMembersQuotesDepositPaymentsByQuoteIdBody,
    CreateMembersQuotesDepositPaymentsByQuoteIdResponse,
    CreateMembersQuotesDepositPaymentsByQuoteIdParams
  >("members", "/quotes/:quoteId/deposit-payments", "POST", options);
}

export function useCreateMembersQuotesDepositPaymentsCompleteByQuoteIdByPaymentIntentId(
  options?: CustomMutationOptions<
    unknown,
    CreateMembersQuotesDepositPaymentsCompleteByQuoteIdByPaymentIntentIdResponse,
    CreateMembersQuotesDepositPaymentsCompleteByQuoteIdByPaymentIntentIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateMembersQuotesDepositPaymentsCompleteByQuoteIdByPaymentIntentIdResponse,
    CreateMembersQuotesDepositPaymentsCompleteByQuoteIdByPaymentIntentIdParams
  >(
    "members",
    "/quotes/:quoteId/deposit-payments/:paymentIntentId/complete",
    "POST",
    options,
  );
}

export function useGetMembersQuotesByQuoteId(
  params: GetMembersQuotesByQuoteIdParams,
): CustomQueryBuilder<
  GetMembersQuotesByQuoteIdResponse,
  GetMembersQuotesByQuoteIdParams
> {
  return useResourceCustomQuery<
    GetMembersQuotesByQuoteIdResponse,
    GetMembersQuotesByQuoteIdParams
  >("members", "/quotes/:quoteId", params);
}

// ============================================================================
// Memberships Resource
// ============================================================================

export function useCreateMembershipsAll(
  options?: CustomMutationOptions<
    CreateMembershipsAllBody,
    CreateMembershipsAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateMembershipsAllBody,
    CreateMembershipsAllResponse
  >("memberships", "", "POST", options);
}

export function useUpdateMembershipsByMembershipId(
  options?: CustomMutationOptions<
    UpdateMembershipsByMembershipIdBody,
    UpdateMembershipsByMembershipIdResponse,
    UpdateMembershipsByMembershipIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateMembershipsByMembershipIdBody,
    UpdateMembershipsByMembershipIdResponse,
    UpdateMembershipsByMembershipIdParams
  >("memberships", "/:membershipId", "PUT", options);
}

export function useDeleteMembershipsByMembershipId(
  options?: CustomMutationOptions<
    unknown,
    DeleteMembershipsByMembershipIdResponse,
    DeleteMembershipsByMembershipIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteMembershipsByMembershipIdResponse,
    DeleteMembershipsByMembershipIdParams
  >("memberships", "/:membershipId", "DELETE", options);
}

// ============================================================================
// Messages Resource
// ============================================================================

export function useCreateMessagesAuto(
  options?: CustomMutationOptions<
    CreateMessagesAutoBody,
    CreateMessagesAutoResponse
  >,
) {
  return useResourceCustomMutation<
    CreateMessagesAutoBody,
    CreateMessagesAutoResponse
  >("messages", "/auto", "POST", options);
}

export function useGetMessagesByMessageId(
  params: GetMessagesByMessageIdParams,
): CustomQueryBuilder<
  GetMessagesByMessageIdResponse,
  GetMessagesByMessageIdParams
> {
  return useResourceCustomQuery<
    GetMessagesByMessageIdResponse,
    GetMessagesByMessageIdParams
  >("messages", "/:messageId", params);
}

// ============================================================================
// Notes Resource
// ============================================================================

export function useGetNotesDocByNotableTypeByNotableId(
  params: GetNotesDocByNotableTypeByNotableIdParams,
): CustomQueryBuilder<
  GetNotesDocByNotableTypeByNotableIdResponse,
  GetNotesDocByNotableTypeByNotableIdParams
> {
  return useResourceCustomQuery<
    GetNotesDocByNotableTypeByNotableIdResponse,
    GetNotesDocByNotableTypeByNotableIdParams
  >("notes", "/doc/:notableType/:notableId", params);
}

export function useUpdateNotesDocByNotableTypeByNotableId(
  options?: CustomMutationOptions<
    UpdateNotesDocByNotableTypeByNotableIdBody,
    UpdateNotesDocByNotableTypeByNotableIdResponse,
    UpdateNotesDocByNotableTypeByNotableIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateNotesDocByNotableTypeByNotableIdBody,
    UpdateNotesDocByNotableTypeByNotableIdResponse,
    UpdateNotesDocByNotableTypeByNotableIdParams
  >("notes", "/doc/:notableType/:notableId", "PUT", options);
}

// ============================================================================
// Notifications Resource
// ============================================================================

export function useGetNotificationsList() {
  return useListQuery<
    GetNotificationsListItem,
    GetNotificationsListResponse,
    GetNotificationsListFilters
  >("notifications", "/list");
}

export function useGetNotificationsLatest(): CustomQueryBuilder<GetNotificationsLatestResponse> {
  return useResourceCustomQuery<GetNotificationsLatestResponse>(
    "notifications",
    "/latest",
  );
}

export function useCreateNotificationsReadAll(
  options?: CustomMutationOptions<
    CreateNotificationsReadAllBody,
    CreateNotificationsReadAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateNotificationsReadAllBody,
    CreateNotificationsReadAllResponse
  >("notifications", "/read-all", "POST", options);
}

export function useCreateNotificationsSeenAll(
  options?: CustomMutationOptions<
    CreateNotificationsSeenAllBody,
    CreateNotificationsSeenAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateNotificationsSeenAllBody,
    CreateNotificationsSeenAllResponse
  >("notifications", "/seen-all", "POST", options);
}

export function useCreateNotificationsArchiveAll(
  options?: CustomMutationOptions<
    CreateNotificationsArchiveAllBody,
    CreateNotificationsArchiveAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateNotificationsArchiveAllBody,
    CreateNotificationsArchiveAllResponse
  >("notifications", "/archive-all", "POST", options);
}

export function useGetNotificationsCounts(): CustomQueryBuilder<GetNotificationsCountsResponse> {
  return useResourceCustomQuery<GetNotificationsCountsResponse>(
    "notifications",
    "/counts",
  );
}

export function useGetNotificationsDeliveriesList() {
  return useListQuery<
    GetNotificationsDeliveriesListItem,
    GetNotificationsDeliveriesListResponse,
    GetNotificationsDeliveriesListFilters
  >("notifications", "/deliveries/list");
}

export function useGetNotificationsByNotificationId(
  params: GetNotificationsByNotificationIdParams,
): CustomQueryBuilder<
  GetNotificationsByNotificationIdResponse,
  GetNotificationsByNotificationIdParams
> {
  return useResourceCustomQuery<
    GetNotificationsByNotificationIdResponse,
    GetNotificationsByNotificationIdParams
  >("notifications", "/:notificationId", params);
}

export function useGetNotificationsDeliveriesByNotificationId(
  params: GetNotificationsDeliveriesByNotificationIdParams,
): CustomQueryBuilder<
  GetNotificationsDeliveriesByNotificationIdResponse,
  GetNotificationsDeliveriesByNotificationIdParams
> {
  return useResourceCustomQuery<
    GetNotificationsDeliveriesByNotificationIdResponse,
    GetNotificationsDeliveriesByNotificationIdParams
  >("notifications", "/:notificationId/deliveries", params);
}

export function useUpdateNotificationsReadByNotificationId(
  options?: CustomMutationOptions<
    UpdateNotificationsReadByNotificationIdBody,
    UpdateNotificationsReadByNotificationIdResponse,
    UpdateNotificationsReadByNotificationIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateNotificationsReadByNotificationIdBody,
    UpdateNotificationsReadByNotificationIdResponse,
    UpdateNotificationsReadByNotificationIdParams
  >("notifications", "/:notificationId/read", "PUT", options);
}

export function useUpdateNotificationsArchiveByNotificationId(
  options?: CustomMutationOptions<
    UpdateNotificationsArchiveByNotificationIdBody,
    UpdateNotificationsArchiveByNotificationIdResponse,
    UpdateNotificationsArchiveByNotificationIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateNotificationsArchiveByNotificationIdBody,
    UpdateNotificationsArchiveByNotificationIdResponse,
    UpdateNotificationsArchiveByNotificationIdParams
  >("notifications", "/:notificationId/archive", "PUT", options);
}

// ============================================================================
// Onboardings Resource
// ============================================================================

export function useGetOnboardingsList() {
  return useListQuery<
    GetOnboardingsListItem,
    GetOnboardingsListResponse,
    GetOnboardingsListFilters
  >("onboardings", "/list");
}

export function useGetOnboardingsStages(): CustomQueryBuilder<GetOnboardingsStagesResponse> {
  return useResourceCustomQuery<GetOnboardingsStagesResponse>(
    "onboardings",
    "/stages",
  );
}

export function useGetOnboardingsWidgetByOnboardingId(
  params: GetOnboardingsWidgetByOnboardingIdParams,
): CustomQueryBuilder<
  GetOnboardingsWidgetByOnboardingIdResponse,
  GetOnboardingsWidgetByOnboardingIdParams
> {
  return useResourceCustomQuery<
    GetOnboardingsWidgetByOnboardingIdResponse,
    GetOnboardingsWidgetByOnboardingIdParams
  >("onboardings", "/:onboardingId/widget", params);
}

export function useGetOnboardingsByOnboardingId(
  params: GetOnboardingsByOnboardingIdParams,
): CustomQueryBuilder<
  GetOnboardingsByOnboardingIdResponse,
  GetOnboardingsByOnboardingIdParams
> {
  return useResourceCustomQuery<
    GetOnboardingsByOnboardingIdResponse,
    GetOnboardingsByOnboardingIdParams
  >("onboardings", "/:onboardingId", params);
}

export function useCreateOnboardingsReset(
  options?: CustomMutationOptions<CreateOnboardingsResetBody, unknown>,
) {
  return useResourceCustomMutation<CreateOnboardingsResetBody, unknown>(
    "onboardings",
    "/reset",
    "POST",
    options,
  );
}

export function useCreateOnboardingsTriggerOnboarding(
  options?: CustomMutationOptions<
    CreateOnboardingsTriggerOnboardingBody,
    CreateOnboardingsTriggerOnboardingResponse
  >,
) {
  return useResourceCustomMutation<
    CreateOnboardingsTriggerOnboardingBody,
    CreateOnboardingsTriggerOnboardingResponse
  >("onboardings", "/trigger-onboarding", "POST", options);
}

export function useCreateOnboardingsStartByOnboardingId(
  options?: CustomMutationOptions<
    unknown,
    unknown,
    CreateOnboardingsStartByOnboardingIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    unknown,
    CreateOnboardingsStartByOnboardingIdParams
  >("onboardings", "/:onboardingId/start", "POST", options);
}

export function useCreateOnboardingsCompleteByOnboardingId(
  options?: CustomMutationOptions<
    unknown,
    unknown,
    CreateOnboardingsCompleteByOnboardingIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    unknown,
    CreateOnboardingsCompleteByOnboardingIdParams
  >("onboardings", "/:onboardingId/complete", "POST", options);
}

export function useCreateOnboardingsNextStepByOnboardingId(
  options?: CustomMutationOptions<
    CreateOnboardingsNextStepByOnboardingIdBody,
    unknown,
    CreateOnboardingsNextStepByOnboardingIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOnboardingsNextStepByOnboardingIdBody,
    unknown,
    CreateOnboardingsNextStepByOnboardingIdParams
  >("onboardings", "/:onboardingId/next-step", "POST", options);
}

export function useCreateOnboardingsCompleteStepByOnboardingId(
  options?: CustomMutationOptions<
    CreateOnboardingsCompleteStepByOnboardingIdBody,
    unknown,
    CreateOnboardingsCompleteStepByOnboardingIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOnboardingsCompleteStepByOnboardingIdBody,
    unknown,
    CreateOnboardingsCompleteStepByOnboardingIdParams
  >("onboardings", "/:onboardingId/complete-step", "POST", options);
}

// ============================================================================
// OrderDeposits Resource
// ============================================================================

export function useCreateOrderDepositsPaymentsConfirmByOrderDepositIdByPaymentId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrderDepositsPaymentsConfirmByOrderDepositIdByPaymentIdResponse,
    CreateOrderDepositsPaymentsConfirmByOrderDepositIdByPaymentIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrderDepositsPaymentsConfirmByOrderDepositIdByPaymentIdResponse,
    CreateOrderDepositsPaymentsConfirmByOrderDepositIdByPaymentIdParams
  >(
    "order-deposits",
    "/:orderDepositId/payments/:paymentId/confirm",
    "POST",
    options,
  );
}

export function useCreateOrderDepositsPaymentsClearByOrderDepositIdByPaymentId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrderDepositsPaymentsClearByOrderDepositIdByPaymentIdResponse,
    CreateOrderDepositsPaymentsClearByOrderDepositIdByPaymentIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrderDepositsPaymentsClearByOrderDepositIdByPaymentIdResponse,
    CreateOrderDepositsPaymentsClearByOrderDepositIdByPaymentIdParams
  >(
    "order-deposits",
    "/:orderDepositId/payments/:paymentId/clear",
    "POST",
    options,
  );
}

export function useCreateOrderDepositsPaymentsReturnedByOrderDepositIdByPaymentId(
  options?: CustomMutationOptions<
    CreateOrderDepositsPaymentsReturnedByOrderDepositIdByPaymentIdBody,
    CreateOrderDepositsPaymentsReturnedByOrderDepositIdByPaymentIdResponse,
    CreateOrderDepositsPaymentsReturnedByOrderDepositIdByPaymentIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderDepositsPaymentsReturnedByOrderDepositIdByPaymentIdBody,
    CreateOrderDepositsPaymentsReturnedByOrderDepositIdByPaymentIdResponse,
    CreateOrderDepositsPaymentsReturnedByOrderDepositIdByPaymentIdParams
  >(
    "order-deposits",
    "/:orderDepositId/payments/:paymentId/returned",
    "POST",
    options,
  );
}

export function useCreateOrderDepositsRefundsByOrderDepositId(
  options?: CustomMutationOptions<
    CreateOrderDepositsRefundsByOrderDepositIdBody,
    CreateOrderDepositsRefundsByOrderDepositIdResponse,
    CreateOrderDepositsRefundsByOrderDepositIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderDepositsRefundsByOrderDepositIdBody,
    CreateOrderDepositsRefundsByOrderDepositIdResponse,
    CreateOrderDepositsRefundsByOrderDepositIdParams
  >("order-deposits", "/:orderDepositId/refunds", "POST", options);
}

export function useCreateOrderDepositsRefundsApproveByOrderDepositIdByRefundId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrderDepositsRefundsApproveByOrderDepositIdByRefundIdResponse,
    CreateOrderDepositsRefundsApproveByOrderDepositIdByRefundIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrderDepositsRefundsApproveByOrderDepositIdByRefundIdResponse,
    CreateOrderDepositsRefundsApproveByOrderDepositIdByRefundIdParams
  >(
    "order-deposits",
    "/:orderDepositId/refunds/:refundId/approve",
    "POST",
    options,
  );
}

export function useCreateOrderDepositsRefundsRejectByOrderDepositIdByRefundId(
  options?: CustomMutationOptions<
    CreateOrderDepositsRefundsRejectByOrderDepositIdByRefundIdBody,
    CreateOrderDepositsRefundsRejectByOrderDepositIdByRefundIdResponse,
    CreateOrderDepositsRefundsRejectByOrderDepositIdByRefundIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderDepositsRefundsRejectByOrderDepositIdByRefundIdBody,
    CreateOrderDepositsRefundsRejectByOrderDepositIdByRefundIdResponse,
    CreateOrderDepositsRefundsRejectByOrderDepositIdByRefundIdParams
  >(
    "order-deposits",
    "/:orderDepositId/refunds/:refundId/reject",
    "POST",
    options,
  );
}

export function useCreateOrderDepositsRefundsPaidOutByOrderDepositIdByRefundId(
  options?: CustomMutationOptions<
    CreateOrderDepositsRefundsPaidOutByOrderDepositIdByRefundIdBody,
    CreateOrderDepositsRefundsPaidOutByOrderDepositIdByRefundIdResponse,
    CreateOrderDepositsRefundsPaidOutByOrderDepositIdByRefundIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderDepositsRefundsPaidOutByOrderDepositIdByRefundIdBody,
    CreateOrderDepositsRefundsPaidOutByOrderDepositIdByRefundIdResponse,
    CreateOrderDepositsRefundsPaidOutByOrderDepositIdByRefundIdParams
  >(
    "order-deposits",
    "/:orderDepositId/refunds/:refundId/paid-out",
    "POST",
    options,
  );
}

export function useCreateOrderDepositsSettleCancellationByOrderDepositId(
  options?: CustomMutationOptions<
    CreateOrderDepositsSettleCancellationByOrderDepositIdBody,
    CreateOrderDepositsSettleCancellationByOrderDepositIdResponse,
    CreateOrderDepositsSettleCancellationByOrderDepositIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderDepositsSettleCancellationByOrderDepositIdBody,
    CreateOrderDepositsSettleCancellationByOrderDepositIdResponse,
    CreateOrderDepositsSettleCancellationByOrderDepositIdParams
  >("order-deposits", "/:orderDepositId/settle-cancellation", "POST", options);
}

// ============================================================================
// OrderPlans Resource
// ============================================================================

export function useUpdateOrderPlansByOrderPlanId(
  options?: CustomMutationOptions<
    UpdateOrderPlansByOrderPlanIdBody,
    UpdateOrderPlansByOrderPlanIdResponse,
    UpdateOrderPlansByOrderPlanIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateOrderPlansByOrderPlanIdBody,
    UpdateOrderPlansByOrderPlanIdResponse,
    UpdateOrderPlansByOrderPlanIdParams
  >("order-plans", "/:orderPlanId", "PUT", options);
}

// ============================================================================
// OrderQuotes Resource
// ============================================================================

export function useGetOrderQuotesCounts(): CustomQueryBuilder<
  GetOrderQuotesCountsResponse,
  Record<string, string>,
  GetOrderQuotesCountsQuery
> {
  return useResourceCustomQuery<
    GetOrderQuotesCountsResponse,
    Record<string, string>,
    GetOrderQuotesCountsQuery
  >("order-quotes", "/counts");
}

export function useGetOrderQuotesList() {
  return useListQuery<
    GetOrderQuotesListItem,
    GetOrderQuotesListResponse,
    GetOrderQuotesListFilters
  >("order-quotes", "/list");
}

export function useCreateOrderQuotesAll(
  options?: CustomMutationOptions<
    CreateOrderQuotesAllBody,
    CreateOrderQuotesAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateOrderQuotesAllBody,
    CreateOrderQuotesAllResponse
  >("order-quotes", "", "POST", options);
}

export function useGetOrderQuotesLegacyScopePreviewByOrderId(
  params: GetOrderQuotesLegacyScopePreviewByOrderIdParams,
): CustomQueryBuilder<
  GetOrderQuotesLegacyScopePreviewByOrderIdResponse,
  GetOrderQuotesLegacyScopePreviewByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrderQuotesLegacyScopePreviewByOrderIdResponse,
    GetOrderQuotesLegacyScopePreviewByOrderIdParams
  >("order-quotes", "/legacy-scope/:orderId/preview", params);
}

export function useCreateOrderQuotesLegacyScopeTransitionByOrderId(
  options?: CustomMutationOptions<
    CreateOrderQuotesLegacyScopeTransitionByOrderIdBody,
    CreateOrderQuotesLegacyScopeTransitionByOrderIdResponse,
    CreateOrderQuotesLegacyScopeTransitionByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderQuotesLegacyScopeTransitionByOrderIdBody,
    CreateOrderQuotesLegacyScopeTransitionByOrderIdResponse,
    CreateOrderQuotesLegacyScopeTransitionByOrderIdParams
  >("order-quotes", "/legacy-scope/:orderId/transition", "POST", options);
}

export function useGetOrderQuotesLegacyScopeMigration(): CustomQueryBuilder<GetOrderQuotesLegacyScopeMigrationResponse> {
  return useResourceCustomQuery<GetOrderQuotesLegacyScopeMigrationResponse>(
    "order-quotes",
    "/legacy-scope/migration",
  );
}

export function useGetOrderQuotesLegacyScopeMigrationPlanByOrderId(
  params: GetOrderQuotesLegacyScopeMigrationPlanByOrderIdParams,
): CustomQueryBuilder<
  GetOrderQuotesLegacyScopeMigrationPlanByOrderIdResponse,
  GetOrderQuotesLegacyScopeMigrationPlanByOrderIdParams,
  GetOrderQuotesLegacyScopeMigrationPlanByOrderIdQuery
> {
  return useResourceCustomQuery<
    GetOrderQuotesLegacyScopeMigrationPlanByOrderIdResponse,
    GetOrderQuotesLegacyScopeMigrationPlanByOrderIdParams,
    GetOrderQuotesLegacyScopeMigrationPlanByOrderIdQuery
  >("order-quotes", "/legacy-scope/:orderId/migration-plan", params);
}

export function useCreateOrderQuotesLegacyScopeMigrateByOrderId(
  options?: CustomMutationOptions<
    CreateOrderQuotesLegacyScopeMigrateByOrderIdBody,
    CreateOrderQuotesLegacyScopeMigrateByOrderIdResponse,
    CreateOrderQuotesLegacyScopeMigrateByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderQuotesLegacyScopeMigrateByOrderIdBody,
    CreateOrderQuotesLegacyScopeMigrateByOrderIdResponse,
    CreateOrderQuotesLegacyScopeMigrateByOrderIdParams
  >("order-quotes", "/legacy-scope/:orderId/migrate", "POST", options);
}

export function useCreateOrderQuotesIssueByQuoteId(
  options?: CustomMutationOptions<
    CreateOrderQuotesIssueByQuoteIdBody,
    CreateOrderQuotesIssueByQuoteIdResponse,
    CreateOrderQuotesIssueByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderQuotesIssueByQuoteIdBody,
    CreateOrderQuotesIssueByQuoteIdResponse,
    CreateOrderQuotesIssueByQuoteIdParams
  >("order-quotes", "/:quoteId/issue", "POST", options);
}

export function useCreateOrderQuotesUpdateByQuoteId(
  options?: CustomMutationOptions<
    CreateOrderQuotesUpdateByQuoteIdBody,
    CreateOrderQuotesUpdateByQuoteIdResponse,
    CreateOrderQuotesUpdateByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderQuotesUpdateByQuoteIdBody,
    CreateOrderQuotesUpdateByQuoteIdResponse,
    CreateOrderQuotesUpdateByQuoteIdParams
  >("order-quotes", "/:quoteId/update", "POST", options);
}

export function useCreateOrderQuotesDiscardEditsByQuoteId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrderQuotesDiscardEditsByQuoteIdResponse,
    CreateOrderQuotesDiscardEditsByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrderQuotesDiscardEditsByQuoteIdResponse,
    CreateOrderQuotesDiscardEditsByQuoteIdParams
  >("order-quotes", "/:quoteId/discard-edits", "POST", options);
}

export function useCreateOrderQuotesResendByQuoteId(
  options?: CustomMutationOptions<
    CreateOrderQuotesResendByQuoteIdBody,
    CreateOrderQuotesResendByQuoteIdResponse,
    CreateOrderQuotesResendByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderQuotesResendByQuoteIdBody,
    CreateOrderQuotesResendByQuoteIdResponse,
    CreateOrderQuotesResendByQuoteIdParams
  >("order-quotes", "/:quoteId/resend", "POST", options);
}

export function useCreateOrderQuotesReopenByQuoteId(
  options?: CustomMutationOptions<
    CreateOrderQuotesReopenByQuoteIdBody,
    CreateOrderQuotesReopenByQuoteIdResponse,
    CreateOrderQuotesReopenByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderQuotesReopenByQuoteIdBody,
    CreateOrderQuotesReopenByQuoteIdResponse,
    CreateOrderQuotesReopenByQuoteIdParams
  >("order-quotes", "/:quoteId/reopen", "POST", options);
}

export function useCreateOrderQuotesCancelByQuoteId(
  options?: CustomMutationOptions<
    CreateOrderQuotesCancelByQuoteIdBody,
    CreateOrderQuotesCancelByQuoteIdResponse,
    CreateOrderQuotesCancelByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderQuotesCancelByQuoteIdBody,
    CreateOrderQuotesCancelByQuoteIdResponse,
    CreateOrderQuotesCancelByQuoteIdParams
  >("order-quotes", "/:quoteId/cancel", "POST", options);
}

export function useCreateOrderQuotesDuplicateByQuoteId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrderQuotesDuplicateByQuoteIdResponse,
    CreateOrderQuotesDuplicateByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrderQuotesDuplicateByQuoteIdResponse,
    CreateOrderQuotesDuplicateByQuoteIdParams
  >("order-quotes", "/:quoteId/duplicate", "POST", options);
}

export function useCreateOrderQuotesCollectDepositByQuoteId(
  options?: CustomMutationOptions<
    CreateOrderQuotesCollectDepositByQuoteIdBody,
    CreateOrderQuotesCollectDepositByQuoteIdResponse,
    CreateOrderQuotesCollectDepositByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderQuotesCollectDepositByQuoteIdBody,
    CreateOrderQuotesCollectDepositByQuoteIdResponse,
    CreateOrderQuotesCollectDepositByQuoteIdParams
  >("order-quotes", "/:quoteId/collect-deposit", "POST", options);
}

export function useCreateOrderQuotesDepositRequestsByQuoteId(
  options?: CustomMutationOptions<
    CreateOrderQuotesDepositRequestsByQuoteIdBody,
    CreateOrderQuotesDepositRequestsByQuoteIdResponse,
    CreateOrderQuotesDepositRequestsByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderQuotesDepositRequestsByQuoteIdBody,
    CreateOrderQuotesDepositRequestsByQuoteIdResponse,
    CreateOrderQuotesDepositRequestsByQuoteIdParams
  >("order-quotes", "/:quoteId/deposit-requests", "POST", options);
}

export function useCreateOrderQuotesOptionsByQuoteId(
  options?: CustomMutationOptions<
    CreateOrderQuotesOptionsByQuoteIdBody,
    CreateOrderQuotesOptionsByQuoteIdResponse,
    CreateOrderQuotesOptionsByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderQuotesOptionsByQuoteIdBody,
    CreateOrderQuotesOptionsByQuoteIdResponse,
    CreateOrderQuotesOptionsByQuoteIdParams
  >("order-quotes", "/:quoteId/options", "POST", options);
}

export function useUpdateOrderQuotesOptionsByQuoteIdByOptionId(
  options?: CustomMutationOptions<
    UpdateOrderQuotesOptionsByQuoteIdByOptionIdBody,
    UpdateOrderQuotesOptionsByQuoteIdByOptionIdResponse,
    UpdateOrderQuotesOptionsByQuoteIdByOptionIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateOrderQuotesOptionsByQuoteIdByOptionIdBody,
    UpdateOrderQuotesOptionsByQuoteIdByOptionIdResponse,
    UpdateOrderQuotesOptionsByQuoteIdByOptionIdParams
  >("order-quotes", "/:quoteId/options/:optionId", "PATCH", options);
}

export function useDeleteOrderQuotesOptionsByQuoteIdByOptionId(
  options?: CustomMutationOptions<
    unknown,
    DeleteOrderQuotesOptionsByQuoteIdByOptionIdResponse,
    DeleteOrderQuotesOptionsByQuoteIdByOptionIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteOrderQuotesOptionsByQuoteIdByOptionIdResponse,
    DeleteOrderQuotesOptionsByQuoteIdByOptionIdParams
  >("order-quotes", "/:quoteId/options/:optionId", "DELETE", options);
}

export function useCreateOrderQuotesOptionsRecommendedByQuoteIdByOptionId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrderQuotesOptionsRecommendedByQuoteIdByOptionIdResponse,
    CreateOrderQuotesOptionsRecommendedByQuoteIdByOptionIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrderQuotesOptionsRecommendedByQuoteIdByOptionIdResponse,
    CreateOrderQuotesOptionsRecommendedByQuoteIdByOptionIdParams
  >("order-quotes", "/:quoteId/options/:optionId/recommended", "POST", options);
}

export function useDeleteOrderQuotesOptionsRecommendedByQuoteIdByOptionId(
  options?: CustomMutationOptions<
    unknown,
    DeleteOrderQuotesOptionsRecommendedByQuoteIdByOptionIdResponse,
    DeleteOrderQuotesOptionsRecommendedByQuoteIdByOptionIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteOrderQuotesOptionsRecommendedByQuoteIdByOptionIdResponse,
    DeleteOrderQuotesOptionsRecommendedByQuoteIdByOptionIdParams
  >(
    "order-quotes",
    "/:quoteId/options/:optionId/recommended",
    "DELETE",
    options,
  );
}

export function useGetOrderQuotesByQuoteId(
  params: GetOrderQuotesByQuoteIdParams,
): CustomQueryBuilder<
  GetOrderQuotesByQuoteIdResponse,
  GetOrderQuotesByQuoteIdParams
> {
  return useResourceCustomQuery<
    GetOrderQuotesByQuoteIdResponse,
    GetOrderQuotesByQuoteIdParams
  >("order-quotes", "/:quoteId", params);
}

export function useUpdateOrderQuotesByQuoteId(
  options?: CustomMutationOptions<
    UpdateOrderQuotesByQuoteIdBody,
    UpdateOrderQuotesByQuoteIdResponse,
    UpdateOrderQuotesByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateOrderQuotesByQuoteIdBody,
    UpdateOrderQuotesByQuoteIdResponse,
    UpdateOrderQuotesByQuoteIdParams
  >("order-quotes", "/:quoteId", "PATCH", options);
}

export function useDeleteOrderQuotesByQuoteId(
  options?: CustomMutationOptions<
    unknown,
    DeleteOrderQuotesByQuoteIdResponse,
    DeleteOrderQuotesByQuoteIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteOrderQuotesByQuoteIdResponse,
    DeleteOrderQuotesByQuoteIdParams
  >("order-quotes", "/:quoteId", "DELETE", options);
}

export function useGetOrderQuotesDepositByQuoteId(
  params: GetOrderQuotesDepositByQuoteIdParams,
): CustomQueryBuilder<
  GetOrderQuotesDepositByQuoteIdResponse,
  GetOrderQuotesDepositByQuoteIdParams
> {
  return useResourceCustomQuery<
    GetOrderQuotesDepositByQuoteIdResponse,
    GetOrderQuotesDepositByQuoteIdParams
  >("order-quotes", "/:quoteId/deposit", params);
}

// ============================================================================
// OrderRequests Resource
// ============================================================================

export function useGetOrderRequestsStatuses(): CustomQueryBuilder<
  GetOrderRequestsStatusesResponse,
  Record<string, string>,
  GetOrderRequestsStatusesQuery
> {
  return useResourceCustomQuery<
    GetOrderRequestsStatusesResponse,
    Record<string, string>,
    GetOrderRequestsStatusesQuery
  >("order-requests", "/statuses");
}

export function useGetOrderRequestsList() {
  return useListQuery<
    GetOrderRequestsListItem,
    GetOrderRequestsListResponse,
    GetOrderRequestsListFilters
  >("order-requests", "/list");
}

export function useGetOrderRequestsGroupCounts(): CustomQueryBuilder<
  GetOrderRequestsGroupCountsResponse,
  Record<string, string>,
  GetOrderRequestsGroupCountsQuery
> {
  return useResourceCustomQuery<
    GetOrderRequestsGroupCountsResponse,
    Record<string, string>,
    GetOrderRequestsGroupCountsQuery
  >("order-requests", "/group-counts");
}

export function useGetOrderRequestsItemsTitleSuggestions(): CustomQueryBuilder<
  GetOrderRequestsItemsTitleSuggestionsResponse,
  Record<string, string>,
  GetOrderRequestsItemsTitleSuggestionsQuery
> {
  return useResourceCustomQuery<
    GetOrderRequestsItemsTitleSuggestionsResponse,
    Record<string, string>,
    GetOrderRequestsItemsTitleSuggestionsQuery
  >("order-requests", "/items/title-suggestions");
}

export function useGetOrderRequestsItemsSuggestByOrderRequestId(
  params: GetOrderRequestsItemsSuggestByOrderRequestIdParams,
): CustomQueryBuilder<
  GetOrderRequestsItemsSuggestByOrderRequestIdResponse,
  GetOrderRequestsItemsSuggestByOrderRequestIdParams,
  GetOrderRequestsItemsSuggestByOrderRequestIdQuery,
  GetOrderRequestsItemsSuggestByOrderRequestIdExtra
> {
  return useResourceCustomQuery<
    GetOrderRequestsItemsSuggestByOrderRequestIdResponse,
    GetOrderRequestsItemsSuggestByOrderRequestIdParams,
    GetOrderRequestsItemsSuggestByOrderRequestIdQuery,
    GetOrderRequestsItemsSuggestByOrderRequestIdExtra
  >("order-requests", "/:orderRequestId/items/suggest", params);
}

export function useGetOrderRequestsActivitiesByOrderRequestId(
  params: GetOrderRequestsActivitiesByOrderRequestIdParams,
): CustomQueryBuilder<
  GetOrderRequestsActivitiesByOrderRequestIdResponse,
  GetOrderRequestsActivitiesByOrderRequestIdParams,
  GetOrderRequestsActivitiesByOrderRequestIdQuery,
  GetOrderRequestsActivitiesByOrderRequestIdExtra
> {
  return useResourceCustomQuery<
    GetOrderRequestsActivitiesByOrderRequestIdResponse,
    GetOrderRequestsActivitiesByOrderRequestIdParams,
    GetOrderRequestsActivitiesByOrderRequestIdQuery,
    GetOrderRequestsActivitiesByOrderRequestIdExtra
  >("order-requests", "/:orderRequestId/activities", params);
}

export function useGetOrderRequestsTimeInStatusByOrderRequestId(
  params: GetOrderRequestsTimeInStatusByOrderRequestIdParams,
): CustomQueryBuilder<
  GetOrderRequestsTimeInStatusByOrderRequestIdResponse,
  GetOrderRequestsTimeInStatusByOrderRequestIdParams
> {
  return useResourceCustomQuery<
    GetOrderRequestsTimeInStatusByOrderRequestIdResponse,
    GetOrderRequestsTimeInStatusByOrderRequestIdParams
  >("order-requests", "/:orderRequestId/time-in-status", params);
}

export function useGetOrderRequestsSubscribersByOrderRequestId(
  params: GetOrderRequestsSubscribersByOrderRequestIdParams,
): CustomQueryBuilder<
  GetOrderRequestsSubscribersByOrderRequestIdResponse,
  GetOrderRequestsSubscribersByOrderRequestIdParams
> {
  return useResourceCustomQuery<
    GetOrderRequestsSubscribersByOrderRequestIdResponse,
    GetOrderRequestsSubscribersByOrderRequestIdParams
  >("order-requests", "/:orderRequestId/subscribers", params);
}

export function useUpdateOrderRequestsSubscribersByOrderRequestId(
  options?: CustomMutationOptions<
    UpdateOrderRequestsSubscribersByOrderRequestIdBody,
    UpdateOrderRequestsSubscribersByOrderRequestIdResponse,
    UpdateOrderRequestsSubscribersByOrderRequestIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateOrderRequestsSubscribersByOrderRequestIdBody,
    UpdateOrderRequestsSubscribersByOrderRequestIdResponse,
    UpdateOrderRequestsSubscribersByOrderRequestIdParams
  >("order-requests", "/:orderRequestId/subscribers", "PUT", options);
}

export function useCreateOrderRequestsCreateOrderRequest(
  options?: CustomMutationOptions<
    CreateOrderRequestsCreateOrderRequestBody,
    CreateOrderRequestsCreateOrderRequestResponse
  >,
) {
  return useResourceCustomMutation<
    CreateOrderRequestsCreateOrderRequestBody,
    CreateOrderRequestsCreateOrderRequestResponse
  >("order-requests", "/create-order-request", "POST", options);
}

export function useCreateOrderRequestsItemsByOrderRequestId(
  options?: CustomMutationOptions<
    CreateOrderRequestsItemsByOrderRequestIdBody,
    CreateOrderRequestsItemsByOrderRequestIdResponse,
    CreateOrderRequestsItemsByOrderRequestIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderRequestsItemsByOrderRequestIdBody,
    CreateOrderRequestsItemsByOrderRequestIdResponse,
    CreateOrderRequestsItemsByOrderRequestIdParams
  >("order-requests", "/:orderRequestId/items", "POST", options);
}

export function useUpdateOrderRequestsItemsByOrderRequestIdByItemId(
  options?: CustomMutationOptions<
    UpdateOrderRequestsItemsByOrderRequestIdByItemIdBody,
    UpdateOrderRequestsItemsByOrderRequestIdByItemIdResponse,
    UpdateOrderRequestsItemsByOrderRequestIdByItemIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateOrderRequestsItemsByOrderRequestIdByItemIdBody,
    UpdateOrderRequestsItemsByOrderRequestIdByItemIdResponse,
    UpdateOrderRequestsItemsByOrderRequestIdByItemIdParams
  >("order-requests", "/:orderRequestId/items/:itemId", "PATCH", options);
}

export function useDeleteOrderRequestsItemsByOrderRequestIdByItemId(
  options?: CustomMutationOptions<
    unknown,
    DeleteOrderRequestsItemsByOrderRequestIdByItemIdResponse,
    DeleteOrderRequestsItemsByOrderRequestIdByItemIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteOrderRequestsItemsByOrderRequestIdByItemIdResponse,
    DeleteOrderRequestsItemsByOrderRequestIdByItemIdParams
  >("order-requests", "/:orderRequestId/items/:itemId", "DELETE", options);
}

export function useCreateOrderRequestsConvertByOrderRequestId(
  options?: CustomMutationOptions<
    CreateOrderRequestsConvertByOrderRequestIdBody,
    CreateOrderRequestsConvertByOrderRequestIdResponse,
    CreateOrderRequestsConvertByOrderRequestIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderRequestsConvertByOrderRequestIdBody,
    CreateOrderRequestsConvertByOrderRequestIdResponse,
    CreateOrderRequestsConvertByOrderRequestIdParams
  >("order-requests", "/:orderRequestId/convert", "POST", options);
}

export function useCreateOrderRequestsAddToOrderByOrderRequestId(
  options?: CustomMutationOptions<
    CreateOrderRequestsAddToOrderByOrderRequestIdBody,
    CreateOrderRequestsAddToOrderByOrderRequestIdResponse,
    CreateOrderRequestsAddToOrderByOrderRequestIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderRequestsAddToOrderByOrderRequestIdBody,
    CreateOrderRequestsAddToOrderByOrderRequestIdResponse,
    CreateOrderRequestsAddToOrderByOrderRequestIdParams
  >("order-requests", "/:orderRequestId/add-to-order", "POST", options);
}

export function useCreateOrderRequestsCancelByOrderRequestId(
  options?: CustomMutationOptions<
    CreateOrderRequestsCancelByOrderRequestIdBody,
    CreateOrderRequestsCancelByOrderRequestIdResponse,
    CreateOrderRequestsCancelByOrderRequestIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrderRequestsCancelByOrderRequestIdBody,
    CreateOrderRequestsCancelByOrderRequestIdResponse,
    CreateOrderRequestsCancelByOrderRequestIdParams
  >("order-requests", "/:orderRequestId/cancel", "POST", options);
}

export function useCreateOrderRequestsRestoreByOrderRequestId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrderRequestsRestoreByOrderRequestIdResponse,
    CreateOrderRequestsRestoreByOrderRequestIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrderRequestsRestoreByOrderRequestIdResponse,
    CreateOrderRequestsRestoreByOrderRequestIdParams
  >("order-requests", "/:orderRequestId/restore", "POST", options);
}

export function useGetOrderRequestsByOrderRequestId(
  params: GetOrderRequestsByOrderRequestIdParams,
): CustomQueryBuilder<
  GetOrderRequestsByOrderRequestIdResponse,
  GetOrderRequestsByOrderRequestIdParams
> {
  return useResourceCustomQuery<
    GetOrderRequestsByOrderRequestIdResponse,
    GetOrderRequestsByOrderRequestIdParams
  >("order-requests", "/:orderRequestId", params);
}

export function useUpdateOrderRequestsByOrderRequestId(
  options?: CustomMutationOptions<
    UpdateOrderRequestsByOrderRequestIdBody,
    UpdateOrderRequestsByOrderRequestIdResponse,
    UpdateOrderRequestsByOrderRequestIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateOrderRequestsByOrderRequestIdBody,
    UpdateOrderRequestsByOrderRequestIdResponse,
    UpdateOrderRequestsByOrderRequestIdParams
  >("order-requests", "/:orderRequestId", "PATCH", options);
}

// ============================================================================
// Orders Resource
// ============================================================================

export function useGetOrdersStatuses(): CustomQueryBuilder<
  GetOrdersStatusesResponse,
  Record<string, string>,
  GetOrdersStatusesQuery
> {
  return useResourceCustomQuery<
    GetOrdersStatusesResponse,
    Record<string, string>,
    GetOrdersStatusesQuery
  >("orders", "/statuses");
}

export function useGetOrdersFeedbackList(): CustomQueryBuilder<
  GetOrdersFeedbackListResponse,
  Record<string, string>,
  GetOrdersFeedbackListQuery,
  GetOrdersFeedbackListExtra
> {
  return useResourceCustomQuery<
    GetOrdersFeedbackListResponse,
    Record<string, string>,
    GetOrdersFeedbackListQuery,
    GetOrdersFeedbackListExtra
  >("orders", "/feedback/list");
}

export function useGetOrdersFeedbackTags(): CustomQueryBuilder<
  GetOrdersFeedbackTagsResponse,
  Record<string, string>,
  Record<string, unknown>,
  GetOrdersFeedbackTagsExtra
> {
  return useResourceCustomQuery<
    GetOrdersFeedbackTagsResponse,
    Record<string, string>,
    Record<string, unknown>,
    GetOrdersFeedbackTagsExtra
  >("orders", "/feedback/tags");
}

export function useGetOrdersFeedbackByFeedbackId(
  params: GetOrdersFeedbackByFeedbackIdParams,
): CustomQueryBuilder<
  GetOrdersFeedbackByFeedbackIdResponse,
  GetOrdersFeedbackByFeedbackIdParams
> {
  return useResourceCustomQuery<
    GetOrdersFeedbackByFeedbackIdResponse,
    GetOrdersFeedbackByFeedbackIdParams
  >("orders", "/feedback/:feedbackId", params);
}

export function useGetOrdersScopeByOrderId(
  params: GetOrdersScopeByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersScopeByOrderIdResponse,
  GetOrdersScopeByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersScopeByOrderIdResponse,
    GetOrdersScopeByOrderIdParams
  >("orders", "/:orderId/scope", params);
}

export function useGetOrdersPublicByOrderId(
  params: GetOrdersPublicByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersPublicByOrderIdResponse,
  GetOrdersPublicByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersPublicByOrderIdResponse,
    GetOrdersPublicByOrderIdParams
  >("orders", "/public/:orderId", params);
}

export function useGetOrdersLastedTimePreferencesByOrderId(
  params: GetOrdersLastedTimePreferencesByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersLastedTimePreferencesByOrderIdResponse,
  GetOrdersLastedTimePreferencesByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersLastedTimePreferencesByOrderIdResponse,
    GetOrdersLastedTimePreferencesByOrderIdParams
  >("orders", "/:orderId/lasted-time-preferences", params);
}

export function useGetOrdersProfitByOrderId(
  params: GetOrdersProfitByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersProfitByOrderIdResponse,
  GetOrdersProfitByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersProfitByOrderIdResponse,
    GetOrdersProfitByOrderIdParams
  >("orders", "/:orderId/profit", params);
}

export function useGetOrdersRevenuesByOrderId(
  params: GetOrdersRevenuesByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersRevenuesByOrderIdResponse,
  GetOrdersRevenuesByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersRevenuesByOrderIdResponse,
    GetOrdersRevenuesByOrderIdParams
  >("orders", "/:orderId/revenues", params);
}

export function useGetOrdersExpensesByOrderId(
  params: GetOrdersExpensesByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersExpensesByOrderIdResponse,
  GetOrdersExpensesByOrderIdParams,
  Record<string, unknown>,
  GetOrdersExpensesByOrderIdExtra
> {
  return useResourceCustomQuery<
    GetOrdersExpensesByOrderIdResponse,
    GetOrdersExpensesByOrderIdParams,
    Record<string, unknown>,
    GetOrdersExpensesByOrderIdExtra
  >("orders", "/:orderId/expenses", params);
}

export function useGetOrdersTimeInStatusByOrderId(
  params: GetOrdersTimeInStatusByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersTimeInStatusByOrderIdResponse,
  GetOrdersTimeInStatusByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersTimeInStatusByOrderIdResponse,
    GetOrdersTimeInStatusByOrderIdParams
  >("orders", "/:orderId/time-in-status", params);
}

export function useGetOrdersActivitiesByOrderId(
  params: GetOrdersActivitiesByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersActivitiesByOrderIdResponse,
  GetOrdersActivitiesByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersActivitiesByOrderIdResponse,
    GetOrdersActivitiesByOrderIdParams
  >("orders", "/:orderId/activities", params);
}

export function useGetOrdersAttachmentsByOrderId(
  params: GetOrdersAttachmentsByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersAttachmentsByOrderIdResponse,
  GetOrdersAttachmentsByOrderIdParams,
  GetOrdersAttachmentsByOrderIdQuery
> {
  return useResourceCustomQuery<
    GetOrdersAttachmentsByOrderIdResponse,
    GetOrdersAttachmentsByOrderIdParams,
    GetOrdersAttachmentsByOrderIdQuery
  >("orders", "/:orderId/attachments", params);
}

export function useCreateOrdersAttachmentsByOrderId(
  options?: CustomMutationOptions<
    CreateOrdersAttachmentsByOrderIdBody,
    CreateOrdersAttachmentsByOrderIdResponse,
    CreateOrdersAttachmentsByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersAttachmentsByOrderIdBody,
    CreateOrdersAttachmentsByOrderIdResponse,
    CreateOrdersAttachmentsByOrderIdParams
  >("orders", "/:orderId/attachments", "POST", options);
}

export function useDeleteOrdersAttachmentsByOrderId(
  options?: CustomMutationOptions<
    DeleteOrdersAttachmentsByOrderIdBody,
    DeleteOrdersAttachmentsByOrderIdResponse,
    DeleteOrdersAttachmentsByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    DeleteOrdersAttachmentsByOrderIdBody,
    DeleteOrdersAttachmentsByOrderIdResponse,
    DeleteOrdersAttachmentsByOrderIdParams
  >("orders", "/:orderId/attachments", "DELETE", options);
}

export function useGetOrdersToneByOrderId(
  params: GetOrdersToneByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersToneByOrderIdResponse,
  GetOrdersToneByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersToneByOrderIdResponse,
    GetOrdersToneByOrderIdParams
  >("orders", "/:orderId/tone", params);
}

export function useGetOrdersConversationSummaryByOrderId(
  params: GetOrdersConversationSummaryByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersConversationSummaryByOrderIdResponse,
  GetOrdersConversationSummaryByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersConversationSummaryByOrderIdResponse,
    GetOrdersConversationSummaryByOrderIdParams
  >("orders", "/:orderId/conversation-summary", params);
}

export function useGetOrdersAiSummaryByOrderId(
  params: GetOrdersAiSummaryByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersAiSummaryByOrderIdResponse,
  GetOrdersAiSummaryByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersAiSummaryByOrderIdResponse,
    GetOrdersAiSummaryByOrderIdParams
  >("orders", "/:orderId/ai-summary", params);
}

export function useCreateOrdersAiSummaryRegenerateByOrderId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrdersAiSummaryRegenerateByOrderIdResponse,
    CreateOrdersAiSummaryRegenerateByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrdersAiSummaryRegenerateByOrderIdResponse,
    CreateOrdersAiSummaryRegenerateByOrderIdParams
  >("orders", "/:orderId/ai-summary/regenerate", "POST", options);
}

export function useGetOrdersBirdieTipsByOrderId(
  params: GetOrdersBirdieTipsByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersBirdieTipsByOrderIdResponse,
  GetOrdersBirdieTipsByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersBirdieTipsByOrderIdResponse,
    GetOrdersBirdieTipsByOrderIdParams
  >("orders", "/:orderId/birdie-tips", params);
}

export function useCreateOrdersBirdieTipsRegenerateByOrderId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrdersBirdieTipsRegenerateByOrderIdResponse,
    CreateOrdersBirdieTipsRegenerateByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrdersBirdieTipsRegenerateByOrderIdResponse,
    CreateOrdersBirdieTipsRegenerateByOrderIdParams
  >("orders", "/:orderId/birdie-tips/regenerate", "POST", options);
}

export function useCreateOrdersComposeMessageByOrderId(
  options?: CustomMutationOptions<
    CreateOrdersComposeMessageByOrderIdBody,
    unknown,
    CreateOrdersComposeMessageByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersComposeMessageByOrderIdBody,
    unknown,
    CreateOrdersComposeMessageByOrderIdParams
  >("orders", "/:orderId/compose-message", "POST", options);
}

export function useCreateOrdersVisitInstructionByOrderId(
  options?: CustomMutationOptions<
    CreateOrdersVisitInstructionByOrderIdBody,
    CreateOrdersVisitInstructionByOrderIdResponse,
    CreateOrdersVisitInstructionByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersVisitInstructionByOrderIdBody,
    CreateOrdersVisitInstructionByOrderIdResponse,
    CreateOrdersVisitInstructionByOrderIdParams
  >("orders", "/:orderId/visit-instruction", "POST", options);
}

export function useCreateOrdersVisitInstructionAutofillByOrderId(
  options?: CustomMutationOptions<
    CreateOrdersVisitInstructionAutofillByOrderIdBody,
    CreateOrdersVisitInstructionAutofillByOrderIdResponse,
    CreateOrdersVisitInstructionAutofillByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersVisitInstructionAutofillByOrderIdBody,
    CreateOrdersVisitInstructionAutofillByOrderIdResponse,
    CreateOrdersVisitInstructionAutofillByOrderIdParams
  >("orders", "/:orderId/visit-instruction/autofill", "POST", options);
}

export function useGetOrdersLinkedOrdersByOrderId(
  params: GetOrdersLinkedOrdersByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersLinkedOrdersByOrderIdResponse,
  GetOrdersLinkedOrdersByOrderIdParams,
  GetOrdersLinkedOrdersByOrderIdQuery
> {
  return useResourceCustomQuery<
    GetOrdersLinkedOrdersByOrderIdResponse,
    GetOrdersLinkedOrdersByOrderIdParams,
    GetOrdersLinkedOrdersByOrderIdQuery
  >("orders", "/:orderId/linked-orders", params);
}

export function useGetOrdersHomecarePlanOrdersByOrderId(
  params: GetOrdersHomecarePlanOrdersByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersHomecarePlanOrdersByOrderIdResponse,
  GetOrdersHomecarePlanOrdersByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersHomecarePlanOrdersByOrderIdResponse,
    GetOrdersHomecarePlanOrdersByOrderIdParams
  >("orders", "/:orderId/homecare-plan-orders", params);
}

export function useCreateOrdersHomecarePlanOrdersByOrderId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrdersHomecarePlanOrdersByOrderIdResponse,
    CreateOrdersHomecarePlanOrdersByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrdersHomecarePlanOrdersByOrderIdResponse,
    CreateOrdersHomecarePlanOrdersByOrderIdParams
  >("orders", "/:orderId/homecare-plan-orders", "POST", options);
}

export function useGetOrdersOrderMonthList() {
  return useListQuery<
    GetOrdersOrderMonthListItem,
    GetOrdersOrderMonthListResponse,
    GetOrdersOrderMonthListFilters
  >("orders", "/order-month/list");
}

export function useGetOrdersList() {
  return useListQuery<
    GetOrdersListItem,
    GetOrdersListResponse,
    GetOrdersListFilters
  >("orders", "/list");
}

export function useGetOrdersDepositsByOrderId(
  params: GetOrdersDepositsByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersDepositsByOrderIdResponse,
  GetOrdersDepositsByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersDepositsByOrderIdResponse,
    GetOrdersDepositsByOrderIdParams
  >("orders", "/:orderId/deposits", params);
}

export function useGetOrdersInvoicesAndPaymentsByOrderId(
  params: GetOrdersInvoicesAndPaymentsByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersInvoicesAndPaymentsByOrderIdResponse,
  GetOrdersInvoicesAndPaymentsByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersInvoicesAndPaymentsByOrderIdResponse,
    GetOrdersInvoicesAndPaymentsByOrderIdParams
  >("orders", "/:orderId/invoices-and-payments", params);
}

export function useGetOrdersCustomerAccountsByOrderId(
  params: GetOrdersCustomerAccountsByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersCustomerAccountsByOrderIdResponse,
  GetOrdersCustomerAccountsByOrderIdParams
> {
  return useResourceCustomQuery<
    GetOrdersCustomerAccountsByOrderIdResponse,
    GetOrdersCustomerAccountsByOrderIdParams
  >("orders", "/:orderId/customer-accounts", params);
}

export function useGetOrdersBrexBillsByOrderId(
  params: GetOrdersBrexBillsByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersBrexBillsByOrderIdResponse,
  GetOrdersBrexBillsByOrderIdParams,
  GetOrdersBrexBillsByOrderIdQuery
> {
  return useResourceCustomQuery<
    GetOrdersBrexBillsByOrderIdResponse,
    GetOrdersBrexBillsByOrderIdParams,
    GetOrdersBrexBillsByOrderIdQuery
  >("orders", "/:orderId/brex-bills", params);
}

export function useCreateOrdersBillingReleaseByOrderId(
  options?: CustomMutationOptions<
    CreateOrdersBillingReleaseByOrderIdBody,
    CreateOrdersBillingReleaseByOrderIdResponse,
    CreateOrdersBillingReleaseByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersBillingReleaseByOrderIdBody,
    CreateOrdersBillingReleaseByOrderIdResponse,
    CreateOrdersBillingReleaseByOrderIdParams
  >("orders", "/:orderId/billing-release", "POST", options);
}

export function useDeleteOrdersBillingReleaseByOrderId(
  options?: CustomMutationOptions<
    unknown,
    DeleteOrdersBillingReleaseByOrderIdResponse,
    DeleteOrdersBillingReleaseByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteOrdersBillingReleaseByOrderIdResponse,
    DeleteOrdersBillingReleaseByOrderIdParams
  >("orders", "/:orderId/billing-release", "DELETE", options);
}

export function useGetOrdersByOrderId(
  params: GetOrdersByOrderIdParams,
): CustomQueryBuilder<
  GetOrdersByOrderIdResponse,
  GetOrdersByOrderIdParams,
  GetOrdersByOrderIdQuery
> {
  return useResourceCustomQuery<
    GetOrdersByOrderIdResponse,
    GetOrdersByOrderIdParams,
    GetOrdersByOrderIdQuery
  >("orders", "/:orderId", params);
}

export function useUpdateOrdersByOrderId(
  options?: CustomMutationOptions<
    UpdateOrdersByOrderIdBody,
    UpdateOrdersByOrderIdResponse,
    UpdateOrdersByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateOrdersByOrderIdBody,
    UpdateOrdersByOrderIdResponse,
    UpdateOrdersByOrderIdParams
  >("orders", "/:orderId", "PATCH", options);
}

export function useDeleteOrdersByOrderId(
  options?: CustomMutationOptions<
    unknown,
    DeleteOrdersByOrderIdResponse,
    DeleteOrdersByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteOrdersByOrderIdResponse,
    DeleteOrdersByOrderIdParams
  >("orders", "/:orderId", "DELETE", options);
}

export function useCreateOrdersCreateOrder(
  options?: CustomMutationOptions<
    CreateOrdersCreateOrderBody,
    CreateOrdersCreateOrderResponse
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersCreateOrderBody,
    CreateOrdersCreateOrderResponse
  >("orders", "/create-order", "POST", options);
}

export function useCreateOrdersRequestOrder(
  options?: CustomMutationOptions<
    CreateOrdersRequestOrderBody,
    CreateOrdersRequestOrderResponse
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersRequestOrderBody,
    CreateOrdersRequestOrderResponse
  >("orders", "/request-order", "POST", options);
}

export function useCreateOrdersAddVendorByOrderId(
  options?: CustomMutationOptions<
    CreateOrdersAddVendorByOrderIdBody,
    CreateOrdersAddVendorByOrderIdResponse,
    CreateOrdersAddVendorByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersAddVendorByOrderIdBody,
    CreateOrdersAddVendorByOrderIdResponse,
    CreateOrdersAddVendorByOrderIdParams
  >("orders", "/:orderId/add-vendor", "POST", options);
}

export function useCreateOrdersRemoveVendorByOrderId(
  options?: CustomMutationOptions<
    CreateOrdersRemoveVendorByOrderIdBody,
    CreateOrdersRemoveVendorByOrderIdResponse,
    CreateOrdersRemoveVendorByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersRemoveVendorByOrderIdBody,
    CreateOrdersRemoveVendorByOrderIdResponse,
    CreateOrdersRemoveVendorByOrderIdParams
  >("orders", "/:orderId/remove-vendor", "POST", options);
}

export function useCreateOrdersMakeVendorPrimaryByOrderId(
  options?: CustomMutationOptions<
    CreateOrdersMakeVendorPrimaryByOrderIdBody,
    CreateOrdersMakeVendorPrimaryByOrderIdResponse,
    CreateOrdersMakeVendorPrimaryByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersMakeVendorPrimaryByOrderIdBody,
    CreateOrdersMakeVendorPrimaryByOrderIdResponse,
    CreateOrdersMakeVendorPrimaryByOrderIdParams
  >("orders", "/:orderId/make-vendor-primary", "POST", options);
}

export function useDeleteOrdersDraftByOrderId(
  options?: CustomMutationOptions<
    unknown,
    DeleteOrdersDraftByOrderIdResponse,
    DeleteOrdersDraftByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteOrdersDraftByOrderIdResponse,
    DeleteOrdersDraftByOrderIdParams
  >("orders", "/:orderId/draft", "DELETE", options);
}

export function useCreateOrdersPublishByOrderId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrdersPublishByOrderIdResponse,
    CreateOrdersPublishByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrdersPublishByOrderIdResponse,
    CreateOrdersPublishByOrderIdParams
  >("orders", "/:orderId/publish", "POST", options);
}

export function useCreateOrdersFlagByOrderId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrdersFlagByOrderIdResponse,
    CreateOrdersFlagByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrdersFlagByOrderIdResponse,
    CreateOrdersFlagByOrderIdParams
  >("orders", "/:orderId/flag", "POST", options);
}

export function useDeleteOrdersFlagByOrderId(
  options?: CustomMutationOptions<
    unknown,
    DeleteOrdersFlagByOrderIdResponse,
    DeleteOrdersFlagByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteOrdersFlagByOrderIdResponse,
    DeleteOrdersFlagByOrderIdParams
  >("orders", "/:orderId/flag", "DELETE", options);
}

export function useCreateOrdersRelateByOrderId(
  options?: CustomMutationOptions<
    CreateOrdersRelateByOrderIdBody,
    CreateOrdersRelateByOrderIdResponse,
    CreateOrdersRelateByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersRelateByOrderIdBody,
    CreateOrdersRelateByOrderIdResponse,
    CreateOrdersRelateByOrderIdParams
  >("orders", "/:orderId/relate", "POST", options);
}

export function useCreateOrdersUnrelateByOrderId(
  options?: CustomMutationOptions<
    CreateOrdersUnrelateByOrderIdBody,
    CreateOrdersUnrelateByOrderIdResponse,
    CreateOrdersUnrelateByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateOrdersUnrelateByOrderIdBody,
    CreateOrdersUnrelateByOrderIdResponse,
    CreateOrdersUnrelateByOrderIdParams
  >("orders", "/:orderId/unrelate", "POST", options);
}

export function useCreateOrdersFeedbackGoogleReviewCountIncrement(
  options?: CustomMutationOptions<
    unknown,
    CreateOrdersFeedbackGoogleReviewCountIncrementResponse
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrdersFeedbackGoogleReviewCountIncrementResponse
  >("orders", "/feedback/google-review-count/increment", "POST", options);
}

export function useCreateOrdersFeedbackRequestByOrderId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrdersFeedbackRequestByOrderIdResponse,
    CreateOrdersFeedbackRequestByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrdersFeedbackRequestByOrderIdResponse,
    CreateOrdersFeedbackRequestByOrderIdParams
  >("orders", "/:orderId/feedback-request", "POST", options);
}

export function useDeleteOrdersFeedbackRequestByOrderId(
  options?: CustomMutationOptions<
    unknown,
    DeleteOrdersFeedbackRequestByOrderIdResponse,
    DeleteOrdersFeedbackRequestByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteOrdersFeedbackRequestByOrderIdResponse,
    DeleteOrdersFeedbackRequestByOrderIdParams
  >("orders", "/:orderId/feedback-request", "DELETE", options);
}

export function useUpdateOrdersFeedbackByOrderId(
  options?: CustomMutationOptions<
    UpdateOrdersFeedbackByOrderIdBody,
    UpdateOrdersFeedbackByOrderIdResponse,
    UpdateOrdersFeedbackByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateOrdersFeedbackByOrderIdBody,
    UpdateOrdersFeedbackByOrderIdResponse,
    UpdateOrdersFeedbackByOrderIdParams
  >("orders", "/:orderId/feedback", "PUT", options);
}

export function useUpdateOrdersSubscribersByOrderId(
  options?: CustomMutationOptions<
    UpdateOrdersSubscribersByOrderIdBody,
    UpdateOrdersSubscribersByOrderIdResponse,
    UpdateOrdersSubscribersByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateOrdersSubscribersByOrderIdBody,
    UpdateOrdersSubscribersByOrderIdResponse,
    UpdateOrdersSubscribersByOrderIdParams
  >("orders", "/:orderId/subscribers", "PUT", options);
}

export function useCreateOrdersSubscribersMeByOrderId(
  options?: CustomMutationOptions<
    unknown,
    CreateOrdersSubscribersMeByOrderIdResponse,
    CreateOrdersSubscribersMeByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateOrdersSubscribersMeByOrderIdResponse,
    CreateOrdersSubscribersMeByOrderIdParams
  >("orders", "/:orderId/subscribers/me", "POST", options);
}

export function useDeleteOrdersSubscribersMeByOrderId(
  options?: CustomMutationOptions<
    unknown,
    DeleteOrdersSubscribersMeByOrderIdResponse,
    DeleteOrdersSubscribersMeByOrderIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteOrdersSubscribersMeByOrderIdResponse,
    DeleteOrdersSubscribersMeByOrderIdParams
  >("orders", "/:orderId/subscribers/me", "DELETE", options);
}

// ============================================================================
// PayLinks Resource
// ============================================================================

export function useCreatePayLinksPreviewByToken(
  options?: CustomMutationOptions<
    CreatePayLinksPreviewByTokenBody,
    CreatePayLinksPreviewByTokenResponse,
    CreatePayLinksPreviewByTokenParams
  >,
) {
  return useResourceCustomMutation<
    CreatePayLinksPreviewByTokenBody,
    CreatePayLinksPreviewByTokenResponse,
    CreatePayLinksPreviewByTokenParams
  >("pay-links", "/:token/preview", "POST", options);
}

export function useCreatePayLinksPaymentsByToken(
  options?: CustomMutationOptions<
    CreatePayLinksPaymentsByTokenBody,
    CreatePayLinksPaymentsByTokenResponse,
    CreatePayLinksPaymentsByTokenParams
  >,
) {
  return useResourceCustomMutation<
    CreatePayLinksPaymentsByTokenBody,
    CreatePayLinksPaymentsByTokenResponse,
    CreatePayLinksPaymentsByTokenParams
  >("pay-links", "/:token/payments", "POST", options);
}

export function useCreatePayLinksPaymentsCompleteByTokenByPaymentIntentId(
  options?: CustomMutationOptions<
    unknown,
    CreatePayLinksPaymentsCompleteByTokenByPaymentIntentIdResponse,
    CreatePayLinksPaymentsCompleteByTokenByPaymentIntentIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreatePayLinksPaymentsCompleteByTokenByPaymentIntentIdResponse,
    CreatePayLinksPaymentsCompleteByTokenByPaymentIntentIdParams
  >("pay-links", "/:token/payments/:paymentIntentId/complete", "POST", options);
}

export function useGetPayLinksByToken(
  params: GetPayLinksByTokenParams,
): CustomQueryBuilder<GetPayLinksByTokenResponse, GetPayLinksByTokenParams> {
  return useResourceCustomQuery<
    GetPayLinksByTokenResponse,
    GetPayLinksByTokenParams
  >("pay-links", "/:token", params);
}

// ============================================================================
// Places Resource
// ============================================================================

export function useGetPlacesOrderPlansKeysByPlaceIdByOrderPlanKey(
  params: GetPlacesOrderPlansKeysByPlaceIdByOrderPlanKeyParams,
): CustomQueryBuilder<
  GetPlacesOrderPlansKeysByPlaceIdByOrderPlanKeyResponse,
  GetPlacesOrderPlansKeysByPlaceIdByOrderPlanKeyParams
> {
  return useResourceCustomQuery<
    GetPlacesOrderPlansKeysByPlaceIdByOrderPlanKeyResponse,
    GetPlacesOrderPlansKeysByPlaceIdByOrderPlanKeyParams
  >("places", "/:placeId/order-plans/keys/:orderPlanKey", params);
}

export function useGetPlacesCheckByPlaceId(
  params: GetPlacesCheckByPlaceIdParams,
): CustomQueryBuilder<
  GetPlacesCheckByPlaceIdResponse,
  GetPlacesCheckByPlaceIdParams
> {
  return useResourceCustomQuery<
    GetPlacesCheckByPlaceIdResponse,
    GetPlacesCheckByPlaceIdParams
  >("places", "/:placeId/check", params);
}

export function useGetPlacesList() {
  return useListQuery<
    GetPlacesListItem,
    GetPlacesListResponse,
    GetPlacesListFilters
  >("places", "/list");
}

export function useGetPlacesByPlaceId(
  params: GetPlacesByPlaceIdParams,
): CustomQueryBuilder<
  GetPlacesByPlaceIdResponse,
  GetPlacesByPlaceIdParams,
  GetPlacesByPlaceIdQuery
> {
  return useResourceCustomQuery<
    GetPlacesByPlaceIdResponse,
    GetPlacesByPlaceIdParams,
    GetPlacesByPlaceIdQuery
  >("places", "/:placeId", params);
}

export function useUpdatePlacesByPlaceId(
  options?: CustomMutationOptions<
    UpdatePlacesByPlaceIdBody,
    UpdatePlacesByPlaceIdResponse,
    UpdatePlacesByPlaceIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdatePlacesByPlaceIdBody,
    UpdatePlacesByPlaceIdResponse,
    UpdatePlacesByPlaceIdParams
  >("places", "/:placeId", "PUT", options);
}

export function useDeletePlacesByPlaceId(
  options?: CustomMutationOptions<
    unknown,
    DeletePlacesByPlaceIdResponse,
    DeletePlacesByPlaceIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeletePlacesByPlaceIdResponse,
    DeletePlacesByPlaceIdParams
  >("places", "/:placeId", "DELETE", options);
}

export function useGetPlacesNestByPlaceId(
  params: GetPlacesNestByPlaceIdParams,
): CustomQueryBuilder<
  GetPlacesNestByPlaceIdResponse,
  GetPlacesNestByPlaceIdParams
> {
  return useResourceCustomQuery<
    GetPlacesNestByPlaceIdResponse,
    GetPlacesNestByPlaceIdParams
  >("places", "/:placeId/nest", params);
}

export function useGetPlacesNestSummaryByPlaceId(
  params: GetPlacesNestSummaryByPlaceIdParams,
): CustomQueryBuilder<
  GetPlacesNestSummaryByPlaceIdResponse,
  GetPlacesNestSummaryByPlaceIdParams
> {
  return useResourceCustomQuery<
    GetPlacesNestSummaryByPlaceIdResponse,
    GetPlacesNestSummaryByPlaceIdParams
  >("places", "/:placeId/nest/summary", params);
}

export function useGetPlacesNestPartsByPlaceId(
  params: GetPlacesNestPartsByPlaceIdParams,
): CustomQueryBuilder<
  GetPlacesNestPartsByPlaceIdResponse,
  GetPlacesNestPartsByPlaceIdParams
> {
  return useResourceCustomQuery<
    GetPlacesNestPartsByPlaceIdResponse,
    GetPlacesNestPartsByPlaceIdParams
  >("places", "/:placeId/nest/parts", params);
}

export function useUpdatePlacesNestRoomsByPlaceIdByRoomKey(
  options?: CustomMutationOptions<
    UpdatePlacesNestRoomsByPlaceIdByRoomKeyBody,
    UpdatePlacesNestRoomsByPlaceIdByRoomKeyResponse,
    UpdatePlacesNestRoomsByPlaceIdByRoomKeyParams
  >,
) {
  return useResourceCustomMutation<
    UpdatePlacesNestRoomsByPlaceIdByRoomKeyBody,
    UpdatePlacesNestRoomsByPlaceIdByRoomKeyResponse,
    UpdatePlacesNestRoomsByPlaceIdByRoomKeyParams
  >("places", "/:placeId/nest/rooms/:roomKey", "PATCH", options);
}

export function useUpdatePlacesNestFactsByPlaceIdByFactKey(
  options?: CustomMutationOptions<
    UpdatePlacesNestFactsByPlaceIdByFactKeyBody,
    UpdatePlacesNestFactsByPlaceIdByFactKeyResponse,
    UpdatePlacesNestFactsByPlaceIdByFactKeyParams
  >,
) {
  return useResourceCustomMutation<
    UpdatePlacesNestFactsByPlaceIdByFactKeyBody,
    UpdatePlacesNestFactsByPlaceIdByFactKeyResponse,
    UpdatePlacesNestFactsByPlaceIdByFactKeyParams
  >("places", "/:placeId/nest/facts/:factKey", "PUT", options);
}

export function useDeletePlacesNestFactsByPlaceIdByFactKey(
  options?: CustomMutationOptions<
    unknown,
    DeletePlacesNestFactsByPlaceIdByFactKeyResponse,
    DeletePlacesNestFactsByPlaceIdByFactKeyParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeletePlacesNestFactsByPlaceIdByFactKeyResponse,
    DeletePlacesNestFactsByPlaceIdByFactKeyParams
  >("places", "/:placeId/nest/facts/:factKey", "DELETE", options);
}

export function useCreatePlacesNestEvaluationsShareByPlaceIdByEvaluationId(
  options?: CustomMutationOptions<
    CreatePlacesNestEvaluationsShareByPlaceIdByEvaluationIdBody,
    CreatePlacesNestEvaluationsShareByPlaceIdByEvaluationIdResponse,
    CreatePlacesNestEvaluationsShareByPlaceIdByEvaluationIdParams
  >,
) {
  return useResourceCustomMutation<
    CreatePlacesNestEvaluationsShareByPlaceIdByEvaluationIdBody,
    CreatePlacesNestEvaluationsShareByPlaceIdByEvaluationIdResponse,
    CreatePlacesNestEvaluationsShareByPlaceIdByEvaluationIdParams
  >(
    "places",
    "/:placeId/nest/evaluations/:evaluationId/share",
    "POST",
    options,
  );
}

export function useGetPlacesAttachmentsByPlaceId(
  params: GetPlacesAttachmentsByPlaceIdParams,
): CustomQueryBuilder<
  GetPlacesAttachmentsByPlaceIdResponse,
  GetPlacesAttachmentsByPlaceIdParams,
  GetPlacesAttachmentsByPlaceIdQuery,
  GetPlacesAttachmentsByPlaceIdExtra
> {
  return useResourceCustomQuery<
    GetPlacesAttachmentsByPlaceIdResponse,
    GetPlacesAttachmentsByPlaceIdParams,
    GetPlacesAttachmentsByPlaceIdQuery,
    GetPlacesAttachmentsByPlaceIdExtra
  >("places", "/:placeId/attachments", params);
}

export function useCreatePlacesAttachmentsByPlaceId(
  options?: CustomMutationOptions<
    CreatePlacesAttachmentsByPlaceIdBody,
    CreatePlacesAttachmentsByPlaceIdResponse,
    CreatePlacesAttachmentsByPlaceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreatePlacesAttachmentsByPlaceIdBody,
    CreatePlacesAttachmentsByPlaceIdResponse,
    CreatePlacesAttachmentsByPlaceIdParams
  >("places", "/:placeId/attachments", "POST", options);
}

export function useDeletePlacesAttachmentsByPlaceId(
  options?: CustomMutationOptions<
    DeletePlacesAttachmentsByPlaceIdBody,
    DeletePlacesAttachmentsByPlaceIdResponse,
    DeletePlacesAttachmentsByPlaceIdParams
  >,
) {
  return useResourceCustomMutation<
    DeletePlacesAttachmentsByPlaceIdBody,
    DeletePlacesAttachmentsByPlaceIdResponse,
    DeletePlacesAttachmentsByPlaceIdParams
  >("places", "/:placeId/attachments", "DELETE", options);
}

export function useDeletePlacesAttachmentsByPlaceIdByAttachmentId(
  options?: CustomMutationOptions<
    unknown,
    DeletePlacesAttachmentsByPlaceIdByAttachmentIdResponse,
    DeletePlacesAttachmentsByPlaceIdByAttachmentIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeletePlacesAttachmentsByPlaceIdByAttachmentIdResponse,
    DeletePlacesAttachmentsByPlaceIdByAttachmentIdParams
  >("places", "/:placeId/attachments/:attachmentId", "DELETE", options);
}

export function useCreatePlacesAll(
  options?: CustomMutationOptions<CreatePlacesAllBody, CreatePlacesAllResponse>,
) {
  return useResourceCustomMutation<
    CreatePlacesAllBody,
    CreatePlacesAllResponse
  >("places", "", "POST", options);
}

export function useCreatePlacesAddMyPlace(
  options?: CustomMutationOptions<
    CreatePlacesAddMyPlaceBody,
    CreatePlacesAddMyPlaceResponse
  >,
) {
  return useResourceCustomMutation<
    CreatePlacesAddMyPlaceBody,
    CreatePlacesAddMyPlaceResponse
  >("places", "/add-my-place", "POST", options);
}

export function useCreatePlacesImportEvaluations(
  options?: CustomMutationOptions<
    CreatePlacesImportEvaluationsBody,
    CreatePlacesImportEvaluationsResponse
  >,
) {
  return useResourceCustomMutation<
    CreatePlacesImportEvaluationsBody,
    CreatePlacesImportEvaluationsResponse
  >("places", "/import-evaluations", "POST", options);
}

export function useCreatePlacesValidateAddress(
  options?: CustomMutationOptions<
    CreatePlacesValidateAddressBody,
    CreatePlacesValidateAddressResponse
  >,
) {
  return useResourceCustomMutation<
    CreatePlacesValidateAddressBody,
    CreatePlacesValidateAddressResponse
  >("places", "/validate-address", "POST", options);
}

// ============================================================================
// Policy Resource
// ============================================================================

export function useGetPolicyPermissions(): CustomQueryBuilder<GetPolicyPermissionsResponse> {
  return useResourceCustomQuery<GetPolicyPermissionsResponse>(
    "policy",
    "/permissions",
  );
}

export function useGetPolicyRoles(): CustomQueryBuilder<GetPolicyRolesResponse> {
  return useResourceCustomQuery<GetPolicyRolesResponse>("policy", "/roles");
}

export function useCreatePolicyRoles(
  options?: CustomMutationOptions<
    CreatePolicyRolesBody,
    CreatePolicyRolesResponse
  >,
) {
  return useResourceCustomMutation<
    CreatePolicyRolesBody,
    CreatePolicyRolesResponse
  >("policy", "/roles", "POST", options);
}

export function useGetPolicyRolesByRoleKey(
  params: GetPolicyRolesByRoleKeyParams,
): CustomQueryBuilder<
  GetPolicyRolesByRoleKeyResponse,
  GetPolicyRolesByRoleKeyParams
> {
  return useResourceCustomQuery<
    GetPolicyRolesByRoleKeyResponse,
    GetPolicyRolesByRoleKeyParams
  >("policy", "/roles/:roleKey", params);
}

export function useUpdatePolicyRolesByRoleKey(
  options?: CustomMutationOptions<
    UpdatePolicyRolesByRoleKeyBody,
    UpdatePolicyRolesByRoleKeyResponse,
    UpdatePolicyRolesByRoleKeyParams
  >,
) {
  return useResourceCustomMutation<
    UpdatePolicyRolesByRoleKeyBody,
    UpdatePolicyRolesByRoleKeyResponse,
    UpdatePolicyRolesByRoleKeyParams
  >("policy", "/roles/:roleKey", "PUT", options);
}

export function useDeletePolicyRolesByRoleKey(
  options?: CustomMutationOptions<
    unknown,
    DeletePolicyRolesByRoleKeyResponse,
    DeletePolicyRolesByRoleKeyParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeletePolicyRolesByRoleKeyResponse,
    DeletePolicyRolesByRoleKeyParams
  >("policy", "/roles/:roleKey", "DELETE", options);
}

export function useCreatePolicyRolesPermissionsByRoleKey(
  options?: CustomMutationOptions<
    CreatePolicyRolesPermissionsByRoleKeyBody,
    CreatePolicyRolesPermissionsByRoleKeyResponse,
    CreatePolicyRolesPermissionsByRoleKeyParams
  >,
) {
  return useResourceCustomMutation<
    CreatePolicyRolesPermissionsByRoleKeyBody,
    CreatePolicyRolesPermissionsByRoleKeyResponse,
    CreatePolicyRolesPermissionsByRoleKeyParams
  >("policy", "/roles/:roleKey/permissions", "POST", options);
}

export function useUpdatePolicyRolesPermissionsByRoleKey(
  options?: CustomMutationOptions<
    UpdatePolicyRolesPermissionsByRoleKeyBody,
    UpdatePolicyRolesPermissionsByRoleKeyResponse,
    UpdatePolicyRolesPermissionsByRoleKeyParams
  >,
) {
  return useResourceCustomMutation<
    UpdatePolicyRolesPermissionsByRoleKeyBody,
    UpdatePolicyRolesPermissionsByRoleKeyResponse,
    UpdatePolicyRolesPermissionsByRoleKeyParams
  >("policy", "/roles/:roleKey/permissions", "PUT", options);
}

export function useDeletePolicyRolesPermissionsByRoleKeyByPermissionKey(
  options?: CustomMutationOptions<
    unknown,
    DeletePolicyRolesPermissionsByRoleKeyByPermissionKeyResponse,
    DeletePolicyRolesPermissionsByRoleKeyByPermissionKeyParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeletePolicyRolesPermissionsByRoleKeyByPermissionKeyResponse,
    DeletePolicyRolesPermissionsByRoleKeyByPermissionKeyParams
  >("policy", "/roles/:roleKey/permissions/:permissionKey", "DELETE", options);
}

export function useGetPolicyUsersByUserId(
  params: GetPolicyUsersByUserIdParams,
): CustomQueryBuilder<
  GetPolicyUsersByUserIdResponse,
  GetPolicyUsersByUserIdParams
> {
  return useResourceCustomQuery<
    GetPolicyUsersByUserIdResponse,
    GetPolicyUsersByUserIdParams
  >("policy", "/users/:userId", params);
}

export function useCreatePolicyUsersRolesByUserId(
  options?: CustomMutationOptions<
    CreatePolicyUsersRolesByUserIdBody,
    CreatePolicyUsersRolesByUserIdResponse,
    CreatePolicyUsersRolesByUserIdParams
  >,
) {
  return useResourceCustomMutation<
    CreatePolicyUsersRolesByUserIdBody,
    CreatePolicyUsersRolesByUserIdResponse,
    CreatePolicyUsersRolesByUserIdParams
  >("policy", "/users/:userId/roles", "POST", options);
}

export function useDeletePolicyUsersRolesByUserIdByRoleKey(
  options?: CustomMutationOptions<
    unknown,
    DeletePolicyUsersRolesByUserIdByRoleKeyResponse,
    DeletePolicyUsersRolesByUserIdByRoleKeyParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeletePolicyUsersRolesByUserIdByRoleKeyResponse,
    DeletePolicyUsersRolesByUserIdByRoleKeyParams
  >("policy", "/users/:userId/roles/:roleKey", "DELETE", options);
}

export function useCreatePolicyUsersPermissionsByUserId(
  options?: CustomMutationOptions<
    CreatePolicyUsersPermissionsByUserIdBody,
    CreatePolicyUsersPermissionsByUserIdResponse,
    CreatePolicyUsersPermissionsByUserIdParams
  >,
) {
  return useResourceCustomMutation<
    CreatePolicyUsersPermissionsByUserIdBody,
    CreatePolicyUsersPermissionsByUserIdResponse,
    CreatePolicyUsersPermissionsByUserIdParams
  >("policy", "/users/:userId/permissions", "POST", options);
}

export function useDeletePolicyUsersPermissionsByUserIdByPermissionKey(
  options?: CustomMutationOptions<
    unknown,
    DeletePolicyUsersPermissionsByUserIdByPermissionKeyResponse,
    DeletePolicyUsersPermissionsByUserIdByPermissionKeyParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeletePolicyUsersPermissionsByUserIdByPermissionKeyResponse,
    DeletePolicyUsersPermissionsByUserIdByPermissionKeyParams
  >("policy", "/users/:userId/permissions/:permissionKey", "DELETE", options);
}

// ============================================================================
// Products Resource
// ============================================================================

/** @deprecated */
export function useGetProductsAll(): CustomQueryBuilder<
  GetProductsAllResponse,
  Record<string, string>,
  GetProductsAllQuery,
  GetProductsAllExtra
> {
  return useResourceCustomQuery<
    GetProductsAllResponse,
    Record<string, string>,
    GetProductsAllQuery,
    GetProductsAllExtra
  >("products", "");
}

export function useGetProductsList() {
  return useListQuery<
    GetProductsListItem,
    GetProductsListResponse,
    GetProductsListFilters
  >("products", "/list");
}

export function useGetProductsByProductId(
  params: GetProductsByProductIdParams,
): CustomQueryBuilder<
  GetProductsByProductIdResponse,
  GetProductsByProductIdParams
> {
  return useResourceCustomQuery<
    GetProductsByProductIdResponse,
    GetProductsByProductIdParams
  >("products", "/:productId", params);
}

// ============================================================================
// PurchaseIntents Resource
// ============================================================================

export function useGetPurchaseIntentsList() {
  return useListQuery<
    GetPurchaseIntentsListItem,
    GetPurchaseIntentsListResponse,
    GetPurchaseIntentsListFilters
  >("purchase-intents", "/list");
}

export function useGetPurchaseIntentsByPurchaseIntentId(
  params: GetPurchaseIntentsByPurchaseIntentIdParams,
): CustomQueryBuilder<
  GetPurchaseIntentsByPurchaseIntentIdResponse,
  GetPurchaseIntentsByPurchaseIntentIdParams,
  GetPurchaseIntentsByPurchaseIntentIdQuery
> {
  return useResourceCustomQuery<
    GetPurchaseIntentsByPurchaseIntentIdResponse,
    GetPurchaseIntentsByPurchaseIntentIdParams,
    GetPurchaseIntentsByPurchaseIntentIdQuery
  >("purchase-intents", "/:purchaseIntentId", params);
}

export function useUpdatePurchaseIntentsByPurchaseIntentId(
  options?: CustomMutationOptions<
    UpdatePurchaseIntentsByPurchaseIntentIdBody,
    UpdatePurchaseIntentsByPurchaseIntentIdResponse,
    UpdatePurchaseIntentsByPurchaseIntentIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdatePurchaseIntentsByPurchaseIntentIdBody,
    UpdatePurchaseIntentsByPurchaseIntentIdResponse,
    UpdatePurchaseIntentsByPurchaseIntentIdParams
  >("purchase-intents", "/:purchaseIntentId", "PUT", options);
}

export function useDeletePurchaseIntentsByPurchaseIntentId(
  options?: CustomMutationOptions<
    unknown,
    unknown,
    DeletePurchaseIntentsByPurchaseIntentIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    unknown,
    DeletePurchaseIntentsByPurchaseIntentIdParams
  >("purchase-intents", "/:purchaseIntentId", "DELETE", options);
}

// ============================================================================
// Realtime Resource
// ============================================================================

export function useCreateRealtimeAuthorize(
  options?: CustomMutationOptions<
    CreateRealtimeAuthorizeBody,
    CreateRealtimeAuthorizeResponse
  >,
) {
  return useResourceCustomMutation<
    CreateRealtimeAuthorizeBody,
    CreateRealtimeAuthorizeResponse
  >("realtime", "/authorize", "POST", options);
}

// ============================================================================
// Report Resource
// ============================================================================

export function useGetReportOrderOverviewList() {
  return useListQuery<
    GetReportOrderOverviewListItem,
    GetReportOrderOverviewListResponse,
    GetReportOrderOverviewListFilters
  >("report", "/order-overview/list");
}

export function useGetReportOrderOverviewSummary(): CustomQueryBuilder<
  GetReportOrderOverviewSummaryResponse,
  Record<string, string>,
  GetReportOrderOverviewSummaryQuery
> {
  return useResourceCustomQuery<
    GetReportOrderOverviewSummaryResponse,
    Record<string, string>,
    GetReportOrderOverviewSummaryQuery
  >("report", "/order-overview/summary");
}

export function useGetReportOrderOverviewHistoryByOrderId(
  params: GetReportOrderOverviewHistoryByOrderIdParams,
): CustomQueryBuilder<
  GetReportOrderOverviewHistoryByOrderIdResponse,
  GetReportOrderOverviewHistoryByOrderIdParams
> {
  return useResourceCustomQuery<
    GetReportOrderOverviewHistoryByOrderIdResponse,
    GetReportOrderOverviewHistoryByOrderIdParams
  >("report", "/order-overview/history/:orderId", params);
}

export function useGetReportMrrMovement(): CustomQueryBuilder<
  GetReportMrrMovementResponse,
  Record<string, string>,
  GetReportMrrMovementQuery,
  GetReportMrrMovementExtra
> {
  return useResourceCustomQuery<
    GetReportMrrMovementResponse,
    Record<string, string>,
    GetReportMrrMovementQuery,
    GetReportMrrMovementExtra
  >("report", "/mrr-movement");
}

export function useGetReportMrrGrowth(): CustomQueryBuilder<
  GetReportMrrGrowthResponse,
  Record<string, string>,
  GetReportMrrGrowthQuery
> {
  return useResourceCustomQuery<
    GetReportMrrGrowthResponse,
    Record<string, string>,
    GetReportMrrGrowthQuery
  >("report", "/mrr-growth");
}

export function useGetReportMrrMovers(): CustomQueryBuilder<
  GetReportMrrMoversResponse,
  Record<string, string>,
  GetReportMrrMoversQuery
> {
  return useResourceCustomQuery<
    GetReportMrrMoversResponse,
    Record<string, string>,
    GetReportMrrMoversQuery
  >("report", "/mrr-movers");
}

export function useGetReportMrrAtRisk(): CustomQueryBuilder<
  GetReportMrrAtRiskResponse,
  Record<string, string>,
  GetReportMrrAtRiskQuery
> {
  return useResourceCustomQuery<
    GetReportMrrAtRiskResponse,
    Record<string, string>,
    GetReportMrrAtRiskQuery
  >("report", "/mrr-at-risk");
}

export function useGetReportMrrChurnReasons(): CustomQueryBuilder<
  GetReportMrrChurnReasonsResponse,
  Record<string, string>,
  GetReportMrrChurnReasonsQuery
> {
  return useResourceCustomQuery<
    GetReportMrrChurnReasonsResponse,
    Record<string, string>,
    GetReportMrrChurnReasonsQuery
  >("report", "/mrr-churn-reasons");
}

export function useGetReportMrrLedgerList() {
  return useListQuery<
    GetReportMrrLedgerListItem,
    GetReportMrrLedgerListResponse,
    GetReportMrrLedgerListFilters
  >("report", "/mrr-ledger/list");
}

export function useGetReportMrrSnapshot(): CustomQueryBuilder<
  GetReportMrrSnapshotResponse,
  Record<string, string>,
  GetReportMrrSnapshotQuery
> {
  return useResourceCustomQuery<
    GetReportMrrSnapshotResponse,
    Record<string, string>,
    GetReportMrrSnapshotQuery
  >("report", "/mrr-snapshot");
}

// ============================================================================
// RevenueMonths Resource
// ============================================================================

export function useGetRevenueMonthsReport(): CustomQueryBuilder<GetRevenueMonthsReportResponse> {
  return useResourceCustomQuery<GetRevenueMonthsReportResponse>(
    "revenue-months",
    "/report",
  );
}

export function useGetRevenueMonthsCloseChecksByMonth(
  params: GetRevenueMonthsCloseChecksByMonthParams,
): CustomQueryBuilder<
  GetRevenueMonthsCloseChecksByMonthResponse,
  GetRevenueMonthsCloseChecksByMonthParams
> {
  return useResourceCustomQuery<
    GetRevenueMonthsCloseChecksByMonthResponse,
    GetRevenueMonthsCloseChecksByMonthParams
  >("revenue-months", "/:month/close-checks", params);
}

export function useCreateRevenueMonthsCloseByMonth(
  options?: CustomMutationOptions<
    unknown,
    CreateRevenueMonthsCloseByMonthResponse,
    CreateRevenueMonthsCloseByMonthParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateRevenueMonthsCloseByMonthResponse,
    CreateRevenueMonthsCloseByMonthParams
  >("revenue-months", "/:month/close", "POST", options);
}

export function useCreateRevenueMonthsReopenByMonth(
  options?: CustomMutationOptions<
    CreateRevenueMonthsReopenByMonthBody,
    CreateRevenueMonthsReopenByMonthResponse,
    CreateRevenueMonthsReopenByMonthParams
  >,
) {
  return useResourceCustomMutation<
    CreateRevenueMonthsReopenByMonthBody,
    CreateRevenueMonthsReopenByMonthResponse,
    CreateRevenueMonthsReopenByMonthParams
  >("revenue-months", "/:month/reopen", "POST", options);
}

export function useGetRevenueMonthsPackageByMonth(
  params: GetRevenueMonthsPackageByMonthParams,
): CustomQueryBuilder<
  GetRevenueMonthsPackageByMonthResponse,
  GetRevenueMonthsPackageByMonthParams
> {
  return useResourceCustomQuery<
    GetRevenueMonthsPackageByMonthResponse,
    GetRevenueMonthsPackageByMonthParams
  >("revenue-months", "/:month/package", params);
}

// ============================================================================
// Revenues Resource
// ============================================================================

export function useCreateRevenuesAll(
  options?: CustomMutationOptions<
    CreateRevenuesAllBody,
    CreateRevenuesAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateRevenuesAllBody,
    CreateRevenuesAllResponse
  >("revenues", "", "POST", options);
}

export function useUpdateRevenuesByRevenueId(
  options?: CustomMutationOptions<
    UpdateRevenuesByRevenueIdBody,
    UpdateRevenuesByRevenueIdResponse,
    UpdateRevenuesByRevenueIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateRevenuesByRevenueIdBody,
    UpdateRevenuesByRevenueIdResponse,
    UpdateRevenuesByRevenueIdParams
  >("revenues", "/:revenueId", "PATCH", options);
}

export function useDeleteRevenuesByRevenueId(
  options?: CustomMutationOptions<
    unknown,
    DeleteRevenuesByRevenueIdResponse,
    DeleteRevenuesByRevenueIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteRevenuesByRevenueIdResponse,
    DeleteRevenuesByRevenueIdParams
  >("revenues", "/:revenueId", "DELETE", options);
}

// ============================================================================
// Schedules Resource
// ============================================================================

export function useGetSchedulesList(): CustomQueryBuilder<
  GetSchedulesListResponse,
  Record<string, string>,
  GetSchedulesListQuery
> {
  return useResourceCustomQuery<
    GetSchedulesListResponse,
    Record<string, string>,
    GetSchedulesListQuery
  >("schedules", "/list");
}

export function useGetScheduleEventDetail(
  params: GetScheduleEventDetailParams,
): CustomQueryBuilder<
  GetScheduleEventDetailResponse,
  GetScheduleEventDetailParams
> {
  return useResourceCustomQuery<
    GetScheduleEventDetailResponse,
    GetScheduleEventDetailParams
  >("schedules", "/events/:scheduleEventId", params);
}

export function useUpdateScheduleEvent(
  options?: CustomMutationOptions<
    UpdateScheduleEventBody,
    UpdateScheduleEventResponse,
    UpdateScheduleEventParams
  >,
) {
  return useResourceCustomMutation<
    UpdateScheduleEventBody,
    UpdateScheduleEventResponse,
    UpdateScheduleEventParams
  >("schedules", "/events/:scheduleEventId", "PATCH", options);
}

export function useDeleteScheduleEvent(
  options?: CustomMutationOptions<
    unknown,
    DeleteScheduleEventResponse,
    DeleteScheduleEventParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteScheduleEventResponse,
    DeleteScheduleEventParams
  >("schedules", "/events/:scheduleEventId", "DELETE", options);
}

export function useGetScheduleGoogleEventDetail(
  params: GetScheduleGoogleEventDetailParams,
): CustomQueryBuilder<
  GetScheduleGoogleEventDetailResponse,
  GetScheduleGoogleEventDetailParams
> {
  return useResourceCustomQuery<
    GetScheduleGoogleEventDetailResponse,
    GetScheduleGoogleEventDetailParams
  >("schedules", "/google-events/:googleCalendarEventId", params);
}

export function useCreateScheduleEvent(
  options?: CustomMutationOptions<
    CreateScheduleEventBody,
    CreateScheduleEventResponse
  >,
) {
  return useResourceCustomMutation<
    CreateScheduleEventBody,
    CreateScheduleEventResponse
  >("schedules", "/events", "POST", options);
}

// ============================================================================
// Scopes Resource
// ============================================================================

export function useUpdateScopesAll(
  options?: CustomMutationOptions<UpdateScopesAllBody, unknown>,
) {
  return useResourceCustomMutation<UpdateScopesAllBody, unknown>(
    "scopes",
    "",
    "PUT",
    options,
  );
}

export function useGetScopesByOrderScopeId(
  params: GetScopesByOrderScopeIdParams,
): CustomQueryBuilder<
  GetScopesByOrderScopeIdResponse,
  GetScopesByOrderScopeIdParams
> {
  return useResourceCustomQuery<
    GetScopesByOrderScopeIdResponse,
    GetScopesByOrderScopeIdParams
  >("scopes", "/:orderScopeId", params);
}

// ============================================================================
// Search Resource
// ============================================================================

export function useGetSearchGlobal(): CustomQueryBuilder<
  GetSearchGlobalResponse,
  Record<string, string>,
  GetSearchGlobalQuery
> {
  return useResourceCustomQuery<
    GetSearchGlobalResponse,
    Record<string, string>,
    GetSearchGlobalQuery
  >("search", "/global");
}

// ============================================================================
// SmartActions Resource
// ============================================================================

export function useGetSmartActionsList() {
  return useListQuery<
    GetSmartActionsListItem,
    GetSmartActionsListResponse,
    GetSmartActionsListFilters
  >("smart-actions", "/list");
}

export function useGetSmartActionsSummary(): CustomQueryBuilder<
  GetSmartActionsSummaryResponse,
  Record<string, string>,
  GetSmartActionsSummaryQuery
> {
  return useResourceCustomQuery<
    GetSmartActionsSummaryResponse,
    Record<string, string>,
    GetSmartActionsSummaryQuery
  >("smart-actions", "/summary");
}

export function useGetSmartActionsForecast(): CustomQueryBuilder<
  GetSmartActionsForecastResponse,
  Record<string, string>,
  GetSmartActionsForecastQuery
> {
  return useResourceCustomQuery<
    GetSmartActionsForecastResponse,
    Record<string, string>,
    GetSmartActionsForecastQuery
  >("smart-actions", "/forecast");
}

export function useGetSmartActionsAccuracy(): CustomQueryBuilder<
  GetSmartActionsAccuracyResponse,
  Record<string, string>,
  GetSmartActionsAccuracyQuery
> {
  return useResourceCustomQuery<
    GetSmartActionsAccuracyResponse,
    Record<string, string>,
    GetSmartActionsAccuracyQuery
  >("smart-actions", "/accuracy");
}

export function useGetSmartActionsLostCosts(): CustomQueryBuilder<
  GetSmartActionsLostCostsResponse,
  Record<string, string>,
  GetSmartActionsLostCostsQuery
> {
  return useResourceCustomQuery<
    GetSmartActionsLostCostsResponse,
    Record<string, string>,
    GetSmartActionsLostCostsQuery
  >("smart-actions", "/lost-costs");
}

export function useGetSmartActionsOrderReviewByOrderId(
  params: GetSmartActionsOrderReviewByOrderIdParams,
): CustomQueryBuilder<
  GetSmartActionsOrderReviewByOrderIdResponse,
  GetSmartActionsOrderReviewByOrderIdParams
> {
  return useResourceCustomQuery<
    GetSmartActionsOrderReviewByOrderIdResponse,
    GetSmartActionsOrderReviewByOrderIdParams
  >("smart-actions", "/order-review/:orderId", params);
}

export function useCreateSmartActionsAnalyze(
  options?: CustomMutationOptions<
    CreateSmartActionsAnalyzeBody,
    CreateSmartActionsAnalyzeResponse
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsAnalyzeBody,
    CreateSmartActionsAnalyzeResponse
  >("smart-actions", "/analyze", "POST", options);
}

export function useCreateSmartActionsRefresh(
  options?: CustomMutationOptions<
    CreateSmartActionsRefreshBody,
    CreateSmartActionsRefreshResponse
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsRefreshBody,
    CreateSmartActionsRefreshResponse
  >("smart-actions", "/refresh", "POST", options);
}

export function useCreateSmartActionsRun(
  options?: CustomMutationOptions<
    CreateSmartActionsRunBody,
    CreateSmartActionsRunResponse
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsRunBody,
    CreateSmartActionsRunResponse
  >("smart-actions", "/run", "POST", options);
}

export function useGetSmartActionsBySmartActionId(
  params: GetSmartActionsBySmartActionIdParams,
): CustomQueryBuilder<
  GetSmartActionsBySmartActionIdResponse,
  GetSmartActionsBySmartActionIdParams
> {
  return useResourceCustomQuery<
    GetSmartActionsBySmartActionIdResponse,
    GetSmartActionsBySmartActionIdParams
  >("smart-actions", "/:smartActionId", params);
}

export function useUpdateSmartActionsBySmartActionId(
  options?: CustomMutationOptions<
    UpdateSmartActionsBySmartActionIdBody,
    UpdateSmartActionsBySmartActionIdResponse,
    UpdateSmartActionsBySmartActionIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateSmartActionsBySmartActionIdBody,
    UpdateSmartActionsBySmartActionIdResponse,
    UpdateSmartActionsBySmartActionIdParams
  >("smart-actions", "/:smartActionId", "PATCH", options);
}

export function useDeleteSmartActionsBySmartActionId(
  options?: CustomMutationOptions<
    unknown,
    DeleteSmartActionsBySmartActionIdResponse,
    DeleteSmartActionsBySmartActionIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteSmartActionsBySmartActionIdResponse,
    DeleteSmartActionsBySmartActionIdParams
  >("smart-actions", "/:smartActionId", "DELETE", options);
}

export function useCreateSmartActionsAll(
  options?: CustomMutationOptions<
    CreateSmartActionsAllBody,
    CreateSmartActionsAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsAllBody,
    CreateSmartActionsAllResponse
  >("smart-actions", "", "POST", options);
}

export function useCreateSmartActionsContactBySmartActionId(
  options?: CustomMutationOptions<
    CreateSmartActionsContactBySmartActionIdBody,
    CreateSmartActionsContactBySmartActionIdResponse,
    CreateSmartActionsContactBySmartActionIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsContactBySmartActionIdBody,
    CreateSmartActionsContactBySmartActionIdResponse,
    CreateSmartActionsContactBySmartActionIdParams
  >("smart-actions", "/:smartActionId/contact", "POST", options);
}

export function useCreateSmartActionsReplanBySmartActionId(
  options?: CustomMutationOptions<
    CreateSmartActionsReplanBySmartActionIdBody,
    CreateSmartActionsReplanBySmartActionIdResponse,
    CreateSmartActionsReplanBySmartActionIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsReplanBySmartActionIdBody,
    CreateSmartActionsReplanBySmartActionIdResponse,
    CreateSmartActionsReplanBySmartActionIdParams
  >("smart-actions", "/:smartActionId/replan", "POST", options);
}

export function useCreateSmartActionsAiFeedbackBySmartActionId(
  options?: CustomMutationOptions<
    CreateSmartActionsAiFeedbackBySmartActionIdBody,
    CreateSmartActionsAiFeedbackBySmartActionIdResponse,
    CreateSmartActionsAiFeedbackBySmartActionIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsAiFeedbackBySmartActionIdBody,
    CreateSmartActionsAiFeedbackBySmartActionIdResponse,
    CreateSmartActionsAiFeedbackBySmartActionIdParams
  >("smart-actions", "/:smartActionId/ai-feedback", "POST", options);
}

export function useCreateSmartActionsSnoozeBySmartActionId(
  options?: CustomMutationOptions<
    CreateSmartActionsSnoozeBySmartActionIdBody,
    CreateSmartActionsSnoozeBySmartActionIdResponse,
    CreateSmartActionsSnoozeBySmartActionIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsSnoozeBySmartActionIdBody,
    CreateSmartActionsSnoozeBySmartActionIdResponse,
    CreateSmartActionsSnoozeBySmartActionIdParams
  >("smart-actions", "/:smartActionId/snooze", "POST", options);
}

export function useCreateSmartActionsResolveBySmartActionId(
  options?: CustomMutationOptions<
    CreateSmartActionsResolveBySmartActionIdBody,
    CreateSmartActionsResolveBySmartActionIdResponse,
    CreateSmartActionsResolveBySmartActionIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsResolveBySmartActionIdBody,
    CreateSmartActionsResolveBySmartActionIdResponse,
    CreateSmartActionsResolveBySmartActionIdParams
  >("smart-actions", "/:smartActionId/resolve", "POST", options);
}

export function useCreateSmartActionsDismissBySmartActionId(
  options?: CustomMutationOptions<
    CreateSmartActionsDismissBySmartActionIdBody,
    CreateSmartActionsDismissBySmartActionIdResponse,
    CreateSmartActionsDismissBySmartActionIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsDismissBySmartActionIdBody,
    CreateSmartActionsDismissBySmartActionIdResponse,
    CreateSmartActionsDismissBySmartActionIdParams
  >("smart-actions", "/:smartActionId/dismiss", "POST", options);
}

export function useCreateSmartActionsReopenBySmartActionId(
  options?: CustomMutationOptions<
    CreateSmartActionsReopenBySmartActionIdBody,
    CreateSmartActionsReopenBySmartActionIdResponse,
    CreateSmartActionsReopenBySmartActionIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsReopenBySmartActionIdBody,
    CreateSmartActionsReopenBySmartActionIdResponse,
    CreateSmartActionsReopenBySmartActionIdParams
  >("smart-actions", "/:smartActionId/reopen", "POST", options);
}

export function useUpdateSmartActionsStepsBySmartActionIdByStepId(
  options?: CustomMutationOptions<
    UpdateSmartActionsStepsBySmartActionIdByStepIdBody,
    UpdateSmartActionsStepsBySmartActionIdByStepIdResponse,
    UpdateSmartActionsStepsBySmartActionIdByStepIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateSmartActionsStepsBySmartActionIdByStepIdBody,
    UpdateSmartActionsStepsBySmartActionIdByStepIdResponse,
    UpdateSmartActionsStepsBySmartActionIdByStepIdParams
  >("smart-actions", "/:smartActionId/steps/:stepId", "PATCH", options);
}

export function useCreateSmartActionsStepsTaskBySmartActionIdByStepId(
  options?: CustomMutationOptions<
    CreateSmartActionsStepsTaskBySmartActionIdByStepIdBody,
    CreateSmartActionsStepsTaskBySmartActionIdByStepIdResponse,
    CreateSmartActionsStepsTaskBySmartActionIdByStepIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsStepsTaskBySmartActionIdByStepIdBody,
    CreateSmartActionsStepsTaskBySmartActionIdByStepIdResponse,
    CreateSmartActionsStepsTaskBySmartActionIdByStepIdParams
  >("smart-actions", "/:smartActionId/steps/:stepId/task", "POST", options);
}

export function useCreateSmartActionsEventsBySmartActionId(
  options?: CustomMutationOptions<
    CreateSmartActionsEventsBySmartActionIdBody,
    CreateSmartActionsEventsBySmartActionIdResponse,
    CreateSmartActionsEventsBySmartActionIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateSmartActionsEventsBySmartActionIdBody,
    CreateSmartActionsEventsBySmartActionIdResponse,
    CreateSmartActionsEventsBySmartActionIdParams
  >("smart-actions", "/:smartActionId/events", "POST", options);
}

// ============================================================================
// Spaces Resource
// ============================================================================

export function useCreateSpacesCreate(
  options?: CustomMutationOptions<
    CreateSpacesCreateBody,
    CreateSpacesCreateResponse
  >,
) {
  return useResourceCustomMutation<
    CreateSpacesCreateBody,
    CreateSpacesCreateResponse
  >("spaces", "/create", "POST", options);
}

export function useGetSpacesBySpaceId(
  params: GetSpacesBySpaceIdParams,
): CustomQueryBuilder<GetSpacesBySpaceIdResponse, GetSpacesBySpaceIdParams> {
  return useResourceCustomQuery<
    GetSpacesBySpaceIdResponse,
    GetSpacesBySpaceIdParams
  >("spaces", "/:spaceId", params);
}

export function useUpdateSpacesBySpaceId(
  options?: CustomMutationOptions<
    UpdateSpacesBySpaceIdBody,
    UpdateSpacesBySpaceIdResponse,
    UpdateSpacesBySpaceIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateSpacesBySpaceIdBody,
    UpdateSpacesBySpaceIdResponse,
    UpdateSpacesBySpaceIdParams
  >("spaces", "/:spaceId", "PUT", options);
}

export function useDeleteSpacesBySpaceId(
  options?: CustomMutationOptions<
    unknown,
    DeleteSpacesBySpaceIdResponse,
    DeleteSpacesBySpaceIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteSpacesBySpaceIdResponse,
    DeleteSpacesBySpaceIdParams
  >("spaces", "/:spaceId", "DELETE", options);
}

// ============================================================================
// Status Resource
// ============================================================================

export function useGetStatusAll(): CustomQueryBuilder<GetStatusAllResponse> {
  return useResourceCustomQuery<GetStatusAllResponse>("status", "");
}

// ============================================================================
// Subscriptions Resource
// ============================================================================

export function useGetSubscriptionsPlans(): CustomQueryBuilder<
  GetSubscriptionsPlansResponse,
  Record<string, string>,
  GetSubscriptionsPlansQuery
> {
  return useResourceCustomQuery<
    GetSubscriptionsPlansResponse,
    Record<string, string>,
    GetSubscriptionsPlansQuery
  >("subscriptions", "/plans");
}

export function useGetSubscriptionsPlansByPlanId(
  params: GetSubscriptionsPlansByPlanIdParams,
): CustomQueryBuilder<
  GetSubscriptionsPlansByPlanIdResponse,
  GetSubscriptionsPlansByPlanIdParams,
  GetSubscriptionsPlansByPlanIdQuery
> {
  return useResourceCustomQuery<
    GetSubscriptionsPlansByPlanIdResponse,
    GetSubscriptionsPlansByPlanIdParams,
    GetSubscriptionsPlansByPlanIdQuery
  >("subscriptions", "/plans/:planId", params);
}

export function useGetSubscriptionsStatuses(): CustomQueryBuilder<GetSubscriptionsStatusesResponse> {
  return useResourceCustomQuery<GetSubscriptionsStatusesResponse>(
    "subscriptions",
    "/statuses",
  );
}

export function useGetSubscriptionsProducts(): CustomQueryBuilder<GetSubscriptionsProductsResponse> {
  return useResourceCustomQuery<GetSubscriptionsProductsResponse>(
    "subscriptions",
    "/products",
  );
}

export function useGetSubscriptionsList() {
  return useListQuery<
    GetSubscriptionsListItem,
    GetSubscriptionsListResponse,
    GetSubscriptionsListFilters
  >("subscriptions", "/list");
}

export function useGetSubscriptionsMyBySubscriptionId(
  params: GetSubscriptionsMyBySubscriptionIdParams,
): CustomQueryBuilder<
  GetSubscriptionsMyBySubscriptionIdResponse,
  GetSubscriptionsMyBySubscriptionIdParams
> {
  return useResourceCustomQuery<
    GetSubscriptionsMyBySubscriptionIdResponse,
    GetSubscriptionsMyBySubscriptionIdParams
  >("subscriptions", "/my/:subscriptionId", params);
}

export function useGetSubscriptionsTimelineBySubscriptionId(
  params: GetSubscriptionsTimelineBySubscriptionIdParams,
): CustomQueryBuilder<
  GetSubscriptionsTimelineBySubscriptionIdResponse,
  GetSubscriptionsTimelineBySubscriptionIdParams,
  GetSubscriptionsTimelineBySubscriptionIdQuery,
  GetSubscriptionsTimelineBySubscriptionIdExtra
> {
  return useResourceCustomQuery<
    GetSubscriptionsTimelineBySubscriptionIdResponse,
    GetSubscriptionsTimelineBySubscriptionIdParams,
    GetSubscriptionsTimelineBySubscriptionIdQuery,
    GetSubscriptionsTimelineBySubscriptionIdExtra
  >("subscriptions", "/:subscriptionId/timeline", params);
}

export function useGetSubscriptionsItemsHistoryBySubscriptionId(
  params: GetSubscriptionsItemsHistoryBySubscriptionIdParams,
): CustomQueryBuilder<
  GetSubscriptionsItemsHistoryBySubscriptionIdResponse,
  GetSubscriptionsItemsHistoryBySubscriptionIdParams,
  GetSubscriptionsItemsHistoryBySubscriptionIdQuery,
  GetSubscriptionsItemsHistoryBySubscriptionIdExtra
> {
  return useResourceCustomQuery<
    GetSubscriptionsItemsHistoryBySubscriptionIdResponse,
    GetSubscriptionsItemsHistoryBySubscriptionIdParams,
    GetSubscriptionsItemsHistoryBySubscriptionIdQuery,
    GetSubscriptionsItemsHistoryBySubscriptionIdExtra
  >("subscriptions", "/:subscriptionId/items/history", params);
}

export function useGetSubscriptionsBySubscriptionId(
  params: GetSubscriptionsBySubscriptionIdParams,
): CustomQueryBuilder<
  GetSubscriptionsBySubscriptionIdResponse,
  GetSubscriptionsBySubscriptionIdParams
> {
  return useResourceCustomQuery<
    GetSubscriptionsBySubscriptionIdResponse,
    GetSubscriptionsBySubscriptionIdParams
  >("subscriptions", "/:subscriptionId", params);
}

export function useUpdateSubscriptionsBySubscriptionId(
  options?: CustomMutationOptions<
    UpdateSubscriptionsBySubscriptionIdBody,
    UpdateSubscriptionsBySubscriptionIdResponse,
    UpdateSubscriptionsBySubscriptionIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateSubscriptionsBySubscriptionIdBody,
    UpdateSubscriptionsBySubscriptionIdResponse,
    UpdateSubscriptionsBySubscriptionIdParams
  >("subscriptions", "/:subscriptionId", "PUT", options);
}

export function useCreateSubscriptionsCreatePurchaseIntent(
  options?: CustomMutationOptions<
    CreateSubscriptionsCreatePurchaseIntentBody,
    CreateSubscriptionsCreatePurchaseIntentResponse
  >,
) {
  return useResourceCustomMutation<
    CreateSubscriptionsCreatePurchaseIntentBody,
    CreateSubscriptionsCreatePurchaseIntentResponse
  >("subscriptions", "/create-purchase-intent", "POST", options);
}

export function useCreateSubscriptionsCreate(
  options?: CustomMutationOptions<
    CreateSubscriptionsCreateBody,
    CreateSubscriptionsCreateResponse
  >,
) {
  return useResourceCustomMutation<
    CreateSubscriptionsCreateBody,
    CreateSubscriptionsCreateResponse
  >("subscriptions", "/create", "POST", options);
}

// ============================================================================
// Tags Resource
// ============================================================================

export function useGetTagsList() {
  return useListQuery<GetTagsListItem, GetTagsListResponse, GetTagsListFilters>(
    "tags",
    "/list",
  );
}

export function useCreateTagsAll(
  options?: CustomMutationOptions<CreateTagsAllBody, CreateTagsAllResponse>,
) {
  return useResourceCustomMutation<CreateTagsAllBody, CreateTagsAllResponse>(
    "tags",
    "",
    "POST",
    options,
  );
}

export function useUpdateTagsByTagId(
  options?: CustomMutationOptions<
    UpdateTagsByTagIdBody,
    UpdateTagsByTagIdResponse,
    UpdateTagsByTagIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateTagsByTagIdBody,
    UpdateTagsByTagIdResponse,
    UpdateTagsByTagIdParams
  >("tags", "/:tagId", "PUT", options);
}

export function useDeleteTagsByTagId(
  options?: CustomMutationOptions<
    unknown,
    DeleteTagsByTagIdResponse,
    DeleteTagsByTagIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteTagsByTagIdResponse,
    DeleteTagsByTagIdParams
  >("tags", "/:tagId", "DELETE", options);
}

// ============================================================================
// Tasks Resource
// ============================================================================

export function useGetTasksList() {
  return useListQuery<
    GetTasksListItem,
    GetTasksListResponse,
    GetTasksListFilters
  >("tasks", "/list");
}

export function useGetTasksGroups(): CustomQueryBuilder<
  GetTasksGroupsResponse,
  Record<string, string>,
  GetTasksGroupsQuery
> {
  return useResourceCustomQuery<
    GetTasksGroupsResponse,
    Record<string, string>,
    GetTasksGroupsQuery
  >("tasks", "/groups");
}

export function useGetTasksByTaskId(
  params: GetTasksByTaskIdParams,
): CustomQueryBuilder<GetTasksByTaskIdResponse, GetTasksByTaskIdParams> {
  return useResourceCustomQuery<
    GetTasksByTaskIdResponse,
    GetTasksByTaskIdParams
  >("tasks", "/:taskId", params);
}

export function useUpdateTasksByTaskId(
  options?: CustomMutationOptions<
    UpdateTasksByTaskIdBody,
    UpdateTasksByTaskIdResponse,
    UpdateTasksByTaskIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateTasksByTaskIdBody,
    UpdateTasksByTaskIdResponse,
    UpdateTasksByTaskIdParams
  >("tasks", "/:taskId", "PATCH", options);
}

export function useDeleteTasksByTaskId(
  options?: CustomMutationOptions<
    unknown,
    DeleteTasksByTaskIdResponse,
    DeleteTasksByTaskIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteTasksByTaskIdResponse,
    DeleteTasksByTaskIdParams
  >("tasks", "/:taskId", "DELETE", options);
}

export function useCreateTasksAll(
  options?: CustomMutationOptions<CreateTasksAllBody, CreateTasksAllResponse>,
) {
  return useResourceCustomMutation<CreateTasksAllBody, CreateTasksAllResponse>(
    "tasks",
    "",
    "POST",
    options,
  );
}

export function useCreateTasksCompleteByTaskId(
  options?: CustomMutationOptions<
    unknown,
    CreateTasksCompleteByTaskIdResponse,
    CreateTasksCompleteByTaskIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateTasksCompleteByTaskIdResponse,
    CreateTasksCompleteByTaskIdParams
  >("tasks", "/:taskId/complete", "POST", options);
}

// ============================================================================
// TimeEntries Resource
// ============================================================================

export function useGetTimeEntriesList() {
  return useListQuery<
    GetTimeEntriesListItem,
    GetTimeEntriesListResponse,
    GetTimeEntriesListFilters
  >("time-entries", "/list");
}

export function useCreateTimeEntriesAll(
  options?: CustomMutationOptions<
    CreateTimeEntriesAllBody,
    CreateTimeEntriesAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateTimeEntriesAllBody,
    CreateTimeEntriesAllResponse
  >("time-entries", "", "POST", options);
}

export function useUpdateTimeEntriesByTimeEntryId(
  options?: CustomMutationOptions<
    UpdateTimeEntriesByTimeEntryIdBody,
    UpdateTimeEntriesByTimeEntryIdResponse,
    UpdateTimeEntriesByTimeEntryIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateTimeEntriesByTimeEntryIdBody,
    UpdateTimeEntriesByTimeEntryIdResponse,
    UpdateTimeEntriesByTimeEntryIdParams
  >("time-entries", "/:timeEntryId", "PATCH", options);
}

export function useDeleteTimeEntriesByTimeEntryId(
  options?: CustomMutationOptions<
    unknown,
    DeleteTimeEntriesByTimeEntryIdResponse,
    DeleteTimeEntriesByTimeEntryIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteTimeEntriesByTimeEntryIdResponse,
    DeleteTimeEntriesByTimeEntryIdParams
  >("time-entries", "/:timeEntryId", "DELETE", options);
}

// ============================================================================
// TimePreferences Resource
// ============================================================================

export function useGetTimePreferencesByTimePreferenceId(
  params: GetTimePreferencesByTimePreferenceIdParams,
): CustomQueryBuilder<
  GetTimePreferencesByTimePreferenceIdResponse,
  GetTimePreferencesByTimePreferenceIdParams
> {
  return useResourceCustomQuery<
    GetTimePreferencesByTimePreferenceIdResponse,
    GetTimePreferencesByTimePreferenceIdParams
  >("time-preferences", "/:timePreferenceId", params);
}

// ============================================================================
// TimeProposals Resource
// ============================================================================

export function useGetTimeProposalsByTimeProposalId(
  params: GetTimeProposalsByTimeProposalIdParams,
): CustomQueryBuilder<
  GetTimeProposalsByTimeProposalIdResponse,
  GetTimeProposalsByTimeProposalIdParams
> {
  return useResourceCustomQuery<
    GetTimeProposalsByTimeProposalIdResponse,
    GetTimeProposalsByTimeProposalIdParams
  >("time-proposals", "/:timeProposalId", params);
}

// ============================================================================
// Uploads Resource
// ============================================================================

export function useCreateUploadsInitPublic(
  options?: CustomMutationOptions<
    CreateUploadsInitPublicBody,
    CreateUploadsInitPublicResponse
  >,
) {
  return useResourceCustomMutation<
    CreateUploadsInitPublicBody,
    CreateUploadsInitPublicResponse
  >("uploads", "/init-public", "POST", options);
}

export function useCreateUploadsFinalPublic(
  options?: CustomMutationOptions<
    CreateUploadsFinalPublicBody,
    CreateUploadsFinalPublicResponse
  >,
) {
  return useResourceCustomMutation<
    CreateUploadsFinalPublicBody,
    CreateUploadsFinalPublicResponse
  >("uploads", "/final-public", "POST", options);
}

// ============================================================================
// Users Resource
// ============================================================================

export function useGetUsersInvitesPlacesByPlaceId(
  params: GetUsersInvitesPlacesByPlaceIdParams,
): CustomQueryBuilder<
  GetUsersInvitesPlacesByPlaceIdResponse,
  GetUsersInvitesPlacesByPlaceIdParams
> {
  return useResourceCustomQuery<
    GetUsersInvitesPlacesByPlaceIdResponse,
    GetUsersInvitesPlacesByPlaceIdParams
  >("users", "/invites/places/:placeId", params);
}

export function useCreateUsersInvitesPlacesByPlaceId(
  options?: CustomMutationOptions<
    CreateUsersInvitesPlacesByPlaceIdBody,
    CreateUsersInvitesPlacesByPlaceIdResponse,
    CreateUsersInvitesPlacesByPlaceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateUsersInvitesPlacesByPlaceIdBody,
    CreateUsersInvitesPlacesByPlaceIdResponse,
    CreateUsersInvitesPlacesByPlaceIdParams
  >("users", "/invites/places/:placeId", "POST", options);
}

export function useGetUsersInvitesPlacesMembersByPlaceId(
  params: GetUsersInvitesPlacesMembersByPlaceIdParams,
): CustomQueryBuilder<
  GetUsersInvitesPlacesMembersByPlaceIdResponse,
  GetUsersInvitesPlacesMembersByPlaceIdParams
> {
  return useResourceCustomQuery<
    GetUsersInvitesPlacesMembersByPlaceIdResponse,
    GetUsersInvitesPlacesMembersByPlaceIdParams
  >("users", "/invites/places/:placeId/members", params);
}

export function useGetUsersInvitesByToken(
  params: GetUsersInvitesByTokenParams,
): CustomQueryBuilder<
  GetUsersInvitesByTokenResponse,
  GetUsersInvitesByTokenParams
> {
  return useResourceCustomQuery<
    GetUsersInvitesByTokenResponse,
    GetUsersInvitesByTokenParams
  >("users", "/invites/:token", params);
}

export function useCreateUsersInvitesPlacesJoinByPlaceId(
  options?: CustomMutationOptions<
    CreateUsersInvitesPlacesJoinByPlaceIdBody,
    CreateUsersInvitesPlacesJoinByPlaceIdResponse,
    CreateUsersInvitesPlacesJoinByPlaceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateUsersInvitesPlacesJoinByPlaceIdBody,
    CreateUsersInvitesPlacesJoinByPlaceIdResponse,
    CreateUsersInvitesPlacesJoinByPlaceIdParams
  >("users", "/invites/places/:placeId/join", "POST", options);
}

export function useCreateUsersInvitesResendByInviteId(
  options?: CustomMutationOptions<
    unknown,
    CreateUsersInvitesResendByInviteIdResponse,
    CreateUsersInvitesResendByInviteIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateUsersInvitesResendByInviteIdResponse,
    CreateUsersInvitesResendByInviteIdParams
  >("users", "/invites/:inviteId/resend", "POST", options);
}

export function useCreateUsersInvitesCancelByInviteId(
  options?: CustomMutationOptions<
    unknown,
    CreateUsersInvitesCancelByInviteIdResponse,
    CreateUsersInvitesCancelByInviteIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateUsersInvitesCancelByInviteIdResponse,
    CreateUsersInvitesCancelByInviteIdParams
  >("users", "/invites/:inviteId/cancel", "POST", options);
}

export function useCreateUsersInvitesPlacesGrantBillingByPlaceId(
  options?: CustomMutationOptions<
    CreateUsersInvitesPlacesGrantBillingByPlaceIdBody,
    CreateUsersInvitesPlacesGrantBillingByPlaceIdResponse,
    CreateUsersInvitesPlacesGrantBillingByPlaceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateUsersInvitesPlacesGrantBillingByPlaceIdBody,
    CreateUsersInvitesPlacesGrantBillingByPlaceIdResponse,
    CreateUsersInvitesPlacesGrantBillingByPlaceIdParams
  >("users", "/invites/places/:placeId/grant-billing", "POST", options);
}

export function useCreateUsersInvitesPlacesRevokeBillingByPlaceId(
  options?: CustomMutationOptions<
    CreateUsersInvitesPlacesRevokeBillingByPlaceIdBody,
    CreateUsersInvitesPlacesRevokeBillingByPlaceIdResponse,
    CreateUsersInvitesPlacesRevokeBillingByPlaceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateUsersInvitesPlacesRevokeBillingByPlaceIdBody,
    CreateUsersInvitesPlacesRevokeBillingByPlaceIdResponse,
    CreateUsersInvitesPlacesRevokeBillingByPlaceIdParams
  >("users", "/invites/places/:placeId/revoke-billing", "POST", options);
}

export function useCreateUsersInvitesPlacesRemoveByPlaceId(
  options?: CustomMutationOptions<
    CreateUsersInvitesPlacesRemoveByPlaceIdBody,
    CreateUsersInvitesPlacesRemoveByPlaceIdResponse,
    CreateUsersInvitesPlacesRemoveByPlaceIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateUsersInvitesPlacesRemoveByPlaceIdBody,
    CreateUsersInvitesPlacesRemoveByPlaceIdResponse,
    CreateUsersInvitesPlacesRemoveByPlaceIdParams
  >("users", "/invites/places/:placeId/remove", "POST", options);
}

export function useGetUsersMeNotificationPreferences(): CustomQueryBuilder<GetUsersMeNotificationPreferencesResponse> {
  return useResourceCustomQuery<GetUsersMeNotificationPreferencesResponse>(
    "users",
    "/me/notification-preferences",
  );
}

export function useUpdateUsersMeNotificationPreferences(
  options?: CustomMutationOptions<
    UpdateUsersMeNotificationPreferencesBody,
    UpdateUsersMeNotificationPreferencesResponse
  >,
) {
  return useResourceCustomMutation<
    UpdateUsersMeNotificationPreferencesBody,
    UpdateUsersMeNotificationPreferencesResponse
  >("users", "/me/notification-preferences", "PUT", options);
}

export function useCreateUsersCreateUser(
  options?: CustomMutationOptions<
    CreateUsersCreateUserBody,
    CreateUsersCreateUserResponse
  >,
) {
  return useResourceCustomMutation<
    CreateUsersCreateUserBody,
    CreateUsersCreateUserResponse
  >("users", "/create-user", "POST", options);
}

export function useCreateUsersTechnicianSignUp(
  options?: CustomMutationOptions<
    CreateUsersTechnicianSignUpBody,
    CreateUsersTechnicianSignUpResponse
  >,
) {
  return useResourceCustomMutation<
    CreateUsersTechnicianSignUpBody,
    CreateUsersTechnicianSignUpResponse
  >("users", "/technician-sign-up", "POST", options);
}

export function useCreateUsersVerifyPhoneNumber(
  options?: CustomMutationOptions<
    CreateUsersVerifyPhoneNumberBody,
    CreateUsersVerifyPhoneNumberResponse
  >,
) {
  return useResourceCustomMutation<
    CreateUsersVerifyPhoneNumberBody,
    CreateUsersVerifyPhoneNumberResponse
  >("users", "/verify-phone-number", "POST", options);
}

export function useCreateUsersVerifyOtp(
  options?: CustomMutationOptions<
    CreateUsersVerifyOtpBody,
    CreateUsersVerifyOtpResponse
  >,
) {
  return useResourceCustomMutation<
    CreateUsersVerifyOtpBody,
    CreateUsersVerifyOtpResponse
  >("users", "/verify-otp", "POST", options);
}

export function useCreateUsersResendOtp(
  options?: CustomMutationOptions<
    CreateUsersResendOtpBody,
    CreateUsersResendOtpResponse
  >,
) {
  return useResourceCustomMutation<
    CreateUsersResendOtpBody,
    CreateUsersResendOtpResponse
  >("users", "/resend-otp", "POST", options);
}

export function useGetUsersList() {
  return useListQuery<
    GetUsersListItem,
    GetUsersListResponse,
    GetUsersListFilters
  >("users", "/list");
}

export function useCreateUsersDeviceTokens(
  options?: CustomMutationOptions<
    CreateUsersDeviceTokensBody,
    CreateUsersDeviceTokensResponse
  >,
) {
  return useResourceCustomMutation<
    CreateUsersDeviceTokensBody,
    CreateUsersDeviceTokensResponse
  >("users", "/device-tokens", "POST", options);
}

export function useDeleteUsersDeviceTokensByDeviceToken(
  options?: CustomMutationOptions<
    unknown,
    DeleteUsersDeviceTokensByDeviceTokenResponse,
    DeleteUsersDeviceTokensByDeviceTokenParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteUsersDeviceTokensByDeviceTokenResponse,
    DeleteUsersDeviceTokensByDeviceTokenParams
  >("users", "/device-tokens/:deviceToken", "DELETE", options);
}

export function useGetUsersAccountsByUserId(
  params: GetUsersAccountsByUserIdParams,
): CustomQueryBuilder<
  GetUsersAccountsByUserIdResponse,
  GetUsersAccountsByUserIdParams
> {
  return useResourceCustomQuery<
    GetUsersAccountsByUserIdResponse,
    GetUsersAccountsByUserIdParams
  >("users", "/:userId/accounts", params);
}

export function useDeleteUsersAccountsByUserId(
  options?: CustomMutationOptions<
    DeleteUsersAccountsByUserIdBody,
    DeleteUsersAccountsByUserIdResponse,
    DeleteUsersAccountsByUserIdParams
  >,
) {
  return useResourceCustomMutation<
    DeleteUsersAccountsByUserIdBody,
    DeleteUsersAccountsByUserIdResponse,
    DeleteUsersAccountsByUserIdParams
  >("users", "/:userId/accounts", "DELETE", options);
}

export function useGetUsersProfilesByUserId(
  params: GetUsersProfilesByUserIdParams,
): CustomQueryBuilder<
  GetUsersProfilesByUserIdResponse,
  GetUsersProfilesByUserIdParams
> {
  return useResourceCustomQuery<
    GetUsersProfilesByUserIdResponse,
    GetUsersProfilesByUserIdParams
  >("users", "/:userId/profiles", params);
}

export function useUpdateUsersProfilesByUserIdByKey(
  options?: CustomMutationOptions<
    UpdateUsersProfilesByUserIdByKeyBody,
    UpdateUsersProfilesByUserIdByKeyResponse,
    UpdateUsersProfilesByUserIdByKeyParams
  >,
) {
  return useResourceCustomMutation<
    UpdateUsersProfilesByUserIdByKeyBody,
    UpdateUsersProfilesByUserIdByKeyResponse,
    UpdateUsersProfilesByUserIdByKeyParams
  >("users", "/:userId/profiles/:key", "PUT", options);
}

export function useGetUsersPlacesByUserId(
  params: GetUsersPlacesByUserIdParams,
): CustomQueryBuilder<
  GetUsersPlacesByUserIdResponse,
  GetUsersPlacesByUserIdParams
> {
  return useResourceCustomQuery<
    GetUsersPlacesByUserIdResponse,
    GetUsersPlacesByUserIdParams
  >("users", "/:userId/places", params);
}

export function useCreateUsersPlacesByUserId(
  options?: CustomMutationOptions<
    CreateUsersPlacesByUserIdBody,
    CreateUsersPlacesByUserIdResponse,
    CreateUsersPlacesByUserIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateUsersPlacesByUserIdBody,
    CreateUsersPlacesByUserIdResponse,
    CreateUsersPlacesByUserIdParams
  >("users", "/:userId/places", "POST", options);
}

export function useDeleteUsersPlacesByUserId(
  options?: CustomMutationOptions<
    DeleteUsersPlacesByUserIdBody,
    DeleteUsersPlacesByUserIdResponse,
    DeleteUsersPlacesByUserIdParams
  >,
) {
  return useResourceCustomMutation<
    DeleteUsersPlacesByUserIdBody,
    DeleteUsersPlacesByUserIdResponse,
    DeleteUsersPlacesByUserIdParams
  >("users", "/:userId/places", "DELETE", options);
}

export function useGetUsersOnlineByUserId(
  params: GetUsersOnlineByUserIdParams,
): CustomQueryBuilder<
  GetUsersOnlineByUserIdResponse,
  GetUsersOnlineByUserIdParams
> {
  return useResourceCustomQuery<
    GetUsersOnlineByUserIdResponse,
    GetUsersOnlineByUserIdParams
  >("users", "/:userId/online", params);
}

export function useUpdateUsersPlaceByUserIdByPlaceId(
  options?: CustomMutationOptions<
    UpdateUsersPlaceByUserIdByPlaceIdBody,
    UpdateUsersPlaceByUserIdByPlaceIdResponse,
    UpdateUsersPlaceByUserIdByPlaceIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateUsersPlaceByUserIdByPlaceIdBody,
    UpdateUsersPlaceByUserIdByPlaceIdResponse,
    UpdateUsersPlaceByUserIdByPlaceIdParams
  >("users", "/:userId/place/:placeId", "PUT", options);
}

export function useCreateUsersAccountByUserIdByAccountId(
  options?: CustomMutationOptions<
    CreateUsersAccountByUserIdByAccountIdBody,
    CreateUsersAccountByUserIdByAccountIdResponse,
    CreateUsersAccountByUserIdByAccountIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateUsersAccountByUserIdByAccountIdBody,
    CreateUsersAccountByUserIdByAccountIdResponse,
    CreateUsersAccountByUserIdByAccountIdParams
  >("users", "/:userId/account/:accountId", "POST", options);
}

export function useUpdateUsersAccountByUserIdByAccountId(
  options?: CustomMutationOptions<
    UpdateUsersAccountByUserIdByAccountIdBody,
    UpdateUsersAccountByUserIdByAccountIdResponse,
    UpdateUsersAccountByUserIdByAccountIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateUsersAccountByUserIdByAccountIdBody,
    UpdateUsersAccountByUserIdByAccountIdResponse,
    UpdateUsersAccountByUserIdByAccountIdParams
  >("users", "/:userId/account/:accountId", "PUT", options);
}

export function useGetUsersByUserId(
  params: GetUsersByUserIdParams,
): CustomQueryBuilder<
  GetUsersByUserIdResponse,
  GetUsersByUserIdParams,
  GetUsersByUserIdQuery
> {
  return useResourceCustomQuery<
    GetUsersByUserIdResponse,
    GetUsersByUserIdParams,
    GetUsersByUserIdQuery
  >("users", "/:userId", params);
}

export function useUpdateUsersByUserId(
  options?: CustomMutationOptions<
    UpdateUsersByUserIdBody,
    UpdateUsersByUserIdResponse,
    UpdateUsersByUserIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateUsersByUserIdBody,
    UpdateUsersByUserIdResponse,
    UpdateUsersByUserIdParams
  >("users", "/:userId", "PUT", options);
}

export function useDeleteUsersByUserId(
  options?: CustomMutationOptions<
    unknown,
    DeleteUsersByUserIdResponse,
    DeleteUsersByUserIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteUsersByUserIdResponse,
    DeleteUsersByUserIdParams
  >("users", "/:userId", "DELETE", options);
}

// ============================================================================
// VendorOnboardings Resource
// ============================================================================

export function useCreateVendorOnboardingsSubmit(
  options?: CustomMutationOptions<
    CreateVendorOnboardingsSubmitBody,
    CreateVendorOnboardingsSubmitResponse
  >,
) {
  return useResourceCustomMutation<
    CreateVendorOnboardingsSubmitBody,
    CreateVendorOnboardingsSubmitResponse
  >("vendor-onboardings", "/submit", "POST", options);
}

export function useCreateVendorOnboardingsAll(
  options?: CustomMutationOptions<
    CreateVendorOnboardingsAllBody,
    CreateVendorOnboardingsAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateVendorOnboardingsAllBody,
    CreateVendorOnboardingsAllResponse
  >("vendor-onboardings", "", "POST", options);
}

export function useUpdateVendorOnboardingsByVendorOnboardingId(
  options?: CustomMutationOptions<
    UpdateVendorOnboardingsByVendorOnboardingIdBody,
    UpdateVendorOnboardingsByVendorOnboardingIdResponse,
    UpdateVendorOnboardingsByVendorOnboardingIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateVendorOnboardingsByVendorOnboardingIdBody,
    UpdateVendorOnboardingsByVendorOnboardingIdResponse,
    UpdateVendorOnboardingsByVendorOnboardingIdParams
  >("vendor-onboardings", "/:vendorOnboardingId", "PUT", options);
}

// ============================================================================
// Vendors Resource
// ============================================================================

export function useGetVendorsList() {
  return useListQuery<
    GetVendorsListItem,
    GetVendorsListResponse,
    GetVendorsListFilters
  >("vendors", "/list");
}

export function useCreateVendorsAll(
  options?: CustomMutationOptions<
    CreateVendorsAllBody,
    CreateVendorsAllResponse
  >,
) {
  return useResourceCustomMutation<
    CreateVendorsAllBody,
    CreateVendorsAllResponse
  >("vendors", "", "POST", options);
}

export function useGetVendorsByVendorId(
  params: GetVendorsByVendorIdParams,
): CustomQueryBuilder<
  GetVendorsByVendorIdResponse,
  GetVendorsByVendorIdParams,
  GetVendorsByVendorIdQuery
> {
  return useResourceCustomQuery<
    GetVendorsByVendorIdResponse,
    GetVendorsByVendorIdParams,
    GetVendorsByVendorIdQuery
  >("vendors", "/:vendorId", params);
}

export function useUpdateVendorsByVendorId(
  options?: CustomMutationOptions<
    UpdateVendorsByVendorIdBody,
    UpdateVendorsByVendorIdResponse,
    UpdateVendorsByVendorIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateVendorsByVendorIdBody,
    UpdateVendorsByVendorIdResponse,
    UpdateVendorsByVendorIdParams
  >("vendors", "/:vendorId", "PATCH", options);
}

export function useDeleteVendorsByVendorId(
  options?: CustomMutationOptions<
    unknown,
    DeleteVendorsByVendorIdResponse,
    DeleteVendorsByVendorIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteVendorsByVendorIdResponse,
    DeleteVendorsByVendorIdParams
  >("vendors", "/:vendorId", "DELETE", options);
}

export function useCreateVendorsDocumentVerificationsByVendorIdByDocument(
  options?: CustomMutationOptions<
    CreateVendorsDocumentVerificationsByVendorIdByDocumentBody,
    CreateVendorsDocumentVerificationsByVendorIdByDocumentResponse,
    CreateVendorsDocumentVerificationsByVendorIdByDocumentParams
  >,
) {
  return useResourceCustomMutation<
    CreateVendorsDocumentVerificationsByVendorIdByDocumentBody,
    CreateVendorsDocumentVerificationsByVendorIdByDocumentResponse,
    CreateVendorsDocumentVerificationsByVendorIdByDocumentParams
  >("vendors", "/:vendorId/document-verifications/:document", "POST", options);
}

export function useDeleteVendorsDocumentVerificationsByVendorIdByDocument(
  options?: CustomMutationOptions<
    unknown,
    DeleteVendorsDocumentVerificationsByVendorIdByDocumentResponse,
    DeleteVendorsDocumentVerificationsByVendorIdByDocumentParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteVendorsDocumentVerificationsByVendorIdByDocumentResponse,
    DeleteVendorsDocumentVerificationsByVendorIdByDocumentParams
  >(
    "vendors",
    "/:vendorId/document-verifications/:document",
    "DELETE",
    options,
  );
}

export function useUpdateVendorsDocumentExtractionsByVendorIdByAttachmentId(
  options?: CustomMutationOptions<
    UpdateVendorsDocumentExtractionsByVendorIdByAttachmentIdBody,
    UpdateVendorsDocumentExtractionsByVendorIdByAttachmentIdResponse,
    UpdateVendorsDocumentExtractionsByVendorIdByAttachmentIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateVendorsDocumentExtractionsByVendorIdByAttachmentIdBody,
    UpdateVendorsDocumentExtractionsByVendorIdByAttachmentIdResponse,
    UpdateVendorsDocumentExtractionsByVendorIdByAttachmentIdParams
  >("vendors", "/:vendorId/document-extractions/:attachmentId", "PUT", options);
}

// ============================================================================
// Views Resource
// ============================================================================

export function useGetViewsList() {
  return useListQuery<
    GetViewsListItem,
    GetViewsListResponse,
    GetViewsListFilters
  >("views", "/list");
}

export function useGetViewsDefaults(): CustomQueryBuilder<
  GetViewsDefaultsResponse,
  Record<string, string>,
  Record<string, unknown>,
  GetViewsDefaultsExtra
> {
  return useResourceCustomQuery<
    GetViewsDefaultsResponse,
    Record<string, string>,
    Record<string, unknown>,
    GetViewsDefaultsExtra
  >("views", "/defaults");
}

export function useCreateViewsSetDefault(
  options?: CustomMutationOptions<
    CreateViewsSetDefaultBody,
    CreateViewsSetDefaultResponse
  >,
) {
  return useResourceCustomMutation<
    CreateViewsSetDefaultBody,
    CreateViewsSetDefaultResponse
  >("views", "/set-default", "POST", options);
}

// ============================================================================
// VisitLinks Resource
// ============================================================================

export function useGetVisitLinksByLinkCode(
  params: GetVisitLinksByLinkCodeParams,
): CustomQueryBuilder<
  GetVisitLinksByLinkCodeResponse,
  GetVisitLinksByLinkCodeParams
> {
  return useResourceCustomQuery<
    GetVisitLinksByLinkCodeResponse,
    GetVisitLinksByLinkCodeParams
  >("visit-links", "/:linkCode", params);
}

export function useCreateVisitLinksOpenByLinkCode(
  options?: CustomMutationOptions<
    unknown,
    CreateVisitLinksOpenByLinkCodeResponse,
    CreateVisitLinksOpenByLinkCodeParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateVisitLinksOpenByLinkCodeResponse,
    CreateVisitLinksOpenByLinkCodeParams
  >("visit-links", "/:linkCode/open", "POST", options);
}

export function useCreateVisitLinksConfirmByLinkCode(
  options?: CustomMutationOptions<
    CreateVisitLinksConfirmByLinkCodeBody,
    CreateVisitLinksConfirmByLinkCodeResponse,
    CreateVisitLinksConfirmByLinkCodeParams
  >,
) {
  return useResourceCustomMutation<
    CreateVisitLinksConfirmByLinkCodeBody,
    CreateVisitLinksConfirmByLinkCodeResponse,
    CreateVisitLinksConfirmByLinkCodeParams
  >("visit-links", "/:linkCode/confirm", "POST", options);
}

// ============================================================================
// VisitMonitor Resource
// ============================================================================

export function useGetVisitMonitorList() {
  return useListQuery<
    GetVisitMonitorListItem,
    GetVisitMonitorListResponse,
    GetVisitMonitorListFilters
  >("visit-monitor", "/list");
}

export function useUpdateVisitMonitorLinkByVisitId(
  options?: CustomMutationOptions<
    unknown,
    UpdateVisitMonitorLinkByVisitIdResponse,
    UpdateVisitMonitorLinkByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    UpdateVisitMonitorLinkByVisitIdResponse,
    UpdateVisitMonitorLinkByVisitIdParams
  >("visit-monitor", "/:visitId/link", "PUT", options);
}

export function useDeleteVisitMonitorLinkByVisitId(
  options?: CustomMutationOptions<
    unknown,
    DeleteVisitMonitorLinkByVisitIdResponse,
    DeleteVisitMonitorLinkByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteVisitMonitorLinkByVisitIdResponse,
    DeleteVisitMonitorLinkByVisitIdParams
  >("visit-monitor", "/:visitId/link", "DELETE", options);
}

export function useGetVisitMonitorSmsDraftByVisitId(
  params: GetVisitMonitorSmsDraftByVisitIdParams,
): CustomQueryBuilder<
  GetVisitMonitorSmsDraftByVisitIdResponse,
  GetVisitMonitorSmsDraftByVisitIdParams
> {
  return useResourceCustomQuery<
    GetVisitMonitorSmsDraftByVisitIdResponse,
    GetVisitMonitorSmsDraftByVisitIdParams
  >("visit-monitor", "/:visitId/sms-draft", params);
}

export function useGetVisitMonitorLinkPreviewByVisitId(
  params: GetVisitMonitorLinkPreviewByVisitIdParams,
): CustomQueryBuilder<
  GetVisitMonitorLinkPreviewByVisitIdResponse,
  GetVisitMonitorLinkPreviewByVisitIdParams
> {
  return useResourceCustomQuery<
    GetVisitMonitorLinkPreviewByVisitIdResponse,
    GetVisitMonitorLinkPreviewByVisitIdParams
  >("visit-monitor", "/:visitId/link-preview", params);
}

export function useCreateVisitMonitorSmsMessagesByVisitId(
  options?: CustomMutationOptions<
    CreateVisitMonitorSmsMessagesByVisitIdBody,
    CreateVisitMonitorSmsMessagesByVisitIdResponse,
    CreateVisitMonitorSmsMessagesByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateVisitMonitorSmsMessagesByVisitIdBody,
    CreateVisitMonitorSmsMessagesByVisitIdResponse,
    CreateVisitMonitorSmsMessagesByVisitIdParams
  >("visit-monitor", "/:visitId/sms-messages", "POST", options);
}

export function useCreateVisitMonitorConfirmationByVisitId(
  options?: CustomMutationOptions<
    unknown,
    CreateVisitMonitorConfirmationByVisitIdResponse,
    CreateVisitMonitorConfirmationByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateVisitMonitorConfirmationByVisitIdResponse,
    CreateVisitMonitorConfirmationByVisitIdParams
  >("visit-monitor", "/:visitId/confirmation", "POST", options);
}

export function useDeleteVisitMonitorConfirmationByVisitId(
  options?: CustomMutationOptions<
    unknown,
    DeleteVisitMonitorConfirmationByVisitIdResponse,
    DeleteVisitMonitorConfirmationByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteVisitMonitorConfirmationByVisitIdResponse,
    DeleteVisitMonitorConfirmationByVisitIdParams
  >("visit-monitor", "/:visitId/confirmation", "DELETE", options);
}

// ============================================================================
// Visits Resource
// ============================================================================

export function useGetVisitsAll(): CustomQueryBuilder<
  GetVisitsAllResponse,
  Record<string, string>,
  GetVisitsAllQuery,
  GetVisitsAllExtra
> {
  return useResourceCustomQuery<
    GetVisitsAllResponse,
    Record<string, string>,
    GetVisitsAllQuery,
    GetVisitsAllExtra
  >("visits", "");
}

export function useCreateVisitsAll(
  options?: CustomMutationOptions<CreateVisitsAllBody, CreateVisitsAllResponse>,
) {
  return useResourceCustomMutation<
    CreateVisitsAllBody,
    CreateVisitsAllResponse
  >("visits", "", "POST", options);
}

export function useCreateVisitsBook(
  options?: CustomMutationOptions<
    CreateVisitsBookBody,
    CreateVisitsBookResponse
  >,
) {
  return useResourceCustomMutation<
    CreateVisitsBookBody,
    CreateVisitsBookResponse
  >("visits", "/book", "POST", options);
}

export function useCreateVisitsCancelByVisitId(
  options?: CustomMutationOptions<
    unknown,
    CreateVisitsCancelByVisitIdResponse,
    CreateVisitsCancelByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateVisitsCancelByVisitIdResponse,
    CreateVisitsCancelByVisitIdParams
  >("visits", "/:visitId/cancel", "POST", options);
}

export function useCreateVisitsResetByVisitId(
  options?: CustomMutationOptions<
    unknown,
    CreateVisitsResetByVisitIdResponse,
    CreateVisitsResetByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateVisitsResetByVisitIdResponse,
    CreateVisitsResetByVisitIdParams
  >("visits", "/:visitId/reset", "POST", options);
}

export function useCreateVisitsStartOnBehalfByVisitId(
  options?: CustomMutationOptions<
    unknown,
    CreateVisitsStartOnBehalfByVisitIdResponse,
    CreateVisitsStartOnBehalfByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateVisitsStartOnBehalfByVisitIdResponse,
    CreateVisitsStartOnBehalfByVisitIdParams
  >("visits", "/:visitId/start-on-behalf", "POST", options);
}

export function useCreateVisitsCompleteOnBehalfByVisitId(
  options?: CustomMutationOptions<
    unknown,
    CreateVisitsCompleteOnBehalfByVisitIdResponse,
    CreateVisitsCompleteOnBehalfByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateVisitsCompleteOnBehalfByVisitIdResponse,
    CreateVisitsCompleteOnBehalfByVisitIdParams
  >("visits", "/:visitId/complete-on-behalf", "POST", options);
}

export function useGetVisitsTechniciansByVisitId(
  params: GetVisitsTechniciansByVisitIdParams,
): CustomQueryBuilder<
  GetVisitsTechniciansByVisitIdResponse,
  GetVisitsTechniciansByVisitIdParams
> {
  return useResourceCustomQuery<
    GetVisitsTechniciansByVisitIdResponse,
    GetVisitsTechniciansByVisitIdParams
  >("visits", "/:visitId/technicians", params);
}

export function useUpdateVisitsTechniciansByVisitId(
  options?: CustomMutationOptions<
    UpdateVisitsTechniciansByVisitIdBody,
    UpdateVisitsTechniciansByVisitIdResponse,
    UpdateVisitsTechniciansByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateVisitsTechniciansByVisitIdBody,
    UpdateVisitsTechniciansByVisitIdResponse,
    UpdateVisitsTechniciansByVisitIdParams
  >("visits", "/:visitId/technicians", "PATCH", options);
}

export function useCreateVisitsInstructionRefreshByVisitId(
  options?: CustomMutationOptions<
    CreateVisitsInstructionRefreshByVisitIdBody,
    CreateVisitsInstructionRefreshByVisitIdResponse,
    CreateVisitsInstructionRefreshByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateVisitsInstructionRefreshByVisitIdBody,
    CreateVisitsInstructionRefreshByVisitIdResponse,
    CreateVisitsInstructionRefreshByVisitIdParams
  >("visits", "/:visitId/instruction-refresh", "POST", options);
}

export function useGetVisitsByVisitId(
  params: GetVisitsByVisitIdParams,
): CustomQueryBuilder<GetVisitsByVisitIdResponse, GetVisitsByVisitIdParams> {
  return useResourceCustomQuery<
    GetVisitsByVisitIdResponse,
    GetVisitsByVisitIdParams
  >("visits", "/:visitId", params);
}

export function useUpdateVisitsByVisitId(
  options?: CustomMutationOptions<
    UpdateVisitsByVisitIdBody,
    UpdateVisitsByVisitIdResponse,
    UpdateVisitsByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    UpdateVisitsByVisitIdBody,
    UpdateVisitsByVisitIdResponse,
    UpdateVisitsByVisitIdParams
  >("visits", "/:visitId", "PATCH", options);
}

export function useDeleteVisitsByVisitId(
  options?: CustomMutationOptions<
    unknown,
    DeleteVisitsByVisitIdResponse,
    DeleteVisitsByVisitIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    DeleteVisitsByVisitIdResponse,
    DeleteVisitsByVisitIdParams
  >("visits", "/:visitId", "DELETE", options);
}

export function useGetVisitsCount(): CustomQueryBuilder<
  GetVisitsCountResponse,
  Record<string, string>,
  GetVisitsCountQuery
> {
  return useResourceCustomQuery<
    GetVisitsCountResponse,
    Record<string, string>,
    GetVisitsCountQuery
  >("visits", "/count");
}

export function useGetVisitsAvailableTimes(): CustomQueryBuilder<
  GetVisitsAvailableTimesResponse,
  Record<string, string>,
  GetVisitsAvailableTimesQuery,
  GetVisitsAvailableTimesExtra
> {
  return useResourceCustomQuery<
    GetVisitsAvailableTimesResponse,
    Record<string, string>,
    GetVisitsAvailableTimesQuery,
    GetVisitsAvailableTimesExtra
  >("visits", "/available-times");
}

export function useGetVisitsOfficeReportByVisitId(
  params: GetVisitsOfficeReportByVisitIdParams,
): CustomQueryBuilder<
  GetVisitsOfficeReportByVisitIdResponse,
  GetVisitsOfficeReportByVisitIdParams
> {
  return useResourceCustomQuery<
    GetVisitsOfficeReportByVisitIdResponse,
    GetVisitsOfficeReportByVisitIdParams
  >("visits", "/office/:visitId/report", params);
}

export function useGetVisitsFieldReportByVisitId(
  params: GetVisitsFieldReportByVisitIdParams,
): CustomQueryBuilder<
  GetVisitsFieldReportByVisitIdResponse,
  GetVisitsFieldReportByVisitIdParams
> {
  return useResourceCustomQuery<
    GetVisitsFieldReportByVisitIdResponse,
    GetVisitsFieldReportByVisitIdParams
  >("visits", "/field/:visitId/report", params);
}

export function useGetVisitsOfficeExpenseByVisitId(
  params: GetVisitsOfficeExpenseByVisitIdParams,
): CustomQueryBuilder<
  GetVisitsOfficeExpenseByVisitIdResponse,
  GetVisitsOfficeExpenseByVisitIdParams
> {
  return useResourceCustomQuery<
    GetVisitsOfficeExpenseByVisitIdResponse,
    GetVisitsOfficeExpenseByVisitIdParams
  >("visits", "/office/:visitId/expense", params);
}

export function useGetVisitsInstructionOriginByVisitId(
  params: GetVisitsInstructionOriginByVisitIdParams,
): CustomQueryBuilder<
  GetVisitsInstructionOriginByVisitIdResponse,
  GetVisitsInstructionOriginByVisitIdParams
> {
  return useResourceCustomQuery<
    GetVisitsInstructionOriginByVisitIdResponse,
    GetVisitsInstructionOriginByVisitIdParams
  >("visits", "/:visitId/instruction-origin", params);
}

export function useGetVisitsServiceTeamByVisitId(
  params: GetVisitsServiceTeamByVisitIdParams,
): CustomQueryBuilder<
  GetVisitsServiceTeamByVisitIdResponse,
  GetVisitsServiceTeamByVisitIdParams
> {
  return useResourceCustomQuery<
    GetVisitsServiceTeamByVisitIdResponse,
    GetVisitsServiceTeamByVisitIdParams
  >("visits", "/:visitId/service-team", params);
}

export function useGetVisitsAttachmentsByVisitId(
  params: GetVisitsAttachmentsByVisitIdParams,
): CustomQueryBuilder<
  GetVisitsAttachmentsByVisitIdResponse,
  GetVisitsAttachmentsByVisitIdParams
> {
  return useResourceCustomQuery<
    GetVisitsAttachmentsByVisitIdResponse,
    GetVisitsAttachmentsByVisitIdParams
  >("visits", "/:visitId/attachments", params);
}

// ============================================================================
// Wallets Resource
// ============================================================================

export function useGetWalletsTransactionHistoriesByLedgerId(
  params: GetWalletsTransactionHistoriesByLedgerIdParams,
): CustomQueryBuilder<
  GetWalletsTransactionHistoriesByLedgerIdResponse,
  GetWalletsTransactionHistoriesByLedgerIdParams
> {
  return useResourceCustomQuery<
    GetWalletsTransactionHistoriesByLedgerIdResponse,
    GetWalletsTransactionHistoriesByLedgerIdParams
  >("wallets", "/transaction-histories/:ledgerId", params);
}

export function useGetWalletsAccountCreditByAccountId(
  params: GetWalletsAccountCreditByAccountIdParams,
): CustomQueryBuilder<
  GetWalletsAccountCreditByAccountIdResponse,
  GetWalletsAccountCreditByAccountIdParams
> {
  return useResourceCustomQuery<
    GetWalletsAccountCreditByAccountIdResponse,
    GetWalletsAccountCreditByAccountIdParams
  >("wallets", "/:accountId/account-credit", params);
}

export function useCreateWalletsCreditGrantsByAccountId(
  options?: CustomMutationOptions<
    CreateWalletsCreditGrantsByAccountIdBody,
    CreateWalletsCreditGrantsByAccountIdResponse,
    CreateWalletsCreditGrantsByAccountIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateWalletsCreditGrantsByAccountIdBody,
    CreateWalletsCreditGrantsByAccountIdResponse,
    CreateWalletsCreditGrantsByAccountIdParams
  >("wallets", "/:accountId/credit-grants", "POST", options);
}

export function useCreateWalletsCreditGrantsApproveByAccountIdByGrantId(
  options?: CustomMutationOptions<
    unknown,
    CreateWalletsCreditGrantsApproveByAccountIdByGrantIdResponse,
    CreateWalletsCreditGrantsApproveByAccountIdByGrantIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateWalletsCreditGrantsApproveByAccountIdByGrantIdResponse,
    CreateWalletsCreditGrantsApproveByAccountIdByGrantIdParams
  >("wallets", "/:accountId/credit-grants/:grantId/approve", "POST", options);
}

export function useCreateWalletsCreditGrantsRejectByAccountIdByGrantId(
  options?: CustomMutationOptions<
    CreateWalletsCreditGrantsRejectByAccountIdByGrantIdBody,
    CreateWalletsCreditGrantsRejectByAccountIdByGrantIdResponse,
    CreateWalletsCreditGrantsRejectByAccountIdByGrantIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateWalletsCreditGrantsRejectByAccountIdByGrantIdBody,
    CreateWalletsCreditGrantsRejectByAccountIdByGrantIdResponse,
    CreateWalletsCreditGrantsRejectByAccountIdByGrantIdParams
  >("wallets", "/:accountId/credit-grants/:grantId/reject", "POST", options);
}

export function useCreateWalletsCreditRefundsByAccountId(
  options?: CustomMutationOptions<
    CreateWalletsCreditRefundsByAccountIdBody,
    CreateWalletsCreditRefundsByAccountIdResponse,
    CreateWalletsCreditRefundsByAccountIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateWalletsCreditRefundsByAccountIdBody,
    CreateWalletsCreditRefundsByAccountIdResponse,
    CreateWalletsCreditRefundsByAccountIdParams
  >("wallets", "/:accountId/credit-refunds", "POST", options);
}

export function useCreateWalletsCreditRefundsApproveByAccountIdByRefundId(
  options?: CustomMutationOptions<
    unknown,
    CreateWalletsCreditRefundsApproveByAccountIdByRefundIdResponse,
    CreateWalletsCreditRefundsApproveByAccountIdByRefundIdParams
  >,
) {
  return useResourceCustomMutation<
    unknown,
    CreateWalletsCreditRefundsApproveByAccountIdByRefundIdResponse,
    CreateWalletsCreditRefundsApproveByAccountIdByRefundIdParams
  >("wallets", "/:accountId/credit-refunds/:refundId/approve", "POST", options);
}

export function useCreateWalletsCreditRefundsRejectByAccountIdByRefundId(
  options?: CustomMutationOptions<
    CreateWalletsCreditRefundsRejectByAccountIdByRefundIdBody,
    CreateWalletsCreditRefundsRejectByAccountIdByRefundIdResponse,
    CreateWalletsCreditRefundsRejectByAccountIdByRefundIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateWalletsCreditRefundsRejectByAccountIdByRefundIdBody,
    CreateWalletsCreditRefundsRejectByAccountIdByRefundIdResponse,
    CreateWalletsCreditRefundsRejectByAccountIdByRefundIdParams
  >("wallets", "/:accountId/credit-refunds/:refundId/reject", "POST", options);
}

export function useCreateWalletsCreditRefundsPaidOutByAccountIdByRefundId(
  options?: CustomMutationOptions<
    CreateWalletsCreditRefundsPaidOutByAccountIdByRefundIdBody,
    CreateWalletsCreditRefundsPaidOutByAccountIdByRefundIdResponse,
    CreateWalletsCreditRefundsPaidOutByAccountIdByRefundIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateWalletsCreditRefundsPaidOutByAccountIdByRefundIdBody,
    CreateWalletsCreditRefundsPaidOutByAccountIdByRefundIdResponse,
    CreateWalletsCreditRefundsPaidOutByAccountIdByRefundIdParams
  >(
    "wallets",
    "/:accountId/credit-refunds/:refundId/paid-out",
    "POST",
    options,
  );
}

export function useGetWalletsByAccountId(
  params: GetWalletsByAccountIdParams,
): CustomQueryBuilder<
  GetWalletsByAccountIdResponse,
  GetWalletsByAccountIdParams
> {
  return useResourceCustomQuery<
    GetWalletsByAccountIdResponse,
    GetWalletsByAccountIdParams
  >("wallets", "/:accountId", params);
}

export function useGetWalletsTransactionHistoriesByAccountId(
  params: GetWalletsTransactionHistoriesByAccountIdParams,
): CustomQueryBuilder<
  GetWalletsTransactionHistoriesByAccountIdResponse,
  GetWalletsTransactionHistoriesByAccountIdParams,
  GetWalletsTransactionHistoriesByAccountIdQuery,
  GetWalletsTransactionHistoriesByAccountIdExtra
> {
  return useResourceCustomQuery<
    GetWalletsTransactionHistoriesByAccountIdResponse,
    GetWalletsTransactionHistoriesByAccountIdParams,
    GetWalletsTransactionHistoriesByAccountIdQuery,
    GetWalletsTransactionHistoriesByAccountIdExtra
  >("wallets", "/:accountId/transaction-histories", params);
}

export function useCreateWalletsAdjustByAccountId(
  options?: CustomMutationOptions<
    CreateWalletsAdjustByAccountIdBody,
    CreateWalletsAdjustByAccountIdResponse,
    CreateWalletsAdjustByAccountIdParams
  >,
) {
  return useResourceCustomMutation<
    CreateWalletsAdjustByAccountIdBody,
    CreateWalletsAdjustByAccountIdResponse,
    CreateWalletsAdjustByAccountIdParams
  >("wallets", "/:accountId/adjust", "POST", options);
}

// ============================================================================
// Zipcodes Resource
// ============================================================================

export function useGetZipcodesList() {
  return useListQuery<
    GetZipcodesListItem,
    GetZipcodesListResponse,
    GetZipcodesListFilters
  >("zipcodes", "/list");
}

export function useGetZipcodesCities(): CustomQueryBuilder<
  GetZipcodesCitiesResponse,
  Record<string, string>,
  GetZipcodesCitiesQuery,
  GetZipcodesCitiesExtra
> {
  return useResourceCustomQuery<
    GetZipcodesCitiesResponse,
    Record<string, string>,
    GetZipcodesCitiesQuery,
    GetZipcodesCitiesExtra
  >("zipcodes", "/cities");
}

export function useGetZipcodesByZipcode(
  params: GetZipcodesByZipcodeParams,
): CustomQueryBuilder<
  GetZipcodesByZipcodeResponse,
  GetZipcodesByZipcodeParams
> {
  return useResourceCustomQuery<
    GetZipcodesByZipcodeResponse,
    GetZipcodesByZipcodeParams
  >("zipcodes", "/:zipcode", params);
}

export function useUpdateZipcodesByZipcode(
  options?: CustomMutationOptions<
    UpdateZipcodesByZipcodeBody,
    UpdateZipcodesByZipcodeResponse,
    UpdateZipcodesByZipcodeParams
  >,
) {
  return useResourceCustomMutation<
    UpdateZipcodesByZipcodeBody,
    UpdateZipcodesByZipcodeResponse,
    UpdateZipcodesByZipcodeParams
  >("zipcodes", "/:zipcode", "PUT", options);
}

// ============================================================================
// Query Keys
// ============================================================================

/**
 * Cache key (or key prefix) of every GET route, by operationId. Pass the
 * params you know; omit them to match every query of the route.
 */
export const queryKeys = {
  getAccountsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("accounts", "/list", params),
  getAccountsUsersByAccountId: (
    params?: Partial<GetAccountsUsersByAccountIdParams>,
  ) => customQueryKey("accounts", "/:accountId/users", params),
  getAccountsPlacesByAccountId: (
    params?: Partial<GetAccountsPlacesByAccountIdParams>,
  ) => customQueryKey("accounts", "/:accountId/places", params),
  getAccountsPaymentMethodsByAccountId: (
    params?: Partial<GetAccountsPaymentMethodsByAccountIdParams>,
  ) => customQueryKey("accounts", "/:accountId/payment-methods", params),
  getAccountsByAccountId: (params?: Partial<GetAccountsByAccountIdParams>) =>
    customQueryKey("accounts", "/:accountId", params),
  getAiFeedbackList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("ai", "/feedback/list", params),
  getAiFeedbackByAiFeedbackId: (
    params?: Partial<GetAiFeedbackByAiFeedbackIdParams>,
  ) => customQueryKey("ai", "/feedback/:aiFeedbackId", params),
  getAiJobsByAiJobId: (params?: Partial<GetAiJobsByAiJobIdParams>) =>
    customQueryKey("ai", "/jobs/:aiJobId", params),
  getAnalyticsMemberActivationRoster: () =>
    customQueryKey("analytics", "/member-activation/roster"),
  getAnalyticsMemberActivationSummary: () =>
    customQueryKey("analytics", "/member-activation/summary"),
  getAnalyticsRenewals: () => customQueryKey("analytics", "/renewals"),
  getAnalyticsRenewalsFirstAnniversaries: () =>
    customQueryKey("analytics", "/renewals/first-anniversaries"),
  getAnalyticsVendorScorecard: () =>
    customQueryKey("analytics", "/vendor-scorecard"),
  getAnalyticsConfirmedChurn: () =>
    customQueryKey("analytics", "/confirmed-churn"),
  getAttachmentsByAttachmentId: (
    params?: Partial<GetAttachmentsByAttachmentIdParams>,
  ) => customQueryKey("attachments", "/:attachmentId", params),
  getAuthMe: () => customQueryKey("auth", "/me"),
  getBillingPaymentMethodsByPaymentMethodId: (
    params?: Partial<GetBillingPaymentMethodsByPaymentMethodIdParams>,
  ) => customQueryKey("billing", "/payment-methods/:paymentMethodId", params),
  getBillingPaymentHistoriesByPaymentId: (
    params?: Partial<GetBillingPaymentHistoriesByPaymentIdParams>,
  ) => customQueryKey("billing", "/payment-histories/:paymentId", params),
  getBillingPaymentMethodsByAccountId: (
    params?: Partial<GetBillingPaymentMethodsByAccountIdParams>,
  ) => customQueryKey("billing", "/:accountId/payment-methods", params),
  getBillingPaymentHistoriesByAccountId: (
    params?: Partial<GetBillingPaymentHistoriesByAccountIdParams>,
  ) => customQueryKey("billing", "/:accountId/payment-histories", params),
  getBillingInvoicesByInvoiceId: (
    params?: Partial<GetBillingInvoicesByInvoiceIdParams>,
  ) => customQueryKey("billing", "/invoices/:invoiceId", params),
  getBillingInvoicesByAccountId: (
    params?: Partial<GetBillingInvoicesByAccountIdParams>,
  ) => customQueryKey("billing", "/:accountId/invoices", params),
  getBillingTodoSections: () => customQueryKey("billing-todo", "/sections"),
  getBirdieAudience: () => customQueryKey("birdie", "/audience"),
  getCampaignsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("campaigns", "/list", params),
  getCampaignsByCampaignId: (
    params?: Partial<GetCampaignsByCampaignIdParams>,
  ) => customQueryKey("campaigns", "/:campaignId", params),
  getCatalogItemsAll: () => customQueryKey("catalog-items", ""),
  getCatalogNewGroupsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("catalog-new", "/groups/list", params),
  getCatalogNewGroupsByGroupId: (
    params?: Partial<GetCatalogNewGroupsByGroupIdParams>,
  ) => customQueryKey("catalog-new", "/groups/:groupId", params),
  getCatalogNewItemsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("catalog-new", "/items/list", params),
  getCatalogNewItemsByCatalogItemId: (
    params?: Partial<GetCatalogNewItemsByCatalogItemIdParams>,
  ) => customQueryKey("catalog-new", "/items/:catalogItemId", params),
  getCatalogNewItemsLineItemsByCatalogItemId: (
    params?: Partial<GetCatalogNewItemsLineItemsByCatalogItemIdParams>,
  ) =>
    customQueryKey("catalog-new", "/items/:catalogItemId/line-items", params),
  getCatalogNewItemsRelationsByCatalogItemId: (
    params?: Partial<GetCatalogNewItemsRelationsByCatalogItemIdParams>,
  ) => customQueryKey("catalog-new", "/items/:catalogItemId/relations", params),
  getCatalogNewMarketRatesList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("catalog-new", "/market-rates/list", params),
  getCatalogNewMarketRatesByMarketRateId: (
    params?: Partial<GetCatalogNewMarketRatesByMarketRateIdParams>,
  ) => customQueryKey("catalog-new", "/market-rates/:marketRateId", params),
  getCategoriesAll: () => customQueryKey("categories", ""),
  getChannelsInbox: (params?: Partial<ListQueryParams>) =>
    listQueryKey("channels", "/inbox", params),
  getChannelsInboxPlaces: (params?: Partial<ListQueryParams>) =>
    listQueryKey("channels", "/inbox/places", params),
  getChannelsInboxCustomers: (params?: Partial<ListQueryParams>) =>
    listQueryKey("channels", "/inbox/customers", params),
  getChannelsInboxCounts: () => customQueryKey("channels", "/inbox/counts"),
  getChannelsByCid: (params?: Partial<GetChannelsByCidParams>) =>
    customQueryKey("channels", "/:cid", params),
  getChannelsMembersByCid: (params?: Partial<GetChannelsMembersByCidParams>) =>
    customQueryKey("channels", "/:cid/members", params),
  getChannelsMessagesByCid: (
    params?: Partial<GetChannelsMessagesByCidParams>,
  ) => customQueryKey("channels", "/:cid/messages", params),
  getChannelsMessagesReadsByCidByMessageId: (
    params?: Partial<GetChannelsMessagesReadsByCidByMessageIdParams>,
  ) => customQueryKey("channels", "/:cid/messages/:messageId/reads", params),
  getChannelsUnreadByCid: (params?: Partial<GetChannelsUnreadByCidParams>) =>
    customQueryKey("channels", "/:cid/unread", params),
  getChannelsPromptBlocksByCid: (
    params?: Partial<GetChannelsPromptBlocksByCidParams>,
  ) => customQueryKey("channels", "/:cid/prompt-blocks", params),
  getCheckoutCouponsByCouponCode: (
    params?: Partial<GetCheckoutCouponsByCouponCodeParams>,
  ) => customQueryKey("checkout", "/coupons/:couponCode", params),
  getCheckoutPurchaseIntents: () =>
    customQueryKey("checkout", "/purchase-intents"),
  getCheckoutPurchaseIntentsByPurchaseIntentId: (
    params?: Partial<GetCheckoutPurchaseIntentsByPurchaseIntentIdParams>,
  ) =>
    customQueryKey("checkout", "/purchase-intents/:purchaseIntentId", params),
  getCheckoutPurchaseIntentsSetupIntentByPurchaseIntentId: (
    params?: Partial<GetCheckoutPurchaseIntentsSetupIntentByPurchaseIntentIdParams>,
  ) =>
    customQueryKey(
      "checkout",
      "/purchase-intents/:purchaseIntentId/setup-intent",
      params,
    ),
  getCheckoutLinksList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("checkout-links", "/list", params),
  getCheckoutLinksByCheckoutLinkId: (
    params?: Partial<GetCheckoutLinksByCheckoutLinkIdParams>,
  ) => customQueryKey("checkout-links", "/:checkoutLinkId", params),
  getCheckoutLinksPlanByCheckoutLinkId: (
    params?: Partial<GetCheckoutLinksPlanByCheckoutLinkIdParams>,
  ) => customQueryKey("checkout-links", "/:checkoutLinkId/plan", params),
  getCommentsByCommentId: (params?: Partial<GetCommentsByCommentIdParams>) =>
    customQueryKey("comments", "/:commentId", params),
  getExpensesList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("expenses", "/list", params),
  getExpensesByExpenseId: (params?: Partial<GetExpensesByExpenseIdParams>) =>
    customQueryKey("expenses", "/:expenseId", params),
  getFieldSchedule: () => customQueryKey("field", "/schedule"),
  getTechnicianCalendarEvents: () => customQueryKey("field", "/events/list"),
  getFieldConversations: (params?: Partial<ListQueryParams>) =>
    listQueryKey("field", "/conversations/list", params),
  getFieldConversationCounts: () =>
    customQueryKey("field", "/conversations/counts"),
  getFieldOrderAttachments: (
    params?: Partial<GetFieldOrderAttachmentsParams>,
  ) => customQueryKey("field", "/orders/:orderId/attachments", params),
  getFieldOrderConversation: (
    params?: Partial<GetFieldOrderConversationParams>,
  ) => customQueryKey("field", "/orders/:orderId/conversation", params),
  getFieldVisitsNotifyMemberPreviewByVisitId: (
    params?: Partial<GetFieldVisitsNotifyMemberPreviewByVisitIdParams>,
  ) =>
    customQueryKey("field", "/visits/:visitId/notify-member/preview", params),
  getFieldVisitReport: (params?: Partial<GetFieldVisitReportParams>) =>
    customQueryKey("field", "/visits/:visitId/report/:reportId", params),
  getFieldVisitDetail: (params?: Partial<GetFieldVisitDetailParams>) =>
    customQueryKey("field", "/visits/:visitId", params),
  getGlobalOffice: () => customQueryKey("global", "/office"),
  getGlobalSpaces: () => customQueryKey("global", "/spaces"),
  getHomecarePlanOrdersProposalByOrderId: (
    params?: Partial<GetHomecarePlanOrdersProposalByOrderIdParams>,
  ) => customQueryKey("homecare-plan", "/orders/:orderId/proposal", params),
  getHomecarePlanProposals: (params?: Partial<ListQueryParams>) =>
    listQueryKey("homecare-plan", "/proposals", params),
  getHomecarePlanProposalsDetailByProposalId: (
    params?: Partial<GetHomecarePlanProposalsDetailByProposalIdParams>,
  ) => customQueryKey("homecare-plan", "/proposals/:proposalId/detail", params),
  getHomecarePlanProposalsByProposalId: (
    params?: Partial<GetHomecarePlanProposalsByProposalIdParams>,
  ) => customQueryKey("homecare-plan", "/proposals/:proposalId", params),
  getImpersonationSearch: () => customQueryKey("impersonation", "/search"),
  getInvoicesList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("invoices", "/list", params),
  getInvoicesSummary: () => customQueryKey("invoices", "/summary"),
  getInvoicesCollectionByInvoiceId: (
    params?: Partial<GetInvoicesCollectionByInvoiceIdParams>,
  ) => customQueryKey("invoices", "/:invoiceId/collection", params),
  getInvoicesDocumentByInvoiceId: (
    params?: Partial<GetInvoicesDocumentByInvoiceIdParams>,
  ) => customQueryKey("invoices", "/:invoiceId/document", params),
  getInvoicesCorrectionsByInvoiceId: (
    params?: Partial<GetInvoicesCorrectionsByInvoiceIdParams>,
  ) => customQueryKey("invoices", "/:invoiceId/corrections", params),
  getInvoicesByInvoiceId: (params?: Partial<GetInvoicesByInvoiceIdParams>) =>
    customQueryKey("invoices", "/:invoiceId", params),
  getLineItemUnitTypesAll: () => customQueryKey("line-item-unit-types", ""),
  getLineItemsByLineItemId: (
    params?: Partial<GetLineItemsByLineItemIdParams>,
  ) => customQueryKey("line-items", "/:lineItemId", params),
  getListItemsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("list-items", "/list", params),
  getListItemsByListItemId: (
    params?: Partial<GetListItemsByListItemIdParams>,
  ) => customQueryKey("list-items", "/:listItemId", params),
  getLocationsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("locations", "/list", params),
  getLocationsByLocationId: (
    params?: Partial<GetLocationsByLocationIdParams>,
  ) => customQueryKey("locations", "/:locationId", params),
  getMeetLinkByName: (params?: Partial<GetMeetLinkByNameParams>) =>
    customQueryKey("meet", "/links/by-name/:roomName", params),
  getMeetParticipantsByRoomName: (
    params?: Partial<GetMeetParticipantsByRoomNameParams>,
  ) => customQueryKey("meet", "/:roomName/participants", params),
  getMembersPlaces: () => customQueryKey("members", "/places"),
  getMembersVisits: () => customQueryKey("members", "/visits"),
  getMembersPayments: () => customQueryKey("members", "/payments"),
  getMembersAccounts: () => customQueryKey("members", "/accounts"),
  getMembersSearch: () => customQueryKey("members", "/search"),
  getMembersCampaigns: () => customQueryKey("members", "/campaigns"),
  getMembersAttachmentsByAttachmentId: (
    params?: Partial<GetMembersAttachmentsByAttachmentIdParams>,
  ) => customQueryKey("members", "/attachments/:attachmentId", params),
  getMembersBillingAlert: () => customQueryKey("members", "/billing-alert"),
  getMembersInsight: () => customQueryKey("members", "/insight"),
  getMembersPlacesNestSummaryByPlaceId: (
    params?: Partial<GetMembersPlacesNestSummaryByPlaceIdParams>,
  ) => customQueryKey("members", "/places/:placeId/nest/summary", params),
  getMembersPlacesNestComponentsByPlaceId: (
    params?: Partial<GetMembersPlacesNestComponentsByPlaceIdParams>,
  ) => customQueryKey("members", "/places/:placeId/nest/components", params),
  getMembersPlacesNestComponentsByPlaceIdByNodeKey: (
    params?: Partial<GetMembersPlacesNestComponentsByPlaceIdByNodeKeyParams>,
  ) =>
    customQueryKey(
      "members",
      "/places/:placeId/nest/components/:nodeKey",
      params,
    ),
  getMembersPlacesByPlaceId: (
    params?: Partial<GetMembersPlacesByPlaceIdParams>,
  ) => customQueryKey("members", "/places/:placeId", params),
  getMembersOrders: (params?: Partial<ListQueryParams>) =>
    listQueryKey("members", "/orders", params),
  getMembersOrdersByOrderId: (
    params?: Partial<GetMembersOrdersByOrderIdParams>,
  ) => customQueryKey("members", "/orders/:orderId", params),
  getMembersQuotesByQuoteId: (
    params?: Partial<GetMembersQuotesByQuoteIdParams>,
  ) => customQueryKey("members", "/quotes/:quoteId", params),
  getMessagesByMessageId: (params?: Partial<GetMessagesByMessageIdParams>) =>
    customQueryKey("messages", "/:messageId", params),
  getNotesDocByNotableTypeByNotableId: (
    params?: Partial<GetNotesDocByNotableTypeByNotableIdParams>,
  ) => customQueryKey("notes", "/doc/:notableType/:notableId", params),
  getNotificationsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("notifications", "/list", params),
  getNotificationsLatest: () => customQueryKey("notifications", "/latest"),
  getNotificationsCounts: () => customQueryKey("notifications", "/counts"),
  getNotificationsDeliveriesList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("notifications", "/deliveries/list", params),
  getNotificationsByNotificationId: (
    params?: Partial<GetNotificationsByNotificationIdParams>,
  ) => customQueryKey("notifications", "/:notificationId", params),
  getNotificationsDeliveriesByNotificationId: (
    params?: Partial<GetNotificationsDeliveriesByNotificationIdParams>,
  ) => customQueryKey("notifications", "/:notificationId/deliveries", params),
  getOnboardingsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("onboardings", "/list", params),
  getOnboardingsStages: () => customQueryKey("onboardings", "/stages"),
  getOnboardingsWidgetByOnboardingId: (
    params?: Partial<GetOnboardingsWidgetByOnboardingIdParams>,
  ) => customQueryKey("onboardings", "/:onboardingId/widget", params),
  getOnboardingsByOnboardingId: (
    params?: Partial<GetOnboardingsByOnboardingIdParams>,
  ) => customQueryKey("onboardings", "/:onboardingId", params),
  getOrderQuotesCounts: () => customQueryKey("order-quotes", "/counts"),
  getOrderQuotesList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("order-quotes", "/list", params),
  getOrderQuotesLegacyScopePreviewByOrderId: (
    params?: Partial<GetOrderQuotesLegacyScopePreviewByOrderIdParams>,
  ) => customQueryKey("order-quotes", "/legacy-scope/:orderId/preview", params),
  getOrderQuotesLegacyScopeMigration: () =>
    customQueryKey("order-quotes", "/legacy-scope/migration"),
  getOrderQuotesLegacyScopeMigrationPlanByOrderId: (
    params?: Partial<GetOrderQuotesLegacyScopeMigrationPlanByOrderIdParams>,
  ) =>
    customQueryKey(
      "order-quotes",
      "/legacy-scope/:orderId/migration-plan",
      params,
    ),
  getOrderQuotesByQuoteId: (params?: Partial<GetOrderQuotesByQuoteIdParams>) =>
    customQueryKey("order-quotes", "/:quoteId", params),
  getOrderQuotesDepositByQuoteId: (
    params?: Partial<GetOrderQuotesDepositByQuoteIdParams>,
  ) => customQueryKey("order-quotes", "/:quoteId/deposit", params),
  getOrderRequestsStatuses: () => customQueryKey("order-requests", "/statuses"),
  getOrderRequestsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("order-requests", "/list", params),
  getOrderRequestsGroupCounts: () =>
    customQueryKey("order-requests", "/group-counts"),
  getOrderRequestsItemsTitleSuggestions: () =>
    customQueryKey("order-requests", "/items/title-suggestions"),
  getOrderRequestsItemsSuggestByOrderRequestId: (
    params?: Partial<GetOrderRequestsItemsSuggestByOrderRequestIdParams>,
  ) =>
    customQueryKey("order-requests", "/:orderRequestId/items/suggest", params),
  getOrderRequestsActivitiesByOrderRequestId: (
    params?: Partial<GetOrderRequestsActivitiesByOrderRequestIdParams>,
  ) => customQueryKey("order-requests", "/:orderRequestId/activities", params),
  getOrderRequestsTimeInStatusByOrderRequestId: (
    params?: Partial<GetOrderRequestsTimeInStatusByOrderRequestIdParams>,
  ) =>
    customQueryKey("order-requests", "/:orderRequestId/time-in-status", params),
  getOrderRequestsSubscribersByOrderRequestId: (
    params?: Partial<GetOrderRequestsSubscribersByOrderRequestIdParams>,
  ) => customQueryKey("order-requests", "/:orderRequestId/subscribers", params),
  getOrderRequestsByOrderRequestId: (
    params?: Partial<GetOrderRequestsByOrderRequestIdParams>,
  ) => customQueryKey("order-requests", "/:orderRequestId", params),
  getOrdersStatuses: () => customQueryKey("orders", "/statuses"),
  getOrdersFeedbackList: () => customQueryKey("orders", "/feedback/list"),
  getOrdersFeedbackTags: () => customQueryKey("orders", "/feedback/tags"),
  getOrdersFeedbackByFeedbackId: (
    params?: Partial<GetOrdersFeedbackByFeedbackIdParams>,
  ) => customQueryKey("orders", "/feedback/:feedbackId", params),
  getOrdersScopeByOrderId: (params?: Partial<GetOrdersScopeByOrderIdParams>) =>
    customQueryKey("orders", "/:orderId/scope", params),
  getOrdersPublicByOrderId: (
    params?: Partial<GetOrdersPublicByOrderIdParams>,
  ) => customQueryKey("orders", "/public/:orderId", params),
  getOrdersLastedTimePreferencesByOrderId: (
    params?: Partial<GetOrdersLastedTimePreferencesByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/lasted-time-preferences", params),
  getOrdersProfitByOrderId: (
    params?: Partial<GetOrdersProfitByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/profit", params),
  getOrdersRevenuesByOrderId: (
    params?: Partial<GetOrdersRevenuesByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/revenues", params),
  getOrdersExpensesByOrderId: (
    params?: Partial<GetOrdersExpensesByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/expenses", params),
  getOrdersTimeInStatusByOrderId: (
    params?: Partial<GetOrdersTimeInStatusByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/time-in-status", params),
  getOrdersActivitiesByOrderId: (
    params?: Partial<GetOrdersActivitiesByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/activities", params),
  getOrdersAttachmentsByOrderId: (
    params?: Partial<GetOrdersAttachmentsByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/attachments", params),
  getOrdersToneByOrderId: (params?: Partial<GetOrdersToneByOrderIdParams>) =>
    customQueryKey("orders", "/:orderId/tone", params),
  getOrdersConversationSummaryByOrderId: (
    params?: Partial<GetOrdersConversationSummaryByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/conversation-summary", params),
  getOrdersAiSummaryByOrderId: (
    params?: Partial<GetOrdersAiSummaryByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/ai-summary", params),
  getOrdersBirdieTipsByOrderId: (
    params?: Partial<GetOrdersBirdieTipsByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/birdie-tips", params),
  getOrdersLinkedOrdersByOrderId: (
    params?: Partial<GetOrdersLinkedOrdersByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/linked-orders", params),
  getOrdersHomecarePlanOrdersByOrderId: (
    params?: Partial<GetOrdersHomecarePlanOrdersByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/homecare-plan-orders", params),
  getOrdersOrderMonthList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("orders", "/order-month/list", params),
  getOrdersList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("orders", "/list", params),
  getOrdersDepositsByOrderId: (
    params?: Partial<GetOrdersDepositsByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/deposits", params),
  getOrdersInvoicesAndPaymentsByOrderId: (
    params?: Partial<GetOrdersInvoicesAndPaymentsByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/invoices-and-payments", params),
  getOrdersCustomerAccountsByOrderId: (
    params?: Partial<GetOrdersCustomerAccountsByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/customer-accounts", params),
  getOrdersBrexBillsByOrderId: (
    params?: Partial<GetOrdersBrexBillsByOrderIdParams>,
  ) => customQueryKey("orders", "/:orderId/brex-bills", params),
  getOrdersByOrderId: (params?: Partial<GetOrdersByOrderIdParams>) =>
    customQueryKey("orders", "/:orderId", params),
  getPayLinksByToken: (params?: Partial<GetPayLinksByTokenParams>) =>
    customQueryKey("pay-links", "/:token", params),
  getPlacesOrderPlansKeysByPlaceIdByOrderPlanKey: (
    params?: Partial<GetPlacesOrderPlansKeysByPlaceIdByOrderPlanKeyParams>,
  ) =>
    customQueryKey(
      "places",
      "/:placeId/order-plans/keys/:orderPlanKey",
      params,
    ),
  getPlacesCheckByPlaceId: (params?: Partial<GetPlacesCheckByPlaceIdParams>) =>
    customQueryKey("places", "/:placeId/check", params),
  getPlacesList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("places", "/list", params),
  getPlacesByPlaceId: (params?: Partial<GetPlacesByPlaceIdParams>) =>
    customQueryKey("places", "/:placeId", params),
  getPlacesNestByPlaceId: (params?: Partial<GetPlacesNestByPlaceIdParams>) =>
    customQueryKey("places", "/:placeId/nest", params),
  getPlacesNestSummaryByPlaceId: (
    params?: Partial<GetPlacesNestSummaryByPlaceIdParams>,
  ) => customQueryKey("places", "/:placeId/nest/summary", params),
  getPlacesNestPartsByPlaceId: (
    params?: Partial<GetPlacesNestPartsByPlaceIdParams>,
  ) => customQueryKey("places", "/:placeId/nest/parts", params),
  getPlacesAttachmentsByPlaceId: (
    params?: Partial<GetPlacesAttachmentsByPlaceIdParams>,
  ) => customQueryKey("places", "/:placeId/attachments", params),
  getPolicyPermissions: () => customQueryKey("policy", "/permissions"),
  getPolicyRoles: () => customQueryKey("policy", "/roles"),
  getPolicyRolesByRoleKey: (params?: Partial<GetPolicyRolesByRoleKeyParams>) =>
    customQueryKey("policy", "/roles/:roleKey", params),
  getPolicyUsersByUserId: (params?: Partial<GetPolicyUsersByUserIdParams>) =>
    customQueryKey("policy", "/users/:userId", params),
  getProductsAll: () => customQueryKey("products", ""),
  getProductsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("products", "/list", params),
  getProductsByProductId: (params?: Partial<GetProductsByProductIdParams>) =>
    customQueryKey("products", "/:productId", params),
  getPurchaseIntentsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("purchase-intents", "/list", params),
  getPurchaseIntentsByPurchaseIntentId: (
    params?: Partial<GetPurchaseIntentsByPurchaseIntentIdParams>,
  ) => customQueryKey("purchase-intents", "/:purchaseIntentId", params),
  getReportOrderOverviewList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("report", "/order-overview/list", params),
  getReportOrderOverviewSummary: () =>
    customQueryKey("report", "/order-overview/summary"),
  getReportOrderOverviewHistoryByOrderId: (
    params?: Partial<GetReportOrderOverviewHistoryByOrderIdParams>,
  ) => customQueryKey("report", "/order-overview/history/:orderId", params),
  getReportMrrMovement: () => customQueryKey("report", "/mrr-movement"),
  getReportMrrGrowth: () => customQueryKey("report", "/mrr-growth"),
  getReportMrrMovers: () => customQueryKey("report", "/mrr-movers"),
  getReportMrrAtRisk: () => customQueryKey("report", "/mrr-at-risk"),
  getReportMrrChurnReasons: () =>
    customQueryKey("report", "/mrr-churn-reasons"),
  getReportMrrLedgerList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("report", "/mrr-ledger/list", params),
  getReportMrrSnapshot: () => customQueryKey("report", "/mrr-snapshot"),
  getRevenueMonthsReport: () => customQueryKey("revenue-months", "/report"),
  getRevenueMonthsCloseChecksByMonth: (
    params?: Partial<GetRevenueMonthsCloseChecksByMonthParams>,
  ) => customQueryKey("revenue-months", "/:month/close-checks", params),
  getRevenueMonthsPackageByMonth: (
    params?: Partial<GetRevenueMonthsPackageByMonthParams>,
  ) => customQueryKey("revenue-months", "/:month/package", params),
  getSchedulesList: () => customQueryKey("schedules", "/list"),
  getScheduleEventDetail: (params?: Partial<GetScheduleEventDetailParams>) =>
    customQueryKey("schedules", "/events/:scheduleEventId", params),
  getScheduleGoogleEventDetail: (
    params?: Partial<GetScheduleGoogleEventDetailParams>,
  ) =>
    customQueryKey(
      "schedules",
      "/google-events/:googleCalendarEventId",
      params,
    ),
  getScopesByOrderScopeId: (params?: Partial<GetScopesByOrderScopeIdParams>) =>
    customQueryKey("scopes", "/:orderScopeId", params),
  getSearchGlobal: () => customQueryKey("search", "/global"),
  getSmartActionsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("smart-actions", "/list", params),
  getSmartActionsSummary: () => customQueryKey("smart-actions", "/summary"),
  getSmartActionsForecast: () => customQueryKey("smart-actions", "/forecast"),
  getSmartActionsAccuracy: () => customQueryKey("smart-actions", "/accuracy"),
  getSmartActionsLostCosts: () =>
    customQueryKey("smart-actions", "/lost-costs"),
  getSmartActionsOrderReviewByOrderId: (
    params?: Partial<GetSmartActionsOrderReviewByOrderIdParams>,
  ) => customQueryKey("smart-actions", "/order-review/:orderId", params),
  getSmartActionsBySmartActionId: (
    params?: Partial<GetSmartActionsBySmartActionIdParams>,
  ) => customQueryKey("smart-actions", "/:smartActionId", params),
  getSpacesBySpaceId: (params?: Partial<GetSpacesBySpaceIdParams>) =>
    customQueryKey("spaces", "/:spaceId", params),
  getStatusAll: () => customQueryKey("status", ""),
  getSubscriptionsPlans: () => customQueryKey("subscriptions", "/plans"),
  getSubscriptionsPlansByPlanId: (
    params?: Partial<GetSubscriptionsPlansByPlanIdParams>,
  ) => customQueryKey("subscriptions", "/plans/:planId", params),
  getSubscriptionsStatuses: () => customQueryKey("subscriptions", "/statuses"),
  getSubscriptionsProducts: () => customQueryKey("subscriptions", "/products"),
  getSubscriptionsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("subscriptions", "/list", params),
  getSubscriptionsMyBySubscriptionId: (
    params?: Partial<GetSubscriptionsMyBySubscriptionIdParams>,
  ) => customQueryKey("subscriptions", "/my/:subscriptionId", params),
  getSubscriptionsTimelineBySubscriptionId: (
    params?: Partial<GetSubscriptionsTimelineBySubscriptionIdParams>,
  ) => customQueryKey("subscriptions", "/:subscriptionId/timeline", params),
  getSubscriptionsItemsHistoryBySubscriptionId: (
    params?: Partial<GetSubscriptionsItemsHistoryBySubscriptionIdParams>,
  ) =>
    customQueryKey("subscriptions", "/:subscriptionId/items/history", params),
  getSubscriptionsBySubscriptionId: (
    params?: Partial<GetSubscriptionsBySubscriptionIdParams>,
  ) => customQueryKey("subscriptions", "/:subscriptionId", params),
  getTagsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("tags", "/list", params),
  getTasksList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("tasks", "/list", params),
  getTasksGroups: () => customQueryKey("tasks", "/groups"),
  getTasksByTaskId: (params?: Partial<GetTasksByTaskIdParams>) =>
    customQueryKey("tasks", "/:taskId", params),
  getTimeEntriesList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("time-entries", "/list", params),
  getTimePreferencesByTimePreferenceId: (
    params?: Partial<GetTimePreferencesByTimePreferenceIdParams>,
  ) => customQueryKey("time-preferences", "/:timePreferenceId", params),
  getTimeProposalsByTimeProposalId: (
    params?: Partial<GetTimeProposalsByTimeProposalIdParams>,
  ) => customQueryKey("time-proposals", "/:timeProposalId", params),
  getUsersInvitesPlacesByPlaceId: (
    params?: Partial<GetUsersInvitesPlacesByPlaceIdParams>,
  ) => customQueryKey("users", "/invites/places/:placeId", params),
  getUsersInvitesPlacesMembersByPlaceId: (
    params?: Partial<GetUsersInvitesPlacesMembersByPlaceIdParams>,
  ) => customQueryKey("users", "/invites/places/:placeId/members", params),
  getUsersInvitesByToken: (params?: Partial<GetUsersInvitesByTokenParams>) =>
    customQueryKey("users", "/invites/:token", params),
  getUsersMeNotificationPreferences: () =>
    customQueryKey("users", "/me/notification-preferences"),
  getUsersList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("users", "/list", params),
  getUsersAccountsByUserId: (
    params?: Partial<GetUsersAccountsByUserIdParams>,
  ) => customQueryKey("users", "/:userId/accounts", params),
  getUsersProfilesByUserId: (
    params?: Partial<GetUsersProfilesByUserIdParams>,
  ) => customQueryKey("users", "/:userId/profiles", params),
  getUsersPlacesByUserId: (params?: Partial<GetUsersPlacesByUserIdParams>) =>
    customQueryKey("users", "/:userId/places", params),
  getUsersOnlineByUserId: (params?: Partial<GetUsersOnlineByUserIdParams>) =>
    customQueryKey("users", "/:userId/online", params),
  getUsersByUserId: (params?: Partial<GetUsersByUserIdParams>) =>
    customQueryKey("users", "/:userId", params),
  getVendorsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("vendors", "/list", params),
  getVendorsByVendorId: (params?: Partial<GetVendorsByVendorIdParams>) =>
    customQueryKey("vendors", "/:vendorId", params),
  getViewsList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("views", "/list", params),
  getViewsDefaults: () => customQueryKey("views", "/defaults"),
  getVisitLinksByLinkCode: (params?: Partial<GetVisitLinksByLinkCodeParams>) =>
    customQueryKey("visit-links", "/:linkCode", params),
  getVisitMonitorList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("visit-monitor", "/list", params),
  getVisitMonitorSmsDraftByVisitId: (
    params?: Partial<GetVisitMonitorSmsDraftByVisitIdParams>,
  ) => customQueryKey("visit-monitor", "/:visitId/sms-draft", params),
  getVisitMonitorLinkPreviewByVisitId: (
    params?: Partial<GetVisitMonitorLinkPreviewByVisitIdParams>,
  ) => customQueryKey("visit-monitor", "/:visitId/link-preview", params),
  getVisitsAll: () => customQueryKey("visits", ""),
  getVisitsTechniciansByVisitId: (
    params?: Partial<GetVisitsTechniciansByVisitIdParams>,
  ) => customQueryKey("visits", "/:visitId/technicians", params),
  getVisitsByVisitId: (params?: Partial<GetVisitsByVisitIdParams>) =>
    customQueryKey("visits", "/:visitId", params),
  getVisitsCount: () => customQueryKey("visits", "/count"),
  getVisitsAvailableTimes: () => customQueryKey("visits", "/available-times"),
  getVisitsOfficeReportByVisitId: (
    params?: Partial<GetVisitsOfficeReportByVisitIdParams>,
  ) => customQueryKey("visits", "/office/:visitId/report", params),
  getVisitsFieldReportByVisitId: (
    params?: Partial<GetVisitsFieldReportByVisitIdParams>,
  ) => customQueryKey("visits", "/field/:visitId/report", params),
  getVisitsOfficeExpenseByVisitId: (
    params?: Partial<GetVisitsOfficeExpenseByVisitIdParams>,
  ) => customQueryKey("visits", "/office/:visitId/expense", params),
  getVisitsInstructionOriginByVisitId: (
    params?: Partial<GetVisitsInstructionOriginByVisitIdParams>,
  ) => customQueryKey("visits", "/:visitId/instruction-origin", params),
  getVisitsServiceTeamByVisitId: (
    params?: Partial<GetVisitsServiceTeamByVisitIdParams>,
  ) => customQueryKey("visits", "/:visitId/service-team", params),
  getVisitsAttachmentsByVisitId: (
    params?: Partial<GetVisitsAttachmentsByVisitIdParams>,
  ) => customQueryKey("visits", "/:visitId/attachments", params),
  getWalletsTransactionHistoriesByLedgerId: (
    params?: Partial<GetWalletsTransactionHistoriesByLedgerIdParams>,
  ) => customQueryKey("wallets", "/transaction-histories/:ledgerId", params),
  getWalletsAccountCreditByAccountId: (
    params?: Partial<GetWalletsAccountCreditByAccountIdParams>,
  ) => customQueryKey("wallets", "/:accountId/account-credit", params),
  getWalletsByAccountId: (params?: Partial<GetWalletsByAccountIdParams>) =>
    customQueryKey("wallets", "/:accountId", params),
  getWalletsTransactionHistoriesByAccountId: (
    params?: Partial<GetWalletsTransactionHistoriesByAccountIdParams>,
  ) => customQueryKey("wallets", "/:accountId/transaction-histories", params),
  getZipcodesList: (params?: Partial<ListQueryParams>) =>
    listQueryKey("zipcodes", "/list", params),
  getZipcodesCities: () => customQueryKey("zipcodes", "/cities"),
  getZipcodesByZipcode: (params?: Partial<GetZipcodesByZipcodeParams>) =>
    customQueryKey("zipcodes", "/:zipcode", params),
} as const;
